import * as React from 'react';
import { withRouter } from "react-router-dom";
import RouterComponent from '../Utility/RouterComponent';
import {
  localGetItem, localClearAll, clearAllCachevalue, localClearItem,
  clearCachevalue, localSetItem, setCachevalue, getCachevalue
} from '../Utility/Services/CacheProviderService';
import { withTranslation } from 'react-i18next';
import { Serviceurls } from '../Utility/API/Serviceurls';
import '../Styles/CommonTableStyles.css';
import MuiAppBar from '@mui/material/AppBar';
import RestAPIService, { APP_Support_Label, APP_Version_Label } from '../Utility/Services/RestAPIService';
import {
  Autocomplete, Avatar, Badge, Box, Button, Checkbox, CircularProgress,
  CssBaseline, Dialog, Divider, Drawer, FormControl, FormControlLabel, FormGroup, Grid,
  IconButton, InputAdornment, InputLabel, List, ListItem, ListItemIcon, Menu,
  MenuItem, Modal, OutlinedInput, Paper, Select, styled, Tab, Tabs, TextField,
  Toolbar, Tooltip, Typography, Table, TableHead, TableRow, TableCell,
  TableContainer, TableBody,
} from '@mui/material';
import { Colors } from '../Styles/Colors';
import './NavbarApp.css';
import { ImagePaths } from '../Utility/ImagePaths';
import GridViewIcon from '@mui/icons-material/GridView';
import { NewSideMenu } from '../Utility/SideMenuList';
import PatientHeaderSearch from '../Components/Common Components/PatientHeaderSearch';
import { CommonPatientDetails, renderPatientCard } from '../Components/Common Components/CommonComponents';
import {
  formatDate, GetInvestigationName, renderBadge, AmountFormat, formatDateAndTimeMeth2
} from '../Components/CommonFunctions/CommonFunctions';
import CommonValidation from '../Components/CommonFunctions/CommonValidation';
import DrQueuePopup from './MenuComponents/DrQueuePopup';
import { City, Country, State } from 'country-state-city';
import { DatePicker, DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DataGrid } from '@mui/x-data-grid';
import { DateTime } from 'luxon';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Edit, HelpOutline } from '@mui/icons-material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import ToastMsg from '../Components/ToastMsg/ToastMsg';
import CloseIcon from '@mui/icons-material/Close';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import { appointment_Status_other, modulePaths, cashmodulePaths, cashCounterRoute, DOC_PRINT_DEFAULT } from '../Utility/Constants';
import ReceiptIcon from "@mui/icons-material/Receipt";
import LabHistoryPopup from "./MenuComponents/LabHistoryPopup";
import ApproverListPopup from "./MenuComponents/ApproverListPopup";
import NotificationPopup from './MenuComponents/NotificationPopup';
import moment from 'moment';
import PharmacySavedBills from './MenuComponents/PharmaSavedBills';
import IPRequest from '../Modules/Pharmacy/HeaderComponents/IPRequest';
import IPReturns from '../Modules/Pharmacy/HeaderComponents/IPReturns';
import Appointments from '../Modules/Pharmacy/HeaderComponents/Appointments';
import Prescription from '../Modules/Pharmacy/PharmacyHome/HeaderComponents/Prescription';
import OpToIpPopup from './MenuComponents/OpToIpPopup';
import CashCounterIPList from '../Modules/FrontOffice/Billing/CashCounterIPList';

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: '20vw',
    width: `calc(100% - 20vw)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const bookedThroughObj = {
  "Mobile": { title: "MobileAppointment", icon: ImagePaths.Phone.default },
  "FO": { title: "TelephonicAppointment", icon: ImagePaths.Telephonic.default },
  "Web": { title: "WebAppointment", icon: ImagePaths.Web.default }
}

const module_typeObj = {
  "front_office": "fo",
  "Laboratory": "lab",
  "nurse": "nurse",
  "Doctor": "doctor",
  "Pharmacy": "pharmacy",
}

const loginTypeMap = {
  master_record_department: "Master Record Department",
  ot_management: "Operation Theatre",
  asset_management: "Asset Management",
  front_office: "Front Office"
};


class MiniDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.webcamRef = React.createRef();
    this.state = {
      loggedInuserInfo: JSON.parse(localGetItem("loggedInUserInfo")),
      isLoader: false,
      isFrontCamera: true,
      facingMode: 'user',
      devices: [],
      disableBtn: false,

      error: false,
      errorFathhus: false,
      labHistoryData: [],
      labHistoryPopup: false,
      labPatientData: null,
      page: 0,
      pageSize: 10,
      viewCultureData: [],
      isViewHistory: false,
      IdleAlertPopup: false,
      OcularResponse: false,
      common_uhid: false,
      rowsPerPage: 5,
      page: 0,
      badgeCount: {},
      smsAlert: false,
      FoNotifyList: {},
      notifyPopup: false,
      whatsappAlert: false,
      insuToolOpen: true,
      isNotifyLoader: false,
      notifyTabIndex: "0",
      notifyCount: 0,
      pathName: "",
      SearchedPatientList: [],
      SelectedDoctor: 0,
      PatientNameSearchKey: "",
      PatientAddressKey: "",
      PatientFathHusKey: "",
      PatientMotherKey: "",
      SelectedIPDoctor: 0,
      FilterDob: null,
      FilterUHID: "",
      FilterIP: "",
      FilterOP: "",
      SearchedRequestPatientList: [],
      SelectedRequestPatient: {},
      RequestPatientMenuPop: false,
      PatientSearchClicked: false,
      AddressFilterClicked: false,
      FaceRecogClicked: false,
      disableProcess: false,
      docFaceRecogClicked: false,
      isPatientisSearching: false,
      FoRequestList: [],
      RequestPopUp: false,
      POVList: [],
      patientSearch: "",
      address_2: "",
      address_1: "",
      city: "",
      cityName: City.getCitiesOfState("IN", "TN"),
      country_code: 'IN',
      state_code: 'TN',
      AllCountry: Country.getAllCountries(),
      AllStates: State.getStatesOfCountry("IN"),
      pin_code: "",
      RequestSelectedDocID: null,
      RequestSelectedSpecID: null,
      RequestPatientName: "",
      RequestPatientAge: "",
      RequestPatientDOB: null,
      RequestPatientGender: "",
      RequestAppointDatetym: new Date(),
      RequestpurposeOfVisit: "",
      RequestMobileNumber: "",
      doctorList: [],
      filteredDocList: [],
      RequestPatientListAnchor: null,
      isClked: false,
      editPatientId: null,
      editAppointmentId: null,
      SelectedRequestTab: "appointment_request",

      QrEntryList: [],
      QRPatientName: "",
      filterDate: new Date(),
      datePicker: new Date(),
      RegistrationDate: new Date(),
      docRequestMobileNumber: "",
      docSelectedRequestPatient: {},
      docRequestSelectedDocID: null,
      docRequestSelectedSpecID: null,
      docRequestPatientAge: "",
      docRequestPatientName: "",
      docRequestPatientDOB: null,
      docRequestPatientGender: "",
      docRequestpurposeOfVisit: "",
      docDatePicker: new Date(),
      docRequestAppointDatetym: new Date(),
      doceditAppointmentId: null,
      doceditPatientId: null,
      docisClked: false,
      drQueueData: [],

      // Doctor Module Headers
      ClinicList: [],
      SearchDoctorPatientList: [],
      SelectedDoctorClinic: '',
      unlockDocDataCount: 0,
      TransAppoint: false,
      unlockNotespopup: false,
      unlockDocData: [],
      transferReqData: [],
      openDoctorPrint: false,
      openDoctorAppointment: false,
      openDoctorNotesPrintAnchor: null,
      openDoctorNotesPrint: false,
      doctorAppointmentDate: new Date(),
      doctorAppointmentAnchor: null,
      doctorAppointmentData: [],
      unlockDate: "",
      docSelectedRequestTab: "appointment_request",
      all: true,
      booked: true,
      arrived: true,
      withNurse: true,
      withDoctor: true,
      completed: true,
      cancelled: true,

      // New Print States In Doctor Notes
      doctorPrintList: {},
      dupDocPrintList: '{}',
      printLoad: false,
      opDraftList: [],
      ipTraLoad: false,
      ipTransAnchor: null,
      isIPTrans: false,
      cash_IpList: false,
      CashCounterRefundRequestList: [],
      LabPatientSearch: false,
      openApproverList: false,
      approverLoad: false,
      radAppointmentDate: new Date(),
      approverList: [],
      DoctorsList: [],
      dupApproverList: "",
      opDraftDate: new Date(),
      clinicId: null,
      ph_SavedBill: false,
      ph_returns: false,
      ph_Prescrition: false,
      ph_request: false,
      ph_Appointments: false,
      ph_IpPatientList: false,
      opDraftPage: 0,
      opDraftPageSize: 10,

      // move to op to ip
      oPRequestPopUp: false,
    }
    setCachevalue(0, "SelectedDoctorID")
    setCachevalue(0, "SelectedIPDoctorID")
    this.IdleTimer = null;
    this.resetIdleTimer = this.resetIdleTimer.bind(this);
    this.PaitentCall = null;
    // this.AutoLogOutOnIdle = this.AutoLogOutOnIdle.bind(this);
  }
  /* Login UserName Api Function start  */

  componentDidMount() {
    // this.getConnectedDevices()
    this.startTimer()
    this.setState({ pathName: window?.location?.pathname || "" });

    window.addEventListener('mousemove', this.resetIdleTimer);
    window.addEventListener('mousedown', this.resetIdleTimer);
    window.addEventListener('touchstart', this.resetIdleTimer);
    window.addEventListener('touchmove', this.resetIdleTimer);
    window.addEventListener('click', this.resetIdleTimer);
    window.addEventListener('keydown', this.resetIdleTimer);
    window.addEventListener('scroll', this.resetIdleTimer, true);
    if (window.location.pathname === "/") {
      this.logout()
    }
    if (localGetItem("isLoggedIn")) {

      if (window.location.pathname === "/") {
        this.logout()
      }
      setTimeout(() => {
        this.setState({ insuToolOpen: undefined });
      }, 2000);
      let smsAlert = JSON.parse(localGetItem("show_sms_alert"))
      let whatsappAlert = JSON.parse(localGetItem("show_whatsapp_alert"))
      var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
      let isfaceRecognizationEnabled = JSON.parse(localGetItem("is_enable_face_data")) ? true : false
      var UserData = myUser
      let specialization = UserData?.specialization_name
      this.setState({
        loginName: UserData?.display_name,
        loginType: UserData?.module_name,
        isfaceRecognizationEnabled: isfaceRecognizationEnabled,
        loggedInuserInfo: JSON.parse(localGetItem("loggedInUserInfo")),
        logedUsername: localGetItem("LogedUserName"),
        doctorAppointmentDate: localGetItem('DoctorAppointmentDate'),
        doctorClinicId: localGetItem('SelectedDoctorClinicId'),
        SelectedDoctorClinic: localGetItem('SelectedDoctorClinicId') ? localGetItem('SelectedDoctorClinicId') : "",
        vitals: false,
        DoctorsList: localGetItem("DoctorsList") ? JSON.parse(localGetItem("DoctorsList")) : [],
        smsAlert: smsAlert ? smsAlert : false,
        whatsappAlert: whatsappAlert ? whatsappAlert : false,
        specialization: specialization
      })
    }
    const path = window.location.pathname;
    const investgationName = GetInvestigationName();
    const notifyPaths = new Set([
      "/OPHome", "/IPHome", "/PharmacyBilling",
      "/MainHome", "/MainHome/TestReport", "/Results",
      "/MainHome/ForTechnicians", "/MainHome/OutsourceList",
      "/MainHome/Order/CreateOrder", `/${investgationName}Home`]);
    const homePaths = new Set(["/DoctorHome", "/OPHome", "/PharmacyBilling", `/${investgationName}Home`, "/MainHome"]);

    const badgeCountPaths = new Set(["/MainHome", "/IPHome", "/Billing", "/Billing/LabBilling",
      "/HospitalBilling", "/HospitalBilling/HospitalBilling", "/LabBilling",
      "/LabBilling/HospitalBilling", "LabBilling/CashCounter", `/${investgationName}Billing`,
      `/${investgationName}Billing/HospitalBilling`, `/${investgationName}Home`,
      "/DoctorBilling", "/DoctorBilling/DoctorBilling"]);

    const callOpList = new Set(["/MainHome", '/HospitalBilling',
      '/HospitalBilling/HospitalBilling',
      '/LabBilling', '/LabBilling/HospitalBilling',
      '/PharmacyBilling/CashCounter', `/${investgationName}Billing`,
      `/${investgationName}Billing/HospitalBilling`, `/${investgationName}Home`]);

    if ((this.state.labType === "Inhouse Laboratory") && (window.location.pathname === "/MainHome")) {
      this.getClinicdata()
    }

    if (badgeCountPaths.has(path)) {
      this.getBadgeCount()
    }
    if (((path === "/OPHome") || (path === `/${investgationName}Home`)) && localGetItem("PurposeOfVisit") === null) {
      this.getPurposeOfVisitList()
    }
    if ((path === "/OPHome")) {
      this.getAppointRequests()
      this.getQREntryList()
      this.getBadgeCount()
      if (myUser?.module_name !== "nurse") {
        this.getNotificationData()
      }
      if (myUser?.is_qms_enabled) {
        this.getDoctorQueueData()
        this.WebSocketConnention()
      }
    }
    if ((path === "/OPHome") || (path === "/DoctorHome")) {
      if (myUser?.is_qms_enabled) { this.FoCallPatientConnect() }
    }
    if ((path === "/OPHome") && localGetItem("ipComplaintsDataList") === null) {
      this.getIPcomlaintsdata()
    }
    if (homePaths.has(path) && (localGetItem("noShowStatus") === null || localGetItem("Allow_Pharma_CreditBill_In_FO") === null || localGetItem("Show_Pharmacy_Bills_In_FO") === null)) {
      this.GetCustomConfig()
    }
    if (notifyPaths?.has(path) && JSON.parse(localGetItem('set_due_date_for_credit_billing')) !== null) {
      this.getNotificationData();
    }
    if (path === '/DoctorHome/DoctorNotes' && (this.state.loggedInuserInfo?.module_name === "Doctor" || this.state.loggedInuserInfo?.clinic_staff)) {
      this.getDoctorNotesPrintTemplate()
    }
    if ((path === "/DoctorHome") && !UserData?.clinic_staff) {
      if (this.state.loggedInuserInfo?.module_name === "Doctor") {
        this.getDoctorClinicData()
        this.getTransferAppointmentData()
        this.getUnlockNotesData()
      }
    }
    else if (UserData?.clinic_staff && (path === "/DoctorHome")) {
      this.getJMODoctor()
    }
    if (callOpList.has(path)) {
      this.getRadAppointmentListData()
    }
  }

  /* Login UserName Api Functionend  */

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      if (window.location.pathname !== this.state.pathName) {
        this.setState({ pathName: window.location.pathname });
        if (window.location.pathname === "/") {
          this.logout()
        }
        setTimeout(() => {
          this.setState({ insuToolOpen: undefined });
        }, 2000);
        if (this.state.unlockDate != "" && window.location.pathname != "/DoctorHome") {
          this.setState({
            unlockDate: ""
          })
        }
        if (localGetItem("isLoggedIn")) {
          let smsAlert = JSON.parse(localGetItem("show_sms_alert"))
          let whatsappAlert = JSON.parse(localGetItem("show_whatsapp_alert"))
          var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
          let isfaceRecognizationEnabled = JSON.parse(localGetItem("is_enable_face_data"))
          var UserData = myUser
          this.setState({
            loginName: UserData?.display_name,
            loginType: UserData?.module_name,
            labType: myUser?.laboratory_type,
            isfaceRecognizationEnabled: isfaceRecognizationEnabled,
            loggedInuserInfo: JSON.parse(localGetItem("loggedInUserInfo")),
            logedUsername: localGetItem("LogedUserName"),
            DoctorsList: localGetItem("DoctorsList") ? JSON.parse(localGetItem("DoctorsList")) : [],
            vitals: false,
            SelectedDoctorClinic: localGetItem('SelectedDoctorClinicId') ? localGetItem('SelectedDoctorClinicId') : "",
            smsAlert: smsAlert ? smsAlert : false,
            whatsappAlert: whatsappAlert ? whatsappAlert : false,
            isIPTrans: false,
          }, () => {
            const path = window.location.pathname;
            const investgationName = GetInvestigationName();
            const module_name = this.state.loggedInuserInfo?.module_name;

            const homePaths = new Set(["/DoctorHome", "/OPHome", "/PharmacyBilling", `/${investgationName}Home`, "/MainHome"]);
            const notifyPaths = new Set([
              "/IPHome", "/PharmacyBilling", "/MainHome", "/MainHome/TestReport",
              "/MainHome/ForTechnicians", "/MainHome/OutsourceList", "/Results",
              "/MainHome/Order/CreateOrder", `/${investgationName}Home`]);

            const badgeCountPaths = new Set(["/MainHome", "/IPHome", "/Billing",
              "/Billing/LabBilling", "/HospitalBilling",
              "/HospitalBilling/HospitalBilling", "/LabBilling",
              "/LabBilling/HospitalBilling", "LabBilling/CashCounter",
              `/${investgationName}Billing`, `/${investgationName}Billing/HospitalBilling`,
              `/${investgationName}Home`, "/DoctorBilling", "/DoctorBilling/DoctorBilling"]);

            const callOpList = new Set(["/MainHome", '/HospitalBilling',
              '/HospitalBilling/HospitalBilling',
              '/LabBilling', '/LabBilling/HospitalBilling',
              '/PharmacyBilling/CashCounter', `/${investgationName}Billing`,
              `/${investgationName}Billing/HospitalBilling`, `/${investgationName}Home`]);

            if (this.state.labType === "Inhouse Laboratory" && (window.location.pathname === "/MainHome")) {
              this.getClinicdata()
            }

            if ((path === "/OPHome") || (path === "/IPHome")) {
              // this.getDoctorsList()
            }

            if (badgeCountPaths.has(path)) {
              this.getBadgeCount()
            }
            if ((path === "/OPHome")) {
              this.getAppointRequests()
              this.getQREntryList()
              this.getBadgeCount()
              if (myUser?.module_name !== "nurse") {
                this.getNotificationData()
              }
              if (myUser?.is_qms_enabled) {
                this.getDoctorQueueData()
                this.WebSocketConnention()
              }
            }
            if ((path === "/OPHome") || (path === "/DoctorHome")) {
              if (myUser?.is_qms_enabled) { this.FoCallPatientConnect() }
            }
            if ((path === "/OPHome" || (path === `/${investgationName}Home`)) && localGetItem("PurposeOfVisit") === null) {
              this.getPurposeOfVisitList()
            }
            if ((path === "/OPHome") && localGetItem("ipComplaintsDataList") === null) {
              this.getIPcomlaintsdata()
            }
            if ((homePaths.has(path)) && (localGetItem("noShowStatus") === null || localGetItem("Allow_Pharma_CreditBill_In_FO") === null || localGetItem("Show_Pharmacy_Bills_In_FO") === null)) {
              this.GetCustomConfig()
            }
            if ((path === "/DoctorHome") && !UserData?.clinic_staff) {
              if (module_name === "Doctor") {
                this.getDoctorClinicData()
                this.getTransferAppointmentData()
                this.getUnlockNotesData()
              }
            }
            else if (UserData?.clinic_staff && (path === "/DoctorHome")) {
              this.getJMODoctor()
            }
            if (path === '/DoctorHome/DoctorNotes' && (module_name === "Doctor" || this.state.loggedInuserInfo?.clinic_staff)) {
              this.getDoctorNotesPrintTemplate()
            }

            if (this.state.clinicId === null && localGetItem("clinicId") !== null && this.state.clinicId !== localGetItem("clinicId")) {
              this.setState({
                clinicId: localGetItem("clinicId")
              })
            }
            if (notifyPaths?.has(path) && JSON.parse(localGetItem('set_due_date_for_credit_billing')) !== null) {
              this.getNotificationData();
            }
            if (callOpList.has(path)) {
              this.getRadAppointmentListData()
            }
            if (((path === "/PharmacyBilling") || (path === "/SubLocationBilling")) && Object.keys(this.state.badgeCount)?.length === 0) {
              if (path !== "/SubLocationBilling") {
                this.getBadgeCount()
              }
              if (path === "/PharmacyBilling" || path === "/SubLocationBilling") {
                this.getIndentCount()
              }
            }
          })

        }
      }
    }
  }

  componentWillUnmount() {
    this.clearTimer();
    // this.WebSocketDisconnect()
    window.removeEventListener('mousemove', this.resetIdleTimer);
    window.removeEventListener('mousedown', this.resetIdleTimer);
    window.removeEventListener('touchstart', this.resetIdleTimer);
    window.removeEventListener('touchmove', this.resetIdleTimer);
    window.removeEventListener('click', this.resetIdleTimer);
    window.removeEventListener('keydown', this.resetIdleTimer);
    window.removeEventListener('scroll', this.resetIdleTimer, true);
    window.removeEventListener("online", this.handleOnlineStatus);
    window.removeEventListener("offline", this.handleOfflineStatus);
  }

  startTimer() {
    if (this.state.IdleAlertPopup) {
      this.setState({
        IdleAlertPopup: false
      })
    }
    let customLogoutTime = localGetItem("auto_log_out_time") ? +localGetItem("auto_log_out_time") : 15
    this.IdleTimer = setTimeout(this.AutoLogOutOnIdle, customLogoutTime * 60 * 1000); // auto logout on 15 mins idle
    this.IdleAlertTimer = setTimeout(() => { this.setState({ IdleAlertPopup: true }) }, (customLogoutTime - 3) * 60 * 1000); // alert popup on 12 mins idle
  }

  resetIdleTimer = () => {
    clearTimeout(this.IdleTimer);
    clearTimeout(this.IdleAlertTimer);
    this.startTimer();
  }

  clearTimer = () => {
    clearTimeout(this.IdleTimer);
    clearTimeout(this.IdleAlertTimer);
  }

  AutoLogOutOnIdle = () => {
    if (window.location.pathname === "/") {
      this.clearTimer()
    } else {
      this.logout()
      this.props?.history.push('/')
    }
  }

  onClickDoctorNotesDefault = () => {
    try {
      this.setState({ doctorPrintList: JSON.parse(this.state.dupDocPrintList) })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }


  getConnectedDevices = () => {
    if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
      console.warn("enumerateDevices() is not supported in this browser or context.");
      return;
    }
    navigator.mediaDevices.enumerateDevices()
      .then(devices => {
        console.log("devicesConnected", devices)
        const videoDevices = devices?.filter(device => device.kind === 'videoinput');
        this.setState({
          devices: videoDevices,
        });
      })
      .catch(error => {
        console.error('Error enumerating devices:', error);
      });
  }

  logout = () => {
    this.resetState();
    localClearAll();
    clearAllCachevalue();
  }

  resetState = () => {
    this.setState({
      loggedInuserInfo: "",
      isLoader: false,
    })
  }

  handleDrawerClose = () => {
    this.setState({
      drawer_Open: false,
    })
  };

  handleOpenUserMenu = (e) => {
    this.setState({
      anchorElUser: true,
      RequestAnchor: e.currentTarget
    })
  };
  handleCloseUserMenu = (event) => {
    this.setState({
      anchorElUser: false
    })
  };

  onClickSavedBillClose = (flag) => {
    this.setState({
      ph_SavedBill: flag
    })
  }

  savedBillClose = () => {
    this.setState({
      ph_SavedBill: false
    })
  }

  WebSocketConnention = () => {
    let userData = JSON.parse(localGetItem("loggedInUserInfo"))
    let emergencyChannel = userData?.emergency_channel_name
    let docCallChannel = userData?.doctor_call_channel_name
    let lateByChannel = userData?.late_channel_name
    let outOfficeChannel = userData?.out_channel_name

    if (this.EmergencySocket === null) {
      this.EmergencySocket = new WebSocket(`${Serviceurls.WEB_SOCKET_DOMAIN}${Serviceurls.DOC_EMERGENCY_WEBSOCKET}${emergencyChannel}/`);
    }
    if (this.DocRunningLate === null) {
      this.DocRunningLate = new WebSocket(`${Serviceurls.WEB_SOCKET_DOMAIN}${Serviceurls.DOC_RUNNINGLATE_WEBSOCKET}${lateByChannel}/`);
    }
    if (this.DocOutofOfficeLate === null) {
      this.DocOutofOfficeLate = new WebSocket(`${Serviceurls.WEB_SOCKET_DOMAIN}${Serviceurls.DOC_OUTOFOFFICE_WEBSOCKET}${outOfficeChannel}/`);
    }
    if (this.DocCallPatient === null) {
      this.DocCallPatient = new WebSocket(`${Serviceurls.WEB_SOCKET_DOMAIN}${Serviceurls.DOC_PATIENTCALL_WEBSOCKET}${docCallChannel}/`);
    }

    const socketMapping = {
      EmergencySocket: this.EmergencySocket,
      DocRunningLate: this.DocRunningLate,
      DocOutofOfficeLate: this.DocOutofOfficeLate,
      DocCallPatient: this.DocCallPatient,
    };

    Object.entries(socketMapping)?.forEach(([name, socket]) => {
      if (socket) {
        socket.onopen = () => {
          console.log(`${name} WebSocket connected`);
        }
        socket.onclose = () => {
          console.log(`${name} WebSocket disconnected`);
        }
        socket.onerror = (error) => {
          console.log(`${name} WebSocket Error`, error);
          socket.close()
        }
        socket.onmessage = (e) => {
          const data = JSON.parse(e.data);
          if (data) {
            if ((name !== "DocCallPatient" || localGetItem("show_notification_banner_fo") === "true") && window.location.pathname !== "/DoctorHome") {
              // enqueueSnackbar(data?.message)
              this.infoMessage(data?.message)
            }
            if (name === "DocCallPatient") {
              this.getDoctorQueueData()
            }
            if (name === "EmergencySocket" || name === "DocRunningLate" || name === "DocOutofOfficeLate") {
              this.getNotificationData()
            }
          }
          console.log(`${name} WebSocket Message`, data);
        }
      }
    })
  }

  WebSocketDisconnect = () => {
    let userData = JSON.parse(localGetItem("loggedInUserInfo"))
    if (userData?.is_qms_enabled) {

      if (this.EmergencySocket) {
        this.EmergencySocket.close()
        this.EmergencySocket = null
      }
      if (this.DocRunningLate) {
        this.DocRunningLate.close()
        this.DocRunningLate = null
      }
      if (this.DocOutofOfficeLate) {
        this.DocOutofOfficeLate.close()
        this.DocOutofOfficeLate = null
      }
      if (this.PaitentCall) {
        this.PaitentCall.close()
        this.PaitentCall = null
      }
      if (this.DocCallPatient) {
        this.DocCallPatient.close()
        this.DocCallPatient = null
      }
      if (this.FoToDocSocket) {
        this.FoToDocSocket.close()
        this.FoToDocSocket = null
      }
      if (this.FoToDocTokenSocket) {
        this.FoToDocTokenSocket.close()
        this.FoToDocTokenSocket = null
      }
    }
  }

  returnSideMenus = () => {
    const myUser = JSON.parse(localGetItem("loggedInUserInfo"));
    const investigationName = localGetItem('investigation_name');
    const module_name = myUser?.module_name;
    if (module_name === "sub_location" || module_name === "Store Sub Location") {
      const sub = myUser?.sub_location_module;

      const subLocationMap = {
        // "Front Office": NewSideMenu.FO_SubLocation,
        // "LAB": NewSideMenu.LAB_SubLocation,
        // "Radiology": NewSideMenu.Radiology_SubLocation,
        // "Pharmacy": NewSideMenu.Pharmacy_SubLocation,
      };

      return (subLocationMap[sub]?.() || NewSideMenu.SubLocation());
    }

    const menuMap = {
      "front_office": NewSideMenu.FO,
      "Doctor": NewSideMenu.Doctor,
      "nurse": NewSideMenu.Nurse,
      "Laboratory": NewSideMenu.lab,
      "Ayurveda": NewSideMenu.Ayurveda,
      "Radiology": NewSideMenu.Radiology,
      [investigationName]: NewSideMenu.Radiology,
      "Pharmacy": NewSideMenu.Pharmacy,
      "JMO": NewSideMenu.JMO,
    };
    return menuMap[module_name === "Investigation" ? investigationName : module_name]?.() || [];
  }

  handleNewCheckBoxHandler = (e, index) => {
    try {
      let value = e.target.checked
      if (this.state.doctorPrintList['other_doctor'][index]['label'] === 'Full Report') {
        this.state.doctorPrintList['other_doctor'][index]['is_checked'] = value
        this.setState({ doctorPrintList: this.state.doctorPrintList }, () => {
          if (this.state.doctorPrintList['other_doctor'][index]['label'] === 'Full Report' && this.state.doctorPrintList['other_doctor'][index]['is_checked']) {
            this.state.doctorPrintList?.other_doctor?.forEach(element => element.is_checked = true)
            this.setState({ doctorPrintList: this.state.doctorPrintList })
          } else {
            this.state.doctorPrintList?.other_doctor?.forEach(element => element.is_checked = false)
            this.setState({ doctorPrintList: this.state.doctorPrintList })
          }
        })
      } else {
        this.state.doctorPrintList['other_doctor'][index]['is_checked'] = value
        this.setState({ doctorPrintList: this.state.doctorPrintList }, () => {
          let filterArray = this.state.doctorPrintList?.other_doctor?.filter(item => item?.label !== 'Full Report')
          let checkAll = filterArray?.every(item => item.is_checked)
          this.state.doctorPrintList?.other_doctor?.forEach(element => {
            if (element.label === 'Full Report' && checkAll) {
              element.is_checked = true
            } else if (!checkAll && element.label === 'Full Report') {
              element.is_checked = false
            }
          })
          this.setState({ doctorPrintList: this.state.doctorPrintList })
        })
      }
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  handleAgeCalculation = date => {
    // let age = "";
    // let dob = DateTime.fromJSDate(date);
    // var year_age = DateTime.now().diff(dob, 'years');
    // age = Math.floor(year_age.years) || 0;
    // return age;
    let age = "";
    let dob = new Date(date);
    let m = moment(dob, "DD-MM-YYYY");
    var end_date = moment();

    var year_age = end_date.diff(m, 'year') || 0;
    // reset(year) year with difference year
    m = moment(m).add(year_age, 'years');

    var month_age = end_date.diff(m, 'month') || 0;
    // reset(month) month with difference month
    m = moment(m).add(month_age, 'months');

    var day_age = end_date.diff(m, 'days') || 0;

    if (year_age > 0) {
      age = year_age || 0;
    } else {
      age = year_age + "Y/" + month_age + "M/" + day_age + "D";
    }
    return (date < new Date() && date > new Date("1872-01-01")) ? age : "";
  }

  handleFindApproxDob = ageEntered => {

    var year = 0;
    var month = 0;
    var days = 0;
    var tempDate;
    year = +(ageEntered)
    if (!year) {
      tempDate = null;
    } else {
      tempDate = DateTime.now().minus({ years: year }).toBSON();
    }

    return tempDate;
  }

  getListCount = (status) => {
    if (status == true) {
      this.getBadgeCount()
    }
  }

  getcountNotification = (flag) => {
    if (flag) {
      this.getIndentCount()
    }
  }

  triggerNotifyCount = (status) => {
    if (!status) return;
    this.getNotificationData();
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    })
  }

  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    })
  }

  infoMessage = (message) => {
    this.setState({
      isInfoMsg: true,
      isInfoMsgText: message
    })
  }

  closeDrQueue = () => {
    if (this.state.DocQueuePopup) {
      this.setState({
        DocQueuePopup: false,
      }, () => this.getDoctorQueueData())
    }
  }

  onClick = () => {
    setTimeout(() => {
      this.setState({
        isLoader: false,
      })
    }, 1000)
    if (this.state.selectedMenuId == 3) {
      var open = this.state.checked
      this.setState({
        checked: !open
      })
    } else if (this.state.selectedMenuId == 4) {
      var open = this.state.checked
      this.setState({
        checked: !open
      })
    } else if (this.state.selectedMenuId == 5) {
      var open = this.state.checked
      this.setState({
        checked: !open
      })
    }
  }

  clearCacheData = (path) => {
    try {
      if (path !== "IPHome") {
        this.setState({ isLoader: true })
      }
      clearCachevalue("patientData")
      clearCachevalue("IppatientData")
      clearCachevalue("withoutAppointment")
      clearCachevalue("OP_CreateAppointment_PatientId")
      clearCachevalue("OTpatientData")
      clearCachevalue("AppRequestPatientData");
      clearCachevalue('DoctorPatientData')
      clearCachevalue('updatePatient')
      clearCachevalue('filteredData')
      clearCachevalue('RadPatientData')
      clearCachevalue('Laboratory_id')
      clearCachevalue('IsFromIPBill')
      clearCachevalue('IsFromOPBill')
      clearCachevalue('SelectedDate')
      clearCachevalue('SelectedOPDate')
      clearCachevalue('reservePatientData')
      clearCachevalue('provisional_diagnosis')
      clearCachevalue('openAlertPopup')
      clearCachevalue('path_name')
      clearCachevalue('component')
      this.isPatientisSearching(false)
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  callPatientSend = (id) => {
    if (this.PaitentCall) {
      this.PaitentCall.send(JSON.stringify({ id: id ? id : null }))
    }
  }

  getDoctorNotesPrintTemplate = () => {
    try {
      this.setState({ printLoad: true })
      RestAPIService.getAllTwo(Serviceurls.DOC_SETTING_CONFIG)
        .then((response) => {
          if (response.data.status === 'success') {
            let Doctor_Print_Layout = JSON.parse(JSON.stringify(DOC_PRINT_DEFAULT))
            let docNotes = response.data.data.doc_notes_print_template
              ? { ...response.data.data.doc_notes_print_template } // Creating a copy
              : { ...Doctor_Print_Layout }; // Fallback if response is missing

            // Sorting `other_doctor`
            if (docNotes.other_doctor) {
              docNotes.other_doctor = [...docNotes.other_doctor]?.sort((a, b) => (a.print_order) - (b.print_order));
            }

            // Updating state
            this.setState({
              doctorPrintList: docNotes,
              dupDocPrintList: JSON.stringify(docNotes),
              printLoad: false
            });


            localSetItem('app_landing_sts', response.data.data.app_landing_sts ? JSON.stringify(response.data.data.app_landing_sts) : JSON.stringify('All'))
            localSetItem('drug_search', JSON.stringify(response?.data?.data?.drug_search))
            localSetItem('complaints_common_textbox', JSON.stringify(response?.data?.data?.complaints_common_textbox))
            localSetItem('show_quantity_in_prescription', JSON.stringify(response?.data?.data?.show_quantity_in_prescription))
            localSetItem('prescription_save_transmit', JSON.stringify(response?.data?.data?.prescription_save_transmit))
          }
        }).catch((error) => {
          this.setState({ printLoad: false })
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.setState({ printLoad: false })
      this.errorMessage(error.message)
    }
  }

  getClinicdata = () => {
    try {
      RestAPIService.getAll(Serviceurls.LAB_CLINIC_LIST_GET)
        .then((response) => {
          if (response.data.status === "success") {
            this.setState({
              clinicData: response.data.data,
              clinicId: response.data.data[0].clinic_id
            })
          } else {
            this.setState({
              isErrorMsg: true,
              isErrorMsgText: response?.data?.message
            }, () => {
              setTimeout(() => {
                this.setState({ isErrorMsg: false })
              }, 2000);
            })
          }
        }).catch((error) => {
          this.setState({
            isErrorMsg: true,
            isErrorMsgText: error?.response?.data?.message
          }, () => {
            setTimeout(() => {
              this.setState({ isErrorMsg: false })
            }, 2000);
          })
        })
    } catch (error) {
      this.setState({
        isErrorMsg: true,
        isErrorMsgText: error
      }, () => {
        setTimeout(() => {
          this.setState({ isErrorMsg: false })
        }, 2000);
      })
    }
  }

  getIndentCount = () => {
    try {
      RestAPIService.getAll(Serviceurls.INDENT_REQ_COUNT)
        .then((response) => {
          if (response?.data?.status === "success") {
            const data = response?.data?.data ? response?.data?.data : {}
            this.setState({
              indent_Count: data,
            }, () => {
              setCachevalue(data?.inbound, 'subInbound')
              setCachevalue(data?.outbound, 'subOutbound')
              setCachevalue(data?.branch_inbound, 'branchInbound')
              setCachevalue(data?.branch_outbound, 'branchOutbound')
              setCachevalue(data?.sub_location, 'subTotal')
              setCachevalue(data?.branch, 'branchTotal')
            })
          }
        }).catch((error) => {
          this.errorMessage(error?.response?.data?.message || error?.message)
        })

    } catch (e) {
      this.errorMessage(e?.message)
    }
  }

  GetCustomConfig() {
    try {
      RestAPIService.getAllTwo(Serviceurls.CUSTOM_CONFIG)
        .then((response) => {
          if (response.data.status === "success") {
            localSetItem("noShowStatus", response.data.data?.allow_no_show_update ? response.data.data?.allow_no_show_update : false);
            localSetItem("Allow_Pharma_CreditBill_In_FO", response.data.data?.allow_fo_pharmacy_bill_complete ? response.data.data?.allow_fo_pharmacy_bill_complete : false);
            localSetItem("Show_Pharmacy_Bills_In_FO", response.data.data?.show_pharmacy_bills_in_fo ? response.data.data?.show_pharmacy_bills_in_fo : false);
            localSetItem("allow_billing_date_fo", response.data.data?.allow_billing_date_fo ? response.data.data?.allow_billing_date_fo : false);
            localSetItem("allow_billing_date_range", response.data.data?.allow_billing_date_range ? response.data.data?.allow_billing_date_range : "Default");
            localSetItem("default_PayFromAdvance_On_Checkout", response.data.data?.default_pay_from_advance_for_checkout ? response.data.data?.default_pay_from_advance_for_checkout : false);
            localSetItem("allow_doctor_fees_split_up", response.data.data?.allow_doctor_fees_split_up ? response.data.data?.allow_doctor_fees_split_up : false);
            // localSetItem("Copy_IP_Mediction_To_DischargeSummery", response.data.data?.copy_ip_medication_to_discharge_summary ? response.data.data?.copy_ip_medication_to_discharge_summary : false);
            localSetItem('day_end_value', response.data.data?.day_end_type ? response.data.data?.day_end_type : 1)
            // localSetItem("Show_Radiology_Bills_In_FO", response.data.data?.block_radiology_bills_in_fo ? response.data.data?.block_radiology_bills_in_fo : false)
            // localSetItem('billing_concession_type', response.data.data?.billing_concession_type ? response.data.data?.billing_concession_type : 1)
            // localSetItem('billing_concession_type', response.data.data?.billing_concession_type ? response.data.data?.billing_concession_type : 1)
            localSetItem('appointment_status', JSON.stringify(response.data.data?.appointment_status ? response.data.data?.appointment_status : appointment_Status_other))
            // localSetItem('lab_test_code', response.data.data?.lab_test_code ? response.data.data?.lab_test_code : false)
            localSetItem('op_ip_service_code', response.data.data?.op_ip_service_code ? response.data.data?.op_ip_service_code : false)
            // localSetItem('lab_cancel_bill', response.data.data?.lab_cancel_bill ? response.data.data?.lab_cancel_bill : false)
            // localSetItem('lab_con_name_mandatory', response.data.data?.lab_con_name_mandatory ? response.data.data?.lab_con_name_mandatory : false)
            // localSetItem('lab_con_name_specialization', response.data.data?.lab_con_name_specialization ? response.data.data?.lab_con_name_specialization : false)
            // localSetItem('radiology_service_code', response.data.data?.radiology_service_code ? response.data.data?.radiology_service_code : false)
            // localSetItem('Show_PH_Bills_In_Credit_Settle', response.data.data?.allow_pharmacy_bills_in_credit_settlement ? response.data.data?.allow_pharmacy_bills_in_credit_settlement : false)
            // localSetItem('dvr_print_config', response.data.data?.dvr_preview_print ? response.data.data?.dvr_preview_print : 'newtab')
            // localSetItem('drug_search', response.data.data?.drug_search ? response.data.data?.drug_search : 1)
            // localSetItem('credit_bill_flt_config', response.data.data?.default_filter_option_for_credit_bills ? response.data.data?.default_filter_option_for_credit_bills : 'admission_wise')
            // localSetItem('is_expense_maximum_enabled', response.data.data?.is_expense_maximum_enabled)
            // localSetItem('expense_maximum_amount', response.data.data?.expense_maximum_amount || 0)
            // localSetItem('deduct_expense_at_day_end', response.data.data?.deduct_expense_at_day_end)
            localSetItem('enable_specialization_auto_bill', response.data.data?.enable_specialization_auto_bill)
            let GSTData = {
              is_room_charge_gst_applicable: response.data.data?.is_room_charge_gst_applicable,
              room_charge_gst_limit: response.data.data?.room_charge_gst_limit || 0,
              room_charge_gst_percent: response.data.data?.room_charge_gst_percent || 0,
            }
            localSetItem('gst_room_charge', JSON.stringify(GSTData))
            localSetItem('is_transaction_number_mandatory', response.data.data?.is_transaction_number_mandatory ? response.data.data?.is_transaction_number_mandatory : false)
            localSetItem('is_admission_datetime_editable', response.data.data?.is_admission_datetime_editable ? response.data.data?.is_admission_datetime_editable : false)
            localSetItem('set_due_date_for_credit_billing', (response.data.data?.set_due_date_for_credit_billing || false))
          }
          else {
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  handleSearchSubmit = (value, module_name, FromFO = false) => {
    if (module_name === "Fo") {
      this.setState({ PatientNameSearchKey: value }, () => {
        if ((this.state.PatientNameSearchKey !== "" && this.state.PatientNameSearchKey.length > 2) || this.state.PatientAddressKey !== "" || this.state.PatientFathHusKey !== "" || this.state.PatientMotherKey !== "" || this.state.FilterDob !== null || this.state.FilterUHID !== "" || ((window.location.pathname === "/OPHome") ? this.state.FilterOP !== "" : this.state.FilterIP !== "")) {
          this.FOPatientSearch();
        }
      });
    } else if (module_name === "Lab") {
      this.setState({ searchkey: value, LabPatientSearch: true }, () => {
        this.getPatientSearchData(FromFO)
      });
    }
    else if (module_name === "Pharmacy") {
      this.setState({ pharmaNameSearchKey: value }, () => {
        if (CommonValidation.removeSpace(this.state.pharmaNameSearchKey) !== "" && this.state.pharmaNameSearchKey?.length > 2) {
          this.PharmaPatientSearch();
        }
      });
    }
    else if (module_name === "Radiology" || module_name === "Investigation") {
      this.setState({ PatientNameSearchKey: value }, () => {
        if ((this.state.PatientNameSearchKey !== "" && this.state.PatientNameSearchKey.length > 2) || this.state.PatientAddressKey !== "" || this.state.PatientFathHusKey !== "" || this.state.PatientMotherKey !== "" || this.state.FilterDob !== null || this.state.FilterUHID !== "") {
          this.radiologyPatientSearch()
        }
      });
    } else if (module_name === "Doctor") {
      this.setState({ PatientNameSearchKey: value }, () => {
        if ((this.state.PatientNameSearchKey !== "" && this.state.PatientNameSearchKey.length > 2) || this.state.PatientAddressKey !== "" || this.state.PatientFathHusKey !== "" || this.state.PatientMotherKey !== "" || this.state.FilterDob !== null || this.state.FilterUHID !== "" || this.state.FilterOP !== "") {
          this.DoctorPatientSearch()
        }
      });
    }
  };

  handleSearchClear = (module_name) => {
    if (module_name === "Pharmacy") {
      this.setState({ pharmaSearchClicked: false });
    }
    else if (module_name === "Lab") {
      this.setState({ LabPatientSearch: false });
    }
    else {
      this.setState({ PatientSearchClicked: false });
    }
  };

  handleFilterOpen = () => {
    this.setState({ AddressFilterClicked: true })
  }

  handleFaceOpen = (module_name) => {
    if (module_name === "Doctor") {
      // this.setState({ docFaceRecogClicked: true }, () => { this.getConnectedDevices() })
    }
    else {
      // this.setState({ FaceRecogClicked: true }, () => { this.getConnectedDevices() })
    }
  }

  FOPatientSearch(ForRequest = false, MobNum = null) {
    try {
      let { t } = this.props;
      let API_URL = ""
      if (ForRequest) {
        API_URL = Serviceurls.FO_PATIENT_SEARCH + `?search_key=${MobNum}&address_key=&father_husband_key=&address=true`
        this.AppointMobileSrch(true);
      } else {
        var DobDate = new Date(this.state.FilterDob)
        var date = this.state.FilterDob ? DateTime.fromJSDate(DobDate).toFormat('yyyy-MM-dd') : ""
        API_URL = Serviceurls.FO_PATIENT_SEARCH + `?search_key=${this.state.PatientNameSearchKey}&address_key=${this.state.PatientAddressKey}&father_husband_key=${this.state.PatientFathHusKey}&mother_name_key=${this.state.PatientMotherKey}&uhid=${this.state.FilterUHID}&dob=${date}&ip_number=${this.state.FilterIP}&op_number=${this.state.FilterOP}`
        this.isPatientisSearching(true)
      }
      RestAPIService.getAll(API_URL).
        then((response) => {
          if (response.data.status === "success") {
            this.isPatientisSearching(false)
            this.AppointMobileSrch(false);
            if (ForRequest) {
              this.setState({
                SearchedRequestPatientList: response.data.data,
                RequestPatientMenuPop: response.data.data.length > 0 ? true : false
              })
            } else {
              this.setState({
                SearchedPatientList: response.data.data,
                common_uhid: response?.data?.common_uhid ? response?.data?.common_uhid : false
              }, () => {
                if (this.state.PatientNameSearchKey !== "" || this.state.PatientAddressKey !== "" || this.state.PatientFathHusKey !== "" || this.state.PatientMotherKey !== "" || this.state.FilterDob !== null || this.state.FilterUHID !== "" || ((window.location.pathname === "/OPHome") ? this.state.FilterOP !== "" : this.state.FilterIP !== "")) {
                  if (response.data.data.length > 0) {
                    this.setState({ PatientSearchClicked: true, AddressFilterClicked: false })
                  } else {
                    this.setState({ PatientSearchClicked: false, AddressFilterClicked: false })
                    this.errorMessage(t("NoRecordsFound"))
                  }
                }
              })
            }
          }
          else {
            this.isPatientisSearching(false)
            this.AppointMobileSrch(false);
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error?.response?.data?.message)
          } else {
            this.errorMessage(error?.message)
          }
          this.isPatientisSearching(false)
          this.AppointMobileSrch(false);
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  isPatientisSearching(flag) {
    this.setState({ isPatientisSearching: flag })
  }

  AppointMobileSrch(flag) {
    this.setState({ isappointRequest: flag, isDocAppointRequest: flag })
  }

  lodaerFunction = (key) => {
    this.setState({
      isLoader: key
    })
  }

  getIpPatientData = (patientId) => {
    try {
      RestAPIService.getAll(Serviceurls.FO_PATIENT_UPDATE + '?patient_id=' + patientId)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.setState({
              ipPatientListData: response?.data?.data
            }, () => {
              this.props.history.push({
                pathname: "/IPHome/CreateAppointment",
                state: { SelectedPatientDetails: this.state.ipPatientListData, PatientClicked: true }
              })
            })
          }
        }).catch((error) => {
          this.errorMessage(error?.response?.data?.message || error?.message)
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getDoctorPatientDetailData = (id, status, fromOPT, item, Type, doctor_id = null) => {
    try {
      RestAPIService.getAll(Serviceurls.DOC_PATIENT_DETAIL_GET + '?patient_id=' + id)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.setState({
              patientDetails: response?.data?.data
            }, () => {
              let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
              let fromFO = UserData?.module_name === "front_office" ? true : false
              if (fromOPT && !fromFO) {
                if (Type == "TransferAppoint") {
                  setCachevalue(JSON.stringify(this.state.patientDetails), "DoctorPatientData")
                  this.props.history.push({ pathname: "/DoctorHome/Doctor/Demographics", state: { fromCreate: true, patientId: id, transferID: item?.id } })
                }
              } else if (fromFO && status === "fromOpHomeEdit") {
                setCachevalue(JSON.stringify({ ...item, ...this.state.patientDetails }), "patientData")
                this.props.history.push({ pathname: "/OPHome/PatientDetails/Demographics" })
              } else if (fromFO && status === "fromIpHomeEdit") {
                setCachevalue(JSON.stringify({ ...item, ...this.state.patientDetails }), "IppatientData")
                setCachevalue(JSON.stringify({ ...item, ...this.state.patientDetails }), "patientData")
                this.props.history.push({ pathname: "/IPHome/Demographics/Demographics" })
              } else {
                if (status === 'Edit Patient') {
                  setCachevalue(JSON.stringify(this.state.patientDetails), "DoctorPatientData")
                  this.props.history.push({ pathname: "/DoctorHome/Demographics/Update", state: { fromCreate: false, doctorUpdate: true } })
                } else if ((status === 'Create Patient') || (status === 'Request Create')) {
                  setCachevalue(JSON.stringify(this.state.patientDetails), "DoctorPatientData")
                  this.props.history.push({ pathname: "/DoctorHome/Doctor/Demographics", state: { fromCreate: true, patientId: id, followupID: item?.id, AppointDate: item?.follow_up_date } })
                }
              }
            })
          }
        }).catch((error) => {
          this.errorMessage(error?.response?.data?.message || error.message)
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  FOheaderSearch = () => {
    const { t } = this.props;
    var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
    var UserData = myUser
    let DoctorsList = this.state.DoctorsList?.length > 0 ? this.state.DoctorsList : localGetItem("DoctorsList") ? JSON.parse(localGetItem("DoctorsList")) : []
    return (
      <Box sx={{ marginLeft: '3.2vw' }}>
        <Box component={'div'} display={'flex'} flexDirection={'row'} sx={{ borderRadius: "0.3vw" }}>
          <FormControl size='small' sx={{ width: "13vw", borderRadius: '0.2vw', }} >
            <Select
              className='mui_header_card_dropdown_fo'
              value={window.location.pathname === "/OPHome" ? this.state.SelectedDoctor : this.state.SelectedIPDoctor}
              onChange={(e) => {
                if ((window.location.pathname === "/OPHome")) {
                  this.setState({ SelectedDoctor: e.target.value }, () => {
                    setCachevalue(this.state.SelectedDoctor, "SelectedDoctorID")
                    this.props.history.push({ pathname: "/OPHome", state: { SelectedDoctorID: this.state.SelectedDoctor } })
                  })
                }
                else if ((window.location.pathname === "/IPHome")) {
                  this.setState({ SelectedIPDoctor: e.target.value }, () => {
                    setCachevalue(this.state.SelectedIPDoctor, "SelectedIPDoctorID")
                    this.props.history.push({ pathname: "/IPHome", state: { SelectedDoctorID: this.state.SelectedIPDoctor } })
                  })
                }
              }}
              sx={{ backgroundColor: 'white' }}
              MenuProps={{ style: { maxHeight: 250 } }}
            >
              <MenuItem value={0} >{"All Doctors"}</MenuItem>
              {DoctorsList && DoctorsList.length > 0 && DoctorsList.map((item) => (
                <MenuItem key={item.doctor_id} value={item.doctor_id} >{item.doctor_name}</MenuItem>
              ))}
            </Select>
          </FormControl>
          {UserData?.module_name !== "nurse" ?
            <>
              <PatientHeaderSearch
                t={this.props.t}
                isLoading={this.state.isPatientisSearching}
                filterVisible={this.state.PatientAddressKey === "" && this.state.PatientFathHusKey === "" && this.state.PatientMotherKey === "" && this.state.FilterDob === null && this.state.FilterUHID === "" && ((window.location.pathname === "/OPHome") ? this.state.FilterOP === "" : this.state.FilterIP === "")}
                flterOpen={this.handleFilterOpen}
                faceOpen={this.handleFaceOpen}
                module_name={"Fo"}
                faceVisible={this.state.isfaceRecognizationEnabled}
                onSearchSubmit={this.handleSearchSubmit}
                onClear={this.handleSearchClear}
                searchValue={this.state.PatientNameSearchKey}
              />
            </>
            : null}
        </Box>
        <Menu
          open={this.state.PatientSearchClicked}
          className="eMed_Header_Search_Pop"
          disableAutoFocus
          disableEnforceFocus
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          MenuListProps={{
            autoFocus: false
          }}
          onClose={() => {
            this.setState({
              PatientSearchClicked: false,
              PatientAddressKey: "",
              PatientFathHusKey: "",
              PatientMotherKey: "",
              FilterDob: null,
              FilterUHID: "",
              FilterOP: "",
              FilterIP: "",
            })
          }}
        >
          {
            this.state.SearchedPatientList?.length > 0 ?
              this.state.SearchedPatientList.map((list) => {
                let PatientFullName = `${list.first_name} ${list.last_name}`
                list["patient_name"] = PatientFullName
                list["patient_mobile_number"] = list.mobile_number
                list["patient_photo_url"] = list.photo_url
                return (
                  <Box>
                    <Box className="eMed_Header_Search_item">
                      <CommonPatientDetails data={list} fromSearch={true} isCommonUhid={this.state.common_uhid} />
                      <Tooltip title={t("Last Visit Date")} arrow>
                        <div style={{ fontSize: "0.65vw", fontWeight: "bold" }}>Last Visited Date</div>
                        <Typography sx={{ fontSize: '0.85vw' }}>OP: {formatDate(list?.op_last_visit_date)}</Typography>
                        <Typography sx={{ fontSize: '0.85vw' }}>IP: {formatDate(list?.ip_last_visit_date)}</Typography>
                      </Tooltip>
                      {
                        ((window.location.pathname === "/OPHome")) ?
                          (list.appointment_date === "" || list.appointment_status === "Cancelled") ?
                            <Box component={'div'} className="eMed_Header_Search_icons">
                              <Tooltip title={t("EditPatientDetails")} arrow>
                                <IconButton onClick={() => {
                                  this.setState({
                                    PatientNameSearchKey: "",
                                    PatientAddressKey: "",
                                    PatientFathHusKey: "",
                                    PatientMotherKey: "",
                                    PatientSearchClicked: false,
                                    SearchedPatientList: [],
                                    common_uhid: false,
                                    FilterDob: null,
                                    FilterUHID: "",
                                    FilterOP: "",
                                    FilterIP: "",
                                  }, () => {
                                    this.getDoctorPatientDetailData(list?.patient_id, "fromOpHomeEdit", false, list)
                                  })
                                }}
                                  position="end">
                                  <Edit color='primary' />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title={t("CreateAppointment")} arrow>
                                <IconButton disabled={list?.op_has_current_appointment} onClick={() => {
                                  this.setState({
                                    PatientNameSearchKey: "",
                                    PatientAddressKey: "",
                                    PatientFathHusKey: "",
                                    PatientMotherKey: "",
                                    FilterDob: null,
                                    FilterUHID: "",
                                    FilterOP: "",
                                    FilterIP: "",
                                    PatientSearchClicked: false,
                                    SearchedPatientList: [],
                                    common_uhid: false,
                                  }, () => {
                                    setCachevalue(list.patient_id, "OP_CreateAppointment_PatientId")
                                    this.props.history.push({ pathname: "/OPHome/Billing/NewQuickBilling" })
                                  })
                                }}
                                  position="end">
                                  <PersonAddAlt1Icon sx={{ color: list.ip_has_current_appointment ? Colors.disableLabelColor : Colors.themeDark }} />
                                </IconButton>
                              </Tooltip>
                            </Box> :
                            <Box component={'div'} className="eMed_Header_Search_icons">
                              <Tooltip title={t("EditPatientDetails")} arrow>
                                <IconButton onClick={() => {
                                  this.setState({
                                    PatientNameSearchKey: "",
                                    PatientAddressKey: "",
                                    PatientFathHusKey: "",
                                    PatientMotherKey: "",
                                    FilterDob: null,
                                    FilterUHID: "",
                                    FilterIP: "",
                                    FilterOP: "",
                                    PatientSearchClicked: false,
                                    SearchedPatientList: [],
                                    common_uhid: false,
                                  }, () => {
                                    this.getDoctorPatientDetailData(list?.patient_id, "fromOpHomeEdit", false, list)
                                  })
                                }}
                                  position="end">
                                  <Edit color='primary' />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title={t("CreateAppointment")} arrow>
                                <IconButton disabled={list?.op_has_current_appointment} onClick={() => {
                                  this.setState({
                                    PatientNameSearchKey: "",
                                    PatientAddressKey: "",
                                    PatientFathHusKey: "",
                                    PatientMotherKey: "",
                                    FilterDob: null,
                                    FilterUHID: "",
                                    FilterOP: "",
                                    FilterIP: "",
                                    PatientSearchClicked: false,
                                    SearchedPatientList: [],
                                    common_uhid: false
                                  }, () => {
                                    setCachevalue(list.patient_id, "OP_CreateAppointment_PatientId")
                                    this.props.history.push({ pathname: "/OPHome/Billing/NewQuickBilling" })
                                  })
                                }}
                                  position="end">
                                  <PersonAddAlt1Icon sx={{ color: list.op_has_current_appointment ? Colors.disableLabelColor : Colors.themeDark }} />
                                </IconButton>
                              </Tooltip>
                              {/* <Typography>{list.appointment_date && formatDate(list.appointment_date)}</Typography> */}
                            </Box>
                          :
                          <Box component={'div'} className="eMed_Header_Search_icons">
                            <Tooltip title={t("ViewPatientDetails")} arrow>
                              <IconButton onClick={() => {
                                this.setState({
                                  PatientNameSearchKey: "",
                                  PatientAddressKey: "",
                                  PatientFathHusKey: "",
                                  PatientMotherKey: "",
                                  FilterDob: null,
                                  FilterUHID: "",
                                  FilterOP: "",
                                  FilterIP: "",
                                  PatientSearchClicked: false,
                                  SearchedPatientList: [],
                                  common_uhid: false
                                }, () => {
                                  this.getDoctorPatientDetailData(list?.patient_id, "fromIpHomeEdit", false, list)
                                })
                              }}
                                position="end">
                                <img src={ImagePaths.View.default} />
                              </IconButton>
                            </Tooltip>
                            {list.is_admitted ? <Typography>{list.admission_date && formatDate(list.admission_date)}</Typography> :
                              <Tooltip title={t("CreateAdmission")} arrow>
                                <IconButton disabled={list?.ip_has_current_appointment}
                                  onClick={() => {
                                    this.setState({
                                      PatientNameSearchKey: "",
                                      PatientAddressKey: "",
                                      PatientFathHusKey: "",
                                      PatientMotherKey: "",
                                      FilterDob: null,
                                      FilterUHID: "",
                                      FilterOP: "",
                                      FilterIP: "",
                                      PatientSearchClicked: false,
                                      SearchedPatientList: [],
                                      PatientMotherKey: "",
                                      common_uhid: false,
                                    }, () => {
                                      this.getIpPatientData(list?.patient_id)
                                    })
                                  }} position="end">
                                  <PersonAddAlt1Icon sx={{ color: list.ip_has_current_appointment ? Colors.disableLabelColor : Colors.themeDark }} />
                                </IconButton>
                              </Tooltip>}
                          </Box>
                      }
                    </Box>
                    <Divider />
                  </Box>
                )
              }) : null
          }
        </Menu>
        <Menu
          open={this.state.AddressFilterClicked}
          className="eMed_Header_Filter_Pop"
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          onClose={() => {
            this.setState({ AddressFilterClicked: false })
          }}
        >
          {this.DynamicFilterFeilds()}
        </Menu>
      </Box>
    )
  }

  getPatientSearchData = (FromFO) => {
    try {
      const { t } = this.props
      var search_key = this.state.searchkey ? this.state.searchkey : ""
      let serviceUrl = ""
      if (FromFO) {
        serviceUrl = Serviceurls.FO_PATIENT_SEARCH + `?search_key=${search_key}`
      } else if (this.state.labType === "Standalone Laboratory") {
        serviceUrl = Serviceurls.LAB_SEARCH_PATIENT + "?search_key=" + search_key
      } else {
        serviceUrl = Serviceurls.LAB_PATIENT_TRANSMIT_SEARCH + "?search_key=" + search_key
      }
      this.isPatientisSearching(true)
      RestAPIService.getAll(serviceUrl)
        .then(response => {
          if (response.data.status == "success") {
            var data = response.data.data
            if (data.length > 0) {
              this.setState({ searchPatientDatas: data, isPatientisSearching: false, common_uhid: response?.data?.common_uhid })
            } else {
              this.isPatientisSearching(false)
              this.errorMessage(t("NoRecordsFound"))
            }
          }
        })
        .catch(e => {
          this.isPatientisSearching(false)
          this.errorMessage(e?.response?.data?.message || e?.message)
        });
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getLabPateintHistoryData = () => {
    try {
      let laboratoryId = getCachevalue("Laboratory_id")
      RestAPIService.getAll(Serviceurls.LAB_PATIENT_TEST_HISTORY + `?patient_id=${this.state.labPatientData?.patient_id}&laboratory_id=${laboratoryId}`)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              labHistoryData: response.data.data
            })
          }
        }).catch((error) => {
          this.errorMessage(error?.response?.data?.message || error.message)
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  LabHeaderSearch = (FromFO = false, radiology = false) => {
    const { t, history } = this.props;
    return (
      <Box sx={{ marginLeft: '3.2vw' }} className='Lab_Home_Patient_Search'>

        <Box component={'div'} display={'flex'} flexDirection={'row'} sx={{ borderRadius: "0.3vw" }}>
          {FromFO && this.state.labType !== "Inhouse Laboratory" ? null :
            <FormControl size='small' sx={{ width: "13vw", borderRadius: '0.2vw', }} >
              <Select
                className='mui_header_card_dropdown_fo'
                value={this.state.clinicId}
                onChange={(e) => {
                  this.setState({ clinicId: e.target.value })
                }}
                sx={{ backgroundColor: '#E4F2F0' }}
                MenuProps={{ style: { maxHeight: 250 } }}
              >
                {this.state.clinicData && this.state.clinicData.length > 0 && this.state.clinicData.map((item) => (
                  <MenuItem key={item.clinic_id} value={item.clinic_id} >{item.clinic_name}</MenuItem>
                ))}
              </Select>
            </FormControl>}
          <PatientHeaderSearch
            t={this.props.t}
            isLoading={this.state.isPatientisSearching}
            module_name={"Lab"}
            onSearchSubmit={this.handleSearchSubmit}
            onClear={this.handleSearchClear}
            FromFo={FromFO}
            searchValue={this.state.searchkey}
          />
        </Box>
        <Menu
          sx={{ left: this.state.labType === "Inhouse Laboratory" ? "3vw" : "-9.5vw" }}
          open={this.state.LabPatientSearch && this.state.searchPatientDatas?.length > 0}
          disableAutoFocus
          disableEnforceFocus
          className="eMed_Header_Search_Pop"
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          MenuListProps={{
            autoFocus: false
          }}
          onClose={() => {
            this.setState({
              LabPatientSearch: false,
              searchPatientDatas: [],
              common_uhid: false,
            })
          }}
        >
          {this.state.searchPatientDatas?.length > 0 ?
            this.state.searchPatientDatas.map((item) => {
              let PatientNameText = item.first_name || item.patient_name
              let PatientAgeText = `(${item?.patient_age ? item?.patient_age : ""}/${item?.gender ? item?.gender.toUpperCase() : ""})`
              let branchName = item?.branch_name ? item.branch_name : "-"
              return (
                <Box width={"25vw"} padding={'0.5vw'}>
                  <Box display={'flex'} alignItems={'center'}>
                    <Avatar id='eMed_IconAvatar' src={item.photo_url || item.patient_photo_url ? item.photo_url || item.patient_photo_url : ImagePaths.Default} sx={{ boxShadow: 3, minWidth: '13%', marginTop: '1vh', marginRight: '2vh', marginBottom: '1vh' }} />
                    <div style={{ minWidth: '55%' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box component={'div'}>
                          {PatientNameText ? PatientNameText?.length > 16 ?
                            <Tooltip placement='top' title={PatientNameText} arrow>
                              <Typography sx={{ margin: "0vw", fontSize: '0.9vw' }}>{PatientNameText.slice(0, 15) + "..."}</Typography></Tooltip> :
                            <Typography sx={{ margin: "0vw", fontSize: '0.9vw' }}>{PatientNameText}</Typography> : "-"}</Box>
                        <Typography sx={{ margin: "0vw", marginLeft: "0.5vw", fontSize: '0.8vw' }}>{PatientAgeText}</Typography>
                      </Box>
                      <div className='search_sub_container'>
                        <Typography className='eMed_Com_Patient_UhidText' sx={{ fontSize: "0.8vw" }}>{item.mobile_number || item.patient_mobile_number}</Typography>
                        <Typography className='eMed_Com_Patient_UhidText' sx={{ fontSize: "0.8vw", marginLeft: "0.5vw" }}>{" | " + item.patient_account_number ? item.patient_account_number : ""}</Typography>
                      </div>
                      <div>
                        {this.state.common_uhid ? <Typography className='eMed_Com_Patient_UhidText' sx={{ fontSize: "0.8vw" }}>Branch Name: {branchName?.length > 22 ? <Tooltip placement="top" title={branchName} arrow><span id='eMed_Com_Patient_UhidText'>{branchName?.slice(0, 19) + "..."}</span></Tooltip> : branchName ? branchName : "-"}</Typography> : null}
                      </div>
                    </div>
                    <button size="small" className='Lab_Search_Button' onClick={() => {
                      this.setState({
                        selectedPatientData: item,
                        LabPatientSearch: false,
                        searchkey: "",
                        searchPatientDatas: [],
                        common_uhid: false,
                      }, () => {
                        if (this.state.loggedInuserInfo?.module_name === 'Laboratory') {
                          setCachevalue(this.state.selectedPatientData?.patient_id, 'OP_CreateAppointment_PatientId')
                          history.push({ pathname: "/LabBilling/NewQuickBilling", state: { patientData: this.state.selectedPatientData } })
                        }
                      })
                    }}><p className='Lab_saved_Bill_Text'>{t("Proceed")}</p></button>
                    {!radiology ? <Button
                      className='Common_Btn_Min_Width'
                      sx={{ height: "2vw", width: '2vw', ml: '1vw' }}
                      onClick={() => this.setState({ labHistoryPopup: true, labPatientData: item }, () => this.getLabPateintHistoryData())}
                    >
                      <Box component={'img'} src={ImagePaths.ResultHistory.default} height={'2vw'} width={'2vw'} />
                    </Button> : null}
                  </Box>
                  <Divider />
                </Box>
              )
            }) : <Box component={'div'} padding={"1vw"}>{t("NoRecordsFound")}</Box>
          }
        </Menu>
      </Box>
    )
  }

  getRadiologyPatientData = (id, update, billSummaryId, data, isFrom) => {
    try {
      this.lodaerFunction(true)
      const investigationName = GetInvestigationName();
      RestAPIService.getAll(Serviceurls.FO_PATIENT_UPDATE + '?patient_id=' + id)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.lodaerFunction(false)
            this.setState({
              patientDetails: response?.data?.data
            }, () => {
              if (update === 'update') {
                setCachevalue(JSON.stringify(this.state.patientDetails), "RadPatientData")
                this.props.history.push({ pathname: `/${investigationName}Home/Demographics/Update`, state: { radUpdate: true, } })
              } else if (update === 'savedBill') {
                this.props.history.push({
                  pathname: `/${investigationName}Home/Patient/Billing`,
                  state: { fromSavedBill: true, patientData: this.state.patientDetails, billSummaryId: billSummaryId }
                })
              } else if (update === "TransmitToFoRad") {
                setCachevalue(JSON.stringify(this.state.patientDetails), 'RadPatientData')
                this.props.history.push({
                  pathname: '/Billing/RadiologyBilling',
                  state: { patientData: this.state.patientDetails, forTransmit: true, TransmitData: data || {} }
                })
              } else {
                setCachevalue(JSON.stringify(this.state.patientDetails), 'RadPatientData')
                if (isFrom === "isFromIpBill") {
                  setCachevalue(JSON.stringify(true), 'IsFromIPBill')
                } else if (isFrom === "isFromOPBill") {
                  setCachevalue(JSON.stringify(true), 'IsFromOPBill')
                }
                setCachevalue(this.state.patientDetails?.patient_id, 'OP_CreateAppointment_PatientId')
                this.props.history.push({ pathname: `/${investigationName}Home/NewQuickBilling` })
              }
            })
          }
        }).catch((error) => {
          this.lodaerFunction(false)
          this.errorMessage(error?.response?.data?.message || error.message)
        })
    } catch (error) {
      this.lodaerFunction(false)
      this.errorMessage(error.message)
    }
  }

  radiologyPatientSearch() {
    try {
      let { t } = this.props;
      let clinicId = this.state.loggedInuserInfo?.clinic_id
      let API_URL = ''
      this.isPatientisSearching(true)
      var DobDate = new Date(this.state.FilterDob)
      var date = this.state.FilterDob ? DateTime.fromJSDate(DobDate).toFormat('yyyy-MM-dd') : ""
      API_URL = Serviceurls.FO_PATIENT_SEARCH + `?search_key=${this.state.PatientNameSearchKey}&address_key=${this.state.PatientAddressKey}&father_husband_key=${this.state.PatientFathHusKey}&mother_name_key=${this.state.PatientMotherKey}&uhid=${this.state.FilterUHID}&dob=${date}&clinic_id=${clinicId}`
      RestAPIService.getAll(API_URL)
        .then((response) => {
          if (response.data.status === "success") {
            this.isPatientisSearching(false)
            this.setState({
              searchPatientRadiologyList: response.data.data,
            }, () => {
              if (this.state.PatientNameSearchKey !== "" || this.state.PatientAddressKey !== "" || this.state.PatientFathHusKey !== "" || this.state.PatientMotherKey !== "" || this.state.FilterDob !== null || this.state.FilterUHID !== "") {
                if (response.data.data?.length > 0) {
                  this.setState({ PatientSearchClicked: true, AddressFilterClicked: false })
                } else {
                  this.isPatientisSearching(false)
                  this.errorMessage(t("NoRecordsFound"))
                }
              }
            })
          }
          else {
            this.isPatientisSearching(false)
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.errorMessage(error?.response?.data?.message || error.message)
          this.isPatientisSearching(false)
        })
    }
    catch (e) {
      this.isPatientisSearching(false)
      this.errorMessage(e.message)
    }
  }

  RadiologyHeaderSearch = () => {
    const { t } = this.props;
    const myUser = JSON.parse(localGetItem("loggedInUserInfo"))
    const module_name = myUser?.module_name
    return (
      <Box sx={{ marginLeft: '3.2vw' }}>
        <Box component={'div'} display={'flex'} flexDirection={'row'} sx={{ borderRadius: "0.3vw" }}>
          {(module_name === "Radiology" || module_name === "Investigation") ?
            <PatientHeaderSearch
              t={this.props.t}
              isLoading={this.state.isPatientisSearching}
              filterVisible={this.state.PatientAddressKey === "" &&
                this.state.PatientFathHusKey === "" &&
                this.state.PatientMotherKey === "" &&
                this.state.FilterDob === null &&
                this.state.FilterUHID === ""}
              flterOpen={this.handleFilterOpen}
              faceOpen={this.handleFaceOpen}
              module_name={module_name}
              faceVisible={this.state.isfaceRecognizationEnabled}
              onSearchSubmit={this.handleSearchSubmit}
              onClear={this.handleSearchClear}
              searchValue={this.state.PatientNameSearchKey}
            /> : null}
        </Box>
        <Menu
          open={this.state.PatientSearchClicked}
          className="eMed_rad_header_search"
          disableAutoFocus
          disableEnforceFocus
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          MenuListProps={{
            autoFocus: false
          }}
          onClose={() => {
            this.setState({
              PatientSearchClicked: false,
              PatientAddressKey: "",
              PatientFathHusKey: "",
              FilterDob: null,
              FilterUHID: "",
              FilterIP: "",
              FilterOP: "",
            })
          }}
        >
          {
            this.state.searchPatientRadiologyList?.length > 0 ?
              this.state.searchPatientRadiologyList?.map((list) => {
                let PatientFullName = `${list.first_name} ${list.last_name}`
                list["patient_name"] = PatientFullName
                list["patient_mobile_number"] = list.mobile_number
                list["patient_photo_url"] = list.photo_url
                return (
                  <Box>
                    <Box className="eMed_Header_Search_item">
                      <CommonPatientDetails data={list} fromSearch={true} />
                      {<Box component={'div'} className="eMed_Header_Search_icons">
                        <Tooltip title={t("EditPatientDetails")} arrow>
                          <IconButton emed_tid='rad_app_lst_edt_btn' onClick={() => {
                            this.setState({
                              PatientNameSearchKey: "",
                              PatientAddressKey: "",
                              PatientFathHusKey: "",
                              FilterDob: null,
                              FilterUHID: "",
                              PatientSearchClicked: false,
                              SearchedPatientList: []
                            }, () => {
                              this.getRadiologyPatientData(list?.patient_id, 'update')
                            })
                          }}
                            position="end">
                            <Edit color='primary' />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title={t("CreateAppointment")} arrow>
                          <IconButton emed_tid='rad_app_crte_btn' onClick={() => {
                            this.setState({
                              PatientNameSearchKey: "",
                              PatientAddressKey: "",
                              PatientFathHusKey: "",
                              FilterDob: null,
                              FilterUHID: "",
                              PatientSearchClicked: false,
                              SearchedPatientList: []
                            }, () => {
                              this.getRadiologyPatientData(list?.patient_id)
                            })
                          }}
                            position="end">
                            <PersonAddAlt1Icon color='primary' />
                          </IconButton>
                        </Tooltip>
                      </Box>}
                    </Box>
                    <Divider />
                  </Box>
                )
              }) : null
          }
        </Menu>
        <Menu
          open={this.state.AddressFilterClicked}
          className="eMed_Header_Filter_Pop"
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          onClose={() => {
            this.setState({ AddressFilterClicked: false })
          }}
        >
          {this.DynamicFilterFeilds(true)}
        </Menu>
      </Box>
    )
  }

  PharmaPatientSearch() {
    try {
      const UserData = JSON.parse(localGetItem("loggedInUserInfo"))
      let { t } = this.props;
      this.isPatientisSearching(true)
      RestAPIService.getAll(Serviceurls.FO_PATIENT_SEARCH + `?search_key=${CommonValidation.removeSpace(this.state.pharmaNameSearchKey)}`)
        .then((response) => {
          if (response.data.status === "success") {
            this.setState({
              pharmaPatientList: response.data.data,
              common_uhid: response?.data?.common_uhid,
            }, () => {
              this.isPatientisSearching(false)
              if (CommonValidation.removeSpace(this.state.pharmaNameSearchKey) !== "") {
                if (response.data.data.length > 0) {
                  this.setState({ pharmaSearchClicked: true })
                } else {
                  this.errorMessage(t("NoRecordsFound"))
                }
              }
            })
          }
          else {
            this.isPatientisSearching(false)
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.isPatientisSearching(false)
          this.errorMessage(error.response.data.message || error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  PharmaheaderSearch = () => {
    const { t } = this.props;
    var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
    var UserData = myUser
    return (
      <Box sx={{ marginLeft: '3.2vw' }}>
        <Box component={'div'} display={'flex'} flexDirection={'row'} sx={{ borderRadius: "0.3vw" }}>
          {UserData?.module_name !== "nurse" ?
            <PatientHeaderSearch
              t={this.props.t}
              module_name={"Pharmacy"}
              isLoading={this.state.isPatientisSearching}
              onSearchSubmit={this.handleSearchSubmit}
              onClear={this.handleSearchClear}
              searchValue={this.state.pharmaNameSearchKey}
            />
            : null}
        </Box>
        <Menu
          open={this.state.pharmaSearchClicked}
          className="eMed_pharmaHeader_Search_Pop"
          disableAutoFocus
          disableEnforceFocus
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          MenuListProps={{
            autoFocus: false
          }}
          onClose={() => {
            this.setState({
              pharmaSearchClicked: false,
            })
          }}
        >
          {

            this.state.pharmaPatientList?.length > 0 ?
              this.state.pharmaPatientList?.map((list) => {
                let PatientFullName = `${list.first_name} ${list.last_name}`
                list["patient_name"] = PatientFullName
                list["patient_mobile_number"] = list.mobile_number
                list["patient_photo_url"] = list.photo_url
                return (
                  <Box>
                    <Box className="eMed_Header_Search_item" width={"28vw"}>
                      <CommonPatientDetails data={list} fromSearch={true} isCommonUhid={this.state.common_uhid} />
                      <Box component={'div'} className="eMed_Header_Search_icons">
                        <Tooltip title={t('CreateBill')} placement='top' arrow>
                          <IconButton size='small' variant='contained' onClick={() => {
                            this.setState({
                              pharmaNameSearchKey: "",
                              pharmaSearchClicked: false,
                              pharmaPatientList: [],
                              common_uhid: false,
                            }, () => {
                              this.props.history.push({
                                pathname: "/PharmacyBilling",
                                state: { Patient_ID: list?.patient_id, showHistory: true }
                              })
                            })
                          }}
                            position="end">
                            <img style={{ width: '1.5vw', height: '1.5vw' }} src={ImagePaths.BillCreated.default} />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </Box>
                  </Box>
                )
              }) : null
          }
        </Menu>
      </Box>
    )
  }

  DynamicFilterFeilds = (FromRadiology = false) => {
    let LoggedData = JSON.parse(localGetItem("loggedInUserInfo"))
    let FeildData = LoggedData?.header_filter_fields ? LoggedData?.header_filter_fields : JSON.parse(JSON.stringify(Header_Filter_Fields))
    return (
      <Box className="eMed_Header_Filter_item" sx={{ height: 'auto' }}>
        {
          FeildData?.map((list) => {
            if (list?.is_checked) {
              return this.returnHeaderFilds(list?.value)
            }
          })
        }
        <Box component={'div'} display='flex' flexDirection='row' justifyContent={'center'}  >
          <Button id="eMed_Config_btn" variant='contained' size='small' disabled={(this.state.PatientAddressKey === "" && this.state.PatientFathHusKey === "" && this.state.PatientMotherKey === "" && this.state.FilterUHID === "" && ((window.location.pathname === "/DoctorHome" || window.location.pathname === "/OPHome") ? this.state.FilterOP === "" : this.state.FilterIP === "") && this.state.FilterDob === null) || (this.state.FilterDob !== null && isNaN(Date.parse(this.state.FilterDob))) || (this.state.error || this.state.errorFathhus) || (this.state.isPatientisSearching)} onClick={() => {
            if (FromRadiology) {
              this.radiologyPatientSearch()
            } else {
              (window.location.pathname === "/DoctorHome") ? this.DoctorPatientSearch() : this.FOPatientSearch()
            }
          }}>Search</Button>
          <Button id="eMed_Config_btn" variant='outlined' size='small' sx={{ marginLeft: "2vw" }} onClick={() => { this.setState({ PatientAddressKey: "", PatientFathHusKey: "", PatientMotherKey: "", error: false, errorFathhus: false, FilterDob: null, FilterUHID: "", FilterOP: "", FilterIP: "" }) }}>Clear</Button></Box>
      </Box>
    )
  }

  returnHeaderFilds = (value) => {
    const { t } = this.props;
    switch (value) {
      case "address": return <TextField
        sx={{ marginY: "0.5vw" }}
        label={t("SearchByAddress")}
        inputProps={{ maxLength: 50 }}
        autoComplete='off'
        size='small'
        value={this.state.PatientAddressKey}
        onChange={(e) => { this.setState({ PatientAddressKey: e.target.value }) }}
        onKeyDown={(e) => e.stopPropagation()} />
      case "father husband name": return <TextField
        sx={{ marginY: "0.5vw" }}
        label={t("SearchByFatherHusbandName")}
        inputProps={{ maxLength: 50 }}
        autoComplete='off'
        size='small'
        value={this.state.PatientFathHusKey}
        onChange={(e) => {
          var isSpecial = /^[ A-Za-z.,/]*$/.test(e.target.value)
          if (isSpecial) {
            this.setState({ PatientFathHusKey: e.target.value, errorFathhus: false, error: false })
          } else {
            // this.setState({ errorFathhus: true, error: false })
          }
        }}
        // error={this.state.errorFathhus}
        // helperText={this.state.errorFathhus ? "Enter Only Alphabets" : null}
        onKeyDown={(e) => e.stopPropagation()} />
      case "dob": return <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          value={this.state.FilterDob}
          name={"datePicker"}
          inputFormat='DD-MM-YYYY'
          views={["year", "month", "day"]}
          maxDate={new Date()}
          onChange={
            (newDate) => {
              this.setState({
                FilterDob: newDate,
              });
            }}
          renderInput={(params) => <TextField size='small' sx={{ marginY: "0.5vw" }} {...params} label={"Date of Birth"} />}
        />
      </LocalizationProvider>
      case "mother name": return <TextField
        sx={{ marginY: "0.5vw" }}
        label={t("Search By Mother Name")}
        autoComplete='off'
        inputProps={{ maxLength: 50 }}
        size='small'
        value={this.state.PatientMotherKey}
        onChange={(e) => {
          var isSpecial = /^[ A-Za-z.,/]*$/.test(e.target.value)
          if (isSpecial) {
            this.setState({ PatientMotherKey: e.target.value })
          } else {
            // this.setState({ errorFathhus: true, error: false })
          }
        }}
        onKeyDown={(e) => e.stopPropagation()} />
      case "uhid": return <TextField
        sx={{ marginY: "0.5vw" }}
        label={t("Search By UHID")}
        autoComplete='off'
        inputProps={{ maxLength: 20 }}
        size='small'
        value={this.state.FilterUHID}
        onChange={(e) => { this.setState({ FilterUHID: e.target.value }) }}
        onKeyDown={(e) => e.stopPropagation()} />
      case "op_ip_number":
        return (
          <TextField
            sx={{ marginY: "0.5vw" }}
            label={
              t((window.location.pathname === "/OPHome" || window.location.pathname === "/DoctorHome") ?
                "Search By OP Appointment Id" : "Search By IP Adminssion Id")
            }
            autoComplete="off"
            inputProps={{ maxLength: 50 }}
            size="small"
            value={
              (window.location.pathname === "/OPHome" || window.location.pathname === "/DoctorHome")
                ? this.state.FilterOP
                : this.state.FilterIP
            }
            onChange={(e) =>
              this.setState(
                (window.location.pathname === "/OPHome" || window.location.pathname === "/DoctorHome")
                  ? { FilterOP: e.target.value }
                  : { FilterIP: e.target.value }
              )
            }
            onKeyDown={(e) => e.stopPropagation()}
          />
        );
      default: break;
    }
  }

  DoctorPatientSearch(DocRequest = false, MobNum = null) {
    try {
      let { t } = this.props;
      let API_URL = ''
      if (DocRequest) {
        API_URL = Serviceurls.FO_PATIENT_SEARCH + `?search_key=${MobNum}&address_key=&father_husband_key=&clinic_id=${this.state.SelectedDoctorClinic}&address=true`
        this.AppointMobileSrch(true);
      } else {
        var DobDate = new Date(this.state.FilterDob)
        var date = this.state.FilterDob ? DateTime.fromJSDate(DobDate).toFormat('yyyy-MM-dd') : ""
        API_URL = Serviceurls.FO_PATIENT_SEARCH + `?search_key=${this.state.PatientNameSearchKey}&address_key=${this.state.PatientAddressKey}&father_husband_key=${this.state.PatientFathHusKey}&clinic_id=${this.state.SelectedDoctorClinic}&mother_name_key=${this.state.PatientMotherKey}&uhid=${this.state.FilterUHID}&dob=${date}&op_number=${this.state.FilterOP}`
        this.isPatientisSearching(true)
      }
      RestAPIService.getAll(API_URL).
        then((response) => {
          if (response.data.status === "success") {
            if (DocRequest) {
              this.setState({
                docSearchedRequestPatientList: response.data.data,
                docRequestPatientMenuPop: response.data.data.length > 0 ? true : false
              })
            } else {
              this.setState({
                SearchDoctorPatientList: response.data.data,
              }, () => {
                if (this.state.PatientNameSearchKey !== "" || this.state.PatientAddressKey !== "" || this.state.PatientFathHusKey !== "" || this.state.PatientMotherKey !== "" || this.state.FilterDob !== null || this.state.FilterUHID !== "" || this.state.FilterOP !== "") {
                  if (response.data.data?.length > 0) {
                    this.setState({ PatientSearchClicked: true, AddressFilterClicked: false })
                  } else {
                    this.errorMessage(t("NoRecordsFound"))
                  }
                }
              })
            }
            this.isPatientisSearching(false)
            this.AppointMobileSrch(false);
          }
          else {
            this.isPatientisSearching(false)
            this.AppointMobileSrch(false);
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.errorMessage(error?.response?.data?.message || error?.message)
          this.isPatientisSearching(false)
          this.AppointMobileSrch(false);
        })
    }
    catch (e) {
      this.isPatientisSearching(false)
      this.AppointMobileSrch(false);
      this.errorMessage(e.message)
    }
  }

  getJMODoctor = () => {
    try {
      RestAPIService.getAll(Serviceurls.JMO_DOCTOR_LIST_GET)
        .then((response) => {
          if (response.data.status === "success") {
            this.setState({
              ClinicList: response.data.data || []
            }, () => {
              if (!localGetItem('JMODoctor')) {
                this.setState({
                  SelectedDoctorClinic: response?.data?.data[0]?.id
                }, () => {
                  localSetItem('JMODoctor', response?.data?.data[0]?.id)
                  setCachevalue(response?.data?.data[0]?.id, "SelectedDoctorID")
                  setCachevalue(response?.data?.data[0]?.id, "SelectedDoctorClinic")
                  localSetItem('ServiceType', response?.data?.data[0]?.service_type)
                  localSetItem('regNo', response?.data?.data[0]?.registration_number)
                  this.ChangeLoginTokken(response?.data?.data[0]?.id)
                })
              }
            })
          }
          else {
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  ChangeLoginTokken = (DoctorId) => {
    try {
      var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
      var BranchId = localGetItem("BranchId") ? JSON.parse(localGetItem("BranchId")) : null
      let APiUrl = Serviceurls.MODULES_DATA_GET + "?linked_modules=JMO" + "&id=" + myUser?.clinic_staff_id + "&clinic_id=" + null + "&branch_id=" + BranchId + "&doctor_id=" + DoctorId
      RestAPIService.LoginAuthGetModules(APiUrl)
        .then((response) => {
          if (response.data.status === 'success') {
            localSetItem("AccessToken", response.data.data.token);
            localSetItem('SelectedDoctorClinicId', response.data.data.clinic_id)
            setCachevalue(this.state.SelectedDoctorClinic === 'all' ? myUser?.clinic_id : DoctorId, "SelectedDoctorClinic")
            // if (localGetItem("enable_other_doctor_list") === 'true' && window.location.pathname === "/DoctorHome") {
            //   this.fetchMultiDoctorOption(response.data.data.clinic_id)
            // } if (FromMultiDoctor && DoctorId?.module_name === "counsellor") {
            //   this.props.history.push({ pathname: "/Counsellor" });
            // } else {
            this.props.history.push({ pathname: (window.location.pathname === "/IPDoctorHome" ? "/IPDoctorHome" : "/DoctorHome"), state: { SelectedDoctorClinic: DoctorId } })
            // }
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }


  getDoctorsList(ForRequest = false) {
    try {
      let API_URL = ""
      if (ForRequest) {
        var date = new Date(this.state.RequestAppointDatetym)
        var appointment_date = DateTime.fromJSDate(date).toFormat('yyyy-MM-dd')
        API_URL = Serviceurls.FO_CONFIG_OPDOCTORNAME + "?date=" + appointment_date
      }
      RestAPIService.getAll(API_URL).
        then((response) => {
          if (response.data.status === "success") {
            if (ForRequest) {
              this.setState({
                doctorList: response.data.data.filter((item) => (item.specialization_active === true))
              })
            }
          }
          else {
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  getNotificationData = () => {
    try {
      const userInfo = JSON.parse(localGetItem("loggedInUserInfo"));
      const is_credit_followup = JSON.parse(localGetItem('set_due_date_for_credit_billing')) || false;
      const moduleName = userInfo?.module_name;
      this.setState({ isNotifyLoader: true })
      RestAPIService.getAll(Serviceurls.FO_NOTIFICATION_GET + `?date=${DateTime.fromJSDate(new Date(this.state.datePicker)).toFormat('yyyy-MM-dd')}&module_type=${module_typeObj[moduleName] ?? GetInvestigationName()?.toLowerCase() ?? ""}`)
        .then((response) => {
          if (response?.data?.status === "success") {
            let data = response.data.data;
            const isArray = Array.isArray(data);
            const path = window.location.pathname;
            const typeMap = {
              "/IPHome": "IP",
              "/OPHome": "OP"
            };

            const creditData = data?.credit_due || [];

            const filteredData = typeMap[path]
              ? creditData?.filter(item => item.patient_type === typeMap[path])
              : creditData;

            data = isArray ? data : { ...data, ...(creditData.length > 0 ? { credit_due: filteredData } : {}) }

            this.setState({
              FoNotifyList: data,
              isNotifyLoader: false,
              notifyCount: isArray
                ? (data?.length || 0)
                : (
                  (Array.isArray(data?.doctor_info) ? data?.doctor_info.length : 0) +
                  ((Array.isArray(data?.credit_due) && is_credit_followup) ? data?.credit_due.length : 0) +
                  (Array.isArray(data?.outsource_test_due) ? data?.outsource_test_due.length : 0)
                )
            })
          }
        }).catch((error) => {
          this.setState({ isNotifyLoader: false })
          this.errorMessage(error.response?.data?.message || error?.message)
        })
    } catch (e) {
      this.setState({ isNotifyLoader: false })
      this.errorMessage(e?.message)
    }
  }

  getAppointRequests(Clicked = false) {
    try {
      let DocId = this.state.App_DocID?.doctor_id ? this.state.App_DocID?.doctor_id : ''
      RestAPIService.getAll(Serviceurls.FO_APPOINT_REQUESTS + "?date=" + DateTime.fromJSDate(new Date(this.state.datePicker)).toFormat('yyyy-MM-dd') + '&doctor_id=' + DocId).
        then((response) => {
          if (response.data.status === "success") {
            const Data = response.data.data ? response.data.data?.map((item, idx) => ({
              ...item,
              sno: idx + 1,
            })) : []
            this.setState({
              FoRequestList: Data,
              duplicateFoReqList: Data,
              // SelectedRequestTab: "appointment_request",
            }, () => {
              if (this.state.patientSearch) {
                this.handlePatientSearch()
              }
              // if (Clicked && response.data.data.length === 0) {
              //   this.errorMessage("No Records To Be Shown")
              // }
            })
          }
          else {
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
      if (Clicked) {
        RestAPIService.getAll(Serviceurls.FO_CONFIG_OPSPECIALIZATION)
          .then(response => {
            if (response.data.status === "success") {
              this.setState({
                spcInfo: response.data.data.filter((item) => (item.is_active === true)),
              });
            }
          })
          .catch(error => {

          });
        this.getDoctorsList(true)
      }
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  getDoctorQueueData = () => {
    try {
      RestAPIService.getAll(Serviceurls.FO_DOC_QUEUE_GET + `?appointment_date=${DateTime.fromJSDate(new Date(this.state.datePicker))?.toFormat('yyyy-MM-dd')}`)
        .then((response) => {
          if (response?.data?.status === "success") {
            this.setState({
              drQueueData: response.data.data ? response.data.data : []
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response?.data?.message)
          } else {
            this.errorMessage(error?.message)
          }
        })
    } catch (e) {
      this.errorMessage(e?.message)
    }
  }

  CreateAppointRequest(fromDoctor = false) {
    try {
      const { t } = this.props;
      var states = this.state;
      if ((states?.RequestMobileNumber.length === 10 && CommonValidation.numberOnly(states?.RequestMobileNumber) && CommonValidation.removeSpace(states?.RequestPatientName) != "") ||
        (states?.docRequestMobileNumber.length === 10 && CommonValidation.numberOnly(states?.docRequestMobileNumber) && CommonValidation.removeSpace(states?.docRequestPatientName) !== "")) {
        var AptDateTime = states.RequestAppointDatetym ? new Date(states.RequestAppointDatetym) : new Date(states.RequestAppointDatetym)
        var DocAptDateTime = states.docRequestAppointDatetym ? new Date(states.docRequestAppointDatetym) : new Date(states.docRequestAppointDatetym)
        var AptDate = DateTime.fromJSDate(AptDateTime).toFormat('yyyy-MM-dd')
        var DocAptDate = DateTime?.fromJSDate(DocAptDateTime)?.toFormat('yyyy-MM-dd')
        var Aptime = DateTime.fromJSDate(AptDateTime).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
        var DocAptime = DateTime?.fromJSDate(DocAptDateTime)?.toLocaleString(DateTime.TIME_24_WITH_SECONDS);
        let data = {}
        if (fromDoctor) {
          let clinicId = localGetItem('SelectedDoctorClinicId')
          data = {
            "patient_name": CommonValidation.removeSpace(states?.docRequestPatientName),
            "patient_id": states?.docSelectedRequestPatient?.patient_id ? states?.docSelectedRequestPatient?.patient_id : states?.doceditPatientId ? states?.doceditPatientId : null,
            "doctor_id": states?.docRequestSelectedDocID?.doctor_id ? states?.docRequestSelectedDocID?.doctor_id : null,
            "mobile": states?.docRequestMobileNumber,
            "reason": states?.docRequestpurposeOfVisit ? states?.docRequestpurposeOfVisit : "",
            "appointment_date": DocAptDate,
            "appointment_time": DocAptime,
            'clinic_id': clinicId,
            "address_line_1": states.address_1 === null ? "" : CommonValidation.removeSpace(states.address_1),
            "address_line_2": states.address_2 === null ? "" : CommonValidation.removeSpace(states.address_2),
            "city_name": states.city === null ? "" : CommonValidation.removeSpace(states.city),
            "state_name": states.state_code === null ? "" : CommonValidation.removeSpace(states.AllStates.find((item) => (item.isoCode === states.state_code))?.name),
            "country": states.country_code === null ? "" : CommonValidation.removeSpace(states.AllCountry.find((item) => (item.isoCode === states.country_code))?.name),
            "pincode": states.pin_code === null ? "" : CommonValidation.removeSpace(states.pin_code),
            "speciality_id": states.docRequestSelectedSpecID?.id ? states.docRequestSelectedSpecID?.id : null,
            "gender": states.docRequestPatientGender ? states.docRequestPatientGender : null,
          }
          if (this.state.doceditAppointmentId) {
            data["id"] = states?.doceditAppointmentId
            data["age"] = states?.docRequestPatientAge === "" ? null : states?.docRequestPatientAge
          } else {
            data["age"] = states?.docRequestPatientAge ? states?.docRequestPatientAge : null
          }
        } else {
          let AgeKey = typeof states?.RequestPatientAge === "string" ? states?.RequestPatientAge?.includes("Y") ? states?.RequestPatientAge : (states?.RequestPatientAge ? (states?.RequestPatientAge + "Y") : null) : (states?.RequestPatientAge ? (states?.RequestPatientAge + "Y") : null);
          data = {
            "patient_name": CommonValidation.removeSpace(states?.RequestPatientName),
            "patient_id": states?.SelectedRequestPatient?.patient_id ? states?.SelectedRequestPatient?.patient_id : states?.editPatientId ? states?.editPatientId : null,
            "doctor_id": states?.RequestSelectedDocID?.doctor_id ? states?.RequestSelectedDocID?.doctor_id : null,
            "mobile": states?.RequestMobileNumber,
            "reason": states?.RequestpurposeOfVisit ? states?.RequestpurposeOfVisit : "",
            // "age": states?.SelectedRequestPatient?.patient_id ? null : states?.RequestPatientAge ? states?.RequestPatientAge?.replace('Y', '') : null,
            "age": AgeKey === "" ? null : AgeKey,
            "appointment_date": AptDate,
            "appointment_time": Aptime,
            "address_line_1": states.address_1 === null ? "" : CommonValidation.removeSpace(states.address_1),
            "address_line_2": states.address_2 === null ? "" : CommonValidation.removeSpace(states.address_2),
            "city_name": states.city === null ? "" : CommonValidation.removeSpace(states.city),
            "state_name": states.state_code === null ? "" : CommonValidation.removeSpace(states.AllStates.find((item) => (item.isoCode === states.state_code))?.name),
            "country": states.country_code === null ? "" : CommonValidation.removeSpace(states.AllCountry.find((item) => (item.isoCode === states.country_code))?.name),
            "pincode": states.pin_code === null ? "" : CommonValidation.removeSpace(states.pin_code),
            "speciality_id": states.RequestSelectedSpecID?.id ? states.RequestSelectedSpecID?.id : null,
            "gender": states.RequestPatientGender ? states.RequestPatientGender : null,
          }
          if (this.state.editAppointmentId) {
            data["id"] = states?.editAppointmentId
          }
        }
        RestAPIService.create(data, Serviceurls.FO_TELE_APPOINTMENT_REQUEST)
          .then((response) => {
            if (response.data.status === "success") {
              this.successMessage(response.data.message)
              this.setState({ SelectedRequestTab: "appointment_request" })
              if (fromDoctor) {
                this.getDoctorAppointmentList(true)
                this.docClearRequestData()
              } else {
                this.props.history.push({ pathname: "/OPHome", state: { NewAppointmentCreated: true, NewMessage: response?.data?.message } })
                this.getAppointRequests()
                this.ClearRequestData()
              }
            }
          }).catch((e) => {
            if (e?.response?.data?.message) {
              this.setState({ isClked: false })
              this.errorMessage(e.response.data.message)
            } else {
              this.setState({ isClked: false })
              this.errorMessage(e.message)
            }
          })
      } else {
        this.setState({ isClked: false }, () => {
          if (states?.RequestMobileNumber === "") {
            this.errorMessage("Enter Mobile Number")
          }
          // else if ((!CommonValidation.removeSpace(states?.RequestPatientAge)) || (fromDoctor && !CommonValidation.removeSpace(states?.docRequestPatientAge))) {
          //   this.errorMessage("Enter Patient Age")
          // }
          else if (CommonValidation.numberOnly(states?.RequestMobileNumber) && states?.RequestMobileNumber.length !== 10) {
            this.errorMessage("Mobile Number Must be in 10 Digits")
          }
          else if (!CommonValidation.numberOnly(states?.RequestMobileNumber) && Object.keys(this.state.SelectedRequestPatient).length === 0) {
            this.errorMessage("Invaild Mobile Number")
          }
          else if (CommonValidation.removeSpace(states?.RequestPatientName) === "") {
            this.errorMessage("Enter Patient Name")
          }
        })
      }
    }
    catch (e) {
      this.setState({ isClked: false })
      this.errorMessage(e.message)
    }
  }

  ClearRequestData() {
    this.setState({
      RequestPatientName: "",
      RequestMobileNumber: "",
      SelectedRequestPatient: {},
      RequestSelectedDocID: null,
      RequestSelectedSpecID: null,
      RequestPatientAge: "",
      RequestAppointDatetym: new Date(),
      RequestpurposeOfVisit: "",
      filteredDocList: [],
      editAppointmentId: null,
      editPatientId: null,
      isClked: false,
      patientSearch: '',
      address_1: "",
      address_2: "",
      city: "",
      cityName: City.getCitiesOfState("IN", "TN"),
      country_code: 'IN',
      state_code: 'TN',
      AllCountry: Country.getAllCountries(),
      AllStates: State.getStatesOfCountry("IN"),
      pin_code: "",
      RequestPatientMenuPop: false,
      RequestPatientListAnchor: null,
      SearchedRequestPatientList: [],
      RequestPatientDOB: null,
      RequestPatientGender: "",
    }, () => {
      let city_name = localGetItem('city_name')
      let state_name = localGetItem('state_name')
      let List = State.getAllStates()?.find(item => item?.name?.toLowerCase() === state_name?.toLowerCase())
      let stateList = State.getStatesOfCountry(List?.countryCode)
      let cityList = City.getCitiesOfState(List?.countryCode, List?.isoCode)
      this.setState({ city: city_name, state_code: List?.isoCode, AllStates: stateList, cityName: cityList })
    })
  }

  docClearRequestData() {
    this.setState({
      docRequestPatientName: "",
      docRequestMobileNumber: "",
      docSelectedRequestPatient: {},
      docRequestSelectedDocID: null,
      docRequestSelectedSpecID: null,
      docRequestPatientAge: "",
      docRequestAppointDatetym: new Date(),
      docRequestpurposeOfVisit: "",
      docfilteredDocList: [],
      doceditAppointmentId: null,
      doceditPatientId: null,
      isClked: false,
      docDatePicker: new Date(),
      patientSearch: '',
      App_DocID: null,
      address_1: "",
      address_2: "",
      city: "",
      cityName: City.getCitiesOfState("IN", "TN"),
      country_code: 'IN',
      state_code: 'TN',
      AllCountry: Country.getAllCountries(),
      AllStates: State.getStatesOfCountry("IN"),
      pin_code: "",
      docRequestPatientMenuPop: false,
      docRequestPatientListAnchor: null,
      docSearchedRequestPatientList: [],
      docRequestPatientDOB: null,
      docRequestPatientGender: "",
    }, () => { this.getDoctorAppointmentList() })
  }

  handleCheckBox = (e, key) => {
    var states = this.state
    states[key] = e.target.checked
    this.setState({ states }, () => {
      switch (key) {
        case 'booked':
          this.setState({
            booked: e.target.checked, all: false
          }, () => { this.checkallfunc() })
          break;
        case 'arrived':
          this.setState({
            arrived: e.target.checked, all: false
          }, () => { this.checkallfunc() })
          break;
        case 'withDoctor':
          this.setState({
            withDoctor: e.target.checked, all: false
          }, () => { this.checkallfunc() })
          break;
        case 'withNurse':
          this.setState({
            withNurse: e.target.checked, all: false
          }, () => { this.checkallfunc() })
          break;
        case 'cancelled':
          this.setState({
            cancelled: e.target.checked, all: false
          }, () => { this.checkallfunc() })
          break;
        case 'completed':
          this.setState({
            completed: e.target.checked, all: false
          }, () => { this.checkallfunc() })
          break;
        case 'all':
          this.setState({
            all: this.state.all
          }, () => {
            this.setState({
              booked: this.state.all, arrived: this.state.all, withDoctor: this.state.all,
              completed: this.state.all, cancelled: this.state.all, withNurse: this.state.all
            })
          })
          break;
        default:
          if (states.booked && states.arrived && states.withDoctor && states.completed && states.cancelled && states.withNurse) {
            this.setState({
              all: true
            })
          } else {
            this.setState({
              all: true, booked: true, arrived: true, withDoctor: true,
              completed: true, cancelled: true, withNurse: true
            })
          }
          break;
      }

      if (key === 'fullReport') {
        this.setState({
          fullReport: e.target.checked, symptoms: true,
          allergies: true, vitals: true,
          examination: true, diagnosis: true,
          prescription: true, prevPrescrip: true,
          test: true, plan: true,
          counselling: true, generalPatient: true
        }, () => {
          if (this.state.fullReport) {
            this.setState({
              fullReport: e.target.checked, symptoms: true,
              allergies: true, vitals: true,
              examination: true, diagnosis: true,
              prescription: true, prevPrescrip: true,
              test: true, plan: true,
              counselling: true, generalPatient: true
            })
          } else {
            this.setState({
              fullReport: false, symptoms: false,
              allergies: false, vitals: false,
              examination: false, diagnosis: false,
              prescription: false, prevPrescrip: false,
              test: false, plan: false,
              counselling: false, generalPatient: false
            })
          }
        })
      } else {
        if (states.symptoms && states.allergies && states.vitals && states.examination && states.diagnosis && states.prescription && states.test && states.plan && states.generalPatient && states.counselling) {
          this.setState({ fullReport: true })
        } else {
          this.setState({ fullReport: false })
        }
      }
    })
  }

  checkallfunc() {
    if (this.state.booked && this.state.arrived && this.state.withDoctor && this.state.completed && this.state.cancelled && this.state.withNurse) {
      this.setState({
        all: true
      })
    }
  }

  renderAppointmentReqTbl = (list, from = "request", height, width) => {
    const { t } = this.props;
    const columns = [
      {
        field: 'created_date', headerName: 'Req Date & Time', flex: 0.16,
        renderCell: ({ row }) => {
          return (
            <Box>
              <Typography fontWeight={'600'} fontSize={"0.85vw"}>{row?.created_date ? formatDate(row.created_date) : "-"}</Typography>
              <Typography fontSize={"0.7vw"}>{row?.created_time || '-'}</Typography>
            </Box>
          )
        },
        valueGetter: (params) => {
          return new Date(`${params.row.created_date} ${params.row.created_time || "00:00"}`);
        },
      },
      {
        field: 'appointment_date', headerName: 'App Date & Time', flex: 0.16,
        renderCell: ({ row }) => {
          return (
            <Box>
              <Typography fontWeight={'600'} fontSize={"0.85vw"}>{row?.appointment_date ? formatDate(row.appointment_date) : "-"}</Typography>
              <Typography fontSize={"0.7vw"}>{row?.appointment_time}</Typography>
            </Box>
          )
        },
        valueGetter: (params) => {
          return new Date(`${params.row.appointment_date} ${params.row.appointment_time || "00:00"}`);
        },
      },
      {
        field: 'first_name', headerName: 'Patient Details', flex: 0.20,
        renderCell: ({ row }) => {
          const PatientName = row.first_name + " " + row.last_name;
          return (
            <Box>
              <Typography fontWeight={'600'} fontSize={"0.85vw"}>
                {PatientName ? PatientName?.length > 20 ?
                  <Tooltip placement='top' title={PatientName} arrow>
                    <div>{PatientName.slice(0, 20) + "..."}</div></Tooltip> :
                  PatientName : "-"}
              </Typography>
              {(row?.mobile_number || row?.patient_account_number) ?
                <Typography fontSize={"0.7vw"}>{row.mobile_number} | {row.patient_account_number ? row.patient_account_number : "-"}</Typography> : null}
            </Box>
          )
        },
        valueGetter: (params) => {
          return `${params.row.first_name ?? ""} ${params.row.last_name ?? ""}`.trim().toLowerCase();
        },
      },
      {
        field: 'doctor_name', headerName: 'Clinic / Hospital', flex: 0.16,
        renderCell: ({ row }) => {
          return (
            <Box>
              {row?.doctor_name ? row?.doctor_name?.length > 20 ?
                <Tooltip placement='top' title={row?.doctor_name} arrow>
                  <div>{row?.doctor_name.slice(0, 20) + "..."}</div></Tooltip> :
                row?.doctor_name : "-"}
              <Typography fontSize={"0.7vw"}>{row?.clinic_name}</Typography>
            </Box>
          )
        },
        valueGetter: (params) => {
          return `${params.row.doctor_name ?? ""} ${params.row.clinic_name ?? ""}`.trim().toLowerCase();
        }
      },
      {
        field: 'booked_through', headerName: 'Source', flex: 0.16, headerAlign: 'center', align: 'center', sortable: false,
        renderCell: ({ row }) => {
          const { title, icon } = bookedThroughObj[row?.booked_through] || bookedThroughObj["Web"];
          return (
            <Box>
              {
                <Tooltip title={t(title)} arrow placement='top'>
                  <img style={{ height: '1.5vw', width: '1.5vw' }} src={icon}></img>
                </Tooltip>
              }
            </Box>
          )
        }
      },
      {
        field: 'action', headerName: 'Action', flex: 0.16, headerAlign: 'center', align: 'center', sortable: false,
        renderCell: ({ row }) => {
          return (
            <>

              {from === "docModule" ? <Box display={'flex'} flexDirection={'row'} alignItems={'center'} justifyContent={'center'}>
                <Tooltip title={t("Edit Appointment")} arrow placement='top'>
                  <IconButton size="small" onClick={() => {
                    // ======> Commented for no doctor and specialization for doctor module
                    // let doctorData = {}, spcData = {};
                    // if (list?.doctor_id) {
                    //   doctorData = this.state.doctorList?.length > 0 ? this.state.doctorList?.find(item => item?.doctor_id === list?.doctor_id) : {};
                    //   spcData = (this.state.spcInfo?.length > 0 && Object.keys(doctorData)?.length > 0) ? this.state.spcInfo?.find(data => data?.id === doctorData?.specialization_id) : {};
                    // }
                    let age = typeof (row?.age) !== "number" ? row?.age?.split("/") : row?.age;

                    this.setState({
                      docSelectedRequestTab: "create_request",
                      doceditAppointmentId: row?.id,
                      doceditPatientId: row?.patient_id,
                      docRequestMobileNumber: row?.mobile_number ? row?.mobile_number : row?.mobile,
                      docRequestPatientName: row?.patient_name ? row?.patient_name : row?.first_name,
                      docRequestPatientAge: age?.length > 0 ? parseInt(age[0]) : age,
                      // docRequestSelectedDocID: Object.keys(doctorData)?.length > 0 ? doctorData : null,
                      // docRequestSelectedSpecID: Object.keys(spcData)?.length > 0 ? spcData : null,
                      docRequestAppointDatetym: row?.appointment_date + row?.appointment_time,
                      docRequestpurposeOfVisit: row?.message,
                      address_1: row?.address_line_1 ? row.address_line_1 : "",
                      address_2: row?.address_line_2 ? row?.address_line_2 : "",
                      country_code: this.state.AllCountry?.find((item) => (item.name === row?.country))?.isoCode,
                      AllStates: State.getStatesOfCountry(this.state.AllCountry?.find((item) => (item.name === row?.country))?.isoCode),
                      state_code: State.getStatesOfCountry(this.state.AllCountry?.find((item) => (item.name === row?.country))?.isoCode)?.find((item) => (item.name === row?.state_name))?.isoCode,
                      city: row?.city_name ? row?.city_name : "",
                      pin_code: row.pincode ? row.pincode : "",
                    })
                  }}
                    position="end">
                    <Edit color='primary' sx={{ height: '1.5vw', width: '1.5vw' }} />
                  </IconButton>
                </Tooltip>
                <Tooltip title={t("Create Appointment")} arrow placement='top'>
                  <IconButton size="small" onClick={() => {
                    // this.postRequest(row, "Approve")
                    this.setState({
                      doctorAppointmentAnchor: null,
                      openDoctorAppointment: false,
                      docDatePicker: new Date()
                    }, () => {
                      if (row?.patient_id) {
                        setCachevalue(JSON.stringify(row), "AppRequestPatientData")
                        this.props.history.push({ pathname: "/DoctorHome/Doctor/Demographics", state: { fromRequest: false, fromCreate: true, patientId: row?.patient_id } })
                        // this.getDoctorPatientDetailData(row?.patient_id, 'Request Create', row)
                      } else {
                        setCachevalue(JSON.stringify(row), "AppRequestPatientData")
                        this.props.history.push({ pathname: "/DoctorHome/Doctor/Demographics", state: { fromCreate: true, fromRequest: true } })
                      }
                    })
                  }}>
                    <CheckCircleIcon sx={{ height: '1.5vw', width: '1.5vw' }} color='primary' />
                  </IconButton>
                </Tooltip>
                <Tooltip title={t("Cancel Request")} arrow placement='top'>
                  <IconButton size="small" onClick={() => { this.postDoctorCancelAppointment(row?.id) }}>
                    <CancelIcon sx={{ height: '1.5vw', width: '1.5vw' }} color='error' />
                  </IconButton>
                </Tooltip>
              </Box>
                : <Box display={'flex'} flexDirection={'row'} justifyContent={'center'} width={'18%'} paddingRight={'0.5vw'}>
                  <Tooltip title={t("Edit Appointment")} arrow placement='top'>
                    <IconButton onClick={() => {
                      let doctorData = {}, spcData = {};
                      if (row?.doctor_id) {
                        doctorData = this.state.doctorList?.length > 0 ? this.state.doctorList?.find(item => item?.doctor_id === row?.doctor_id) : {};
                        spcData = (this.state.spcInfo?.length > 0 && Object.keys(doctorData)?.length > 0) ? this.state.spcInfo?.find(data => data?.id === doctorData?.specialization_id) : {};
                      }
                      let age = typeof (row?.age) !== "number" ? row?.age?.split("/") : row?.age;
                      this.setState({
                        SelectedRequestTab: "create_request",
                        editAppointmentId: row?.id,
                        editPatientId: row?.patient_id,
                        RequestMobileNumber: row?.mobile_number ? row?.mobile_number : row?.mobile,
                        RequestPatientName: row?.patient_name ? row?.patient_name : row?.first_name,
                        RequestPatientAge: age?.length > 0 ? row?.age : age,
                        RequestSelectedDocID: Object.keys(doctorData)?.length > 0 ? doctorData : null,
                        RequestSelectedSpecID: Object.keys(spcData)?.length > 0 ? spcData : null,
                        RequestAppointDatetym: row?.appointment_date + row?.appointment_time,
                        RequestpurposeOfVisit: row.message,
                        address_1: row?.address_line_1 ? row?.address_line_1 : "",
                        address_2: row?.address_line_2 ? row?.address_line_2 : "",
                        country_code: this.state.AllCountry.find((item) => (item.name === row?.country))?.isoCode,
                        AllStates: State.getStatesOfCountry(this.state.AllCountry.find((item) => (item.name === row?.country))?.isoCode),
                        state_code: State.getStatesOfCountry(this.state.AllCountry.find((item) => (item.name === row?.country))?.isoCode).find((item) => (item.name === row?.state_name))?.isoCode,
                        city: row?.city_name ? row?.city_name : "",
                        pin_code: row.pincode ? row.pincode : "",
                        RequestPatientDOB: row?.age ? this.handleFindApproxDob(typeof row?.age === "string" ? row?.age?.includes("Y") ? row?.age?.replace('Y', '') : row?.age : row?.age) : null,
                        RequestPatientGender: row?.gender ? row?.gender : "",
                      })
                    }}
                      position="end">
                      <Edit color='primary' />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={t("Create Appointment")} arrow placement='top'>
                    <IconButton onClick={() => {
                      this.setState({ RequestPopUp: false, DateOpen: false, patientSearch: '', App_DocID: null }, () => {
                        setCachevalue(JSON.stringify(row), "AppRequestPatientData")
                        if (row?.appointment_date === DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd')) {
                          this.props.history.push({ pathname: "/OPHome/Billing/NewQuickBilling" })
                        } else {
                          this.props.history.push({ pathname: "/OPHome/Billing/CreateAppointment" })
                        }
                      })
                    }}>
                      <CheckCircleIcon sx={{ height: '1.8vw', width: '1.8vw' }} color='primary' />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={t("Cancel Request")} arrow placement='top'>
                    <IconButton onClick={() => { this.postRequest(row, "Cancel") }}>
                      <CancelIcon sx={{ height: '1.8vw', width: '1.8vw' }} color='error' />
                    </IconButton>
                  </Tooltip>
                </Box>}
            </>
          )
        }
      },
    ];

    return (
      <Box height={height} width={width}>
        <DataGrid
          columns={columns}
          rows={list}
          getRowId={(row) => row['sno']}
          localeText={{
            toolbarColumns: "",
            toolbarDensity: "",
            toolbarExport: "",
            toolbarFilters: "",
            toolbarExportPrint: ""
          }}
          components={{
            NoRowsOverlay: () => (
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                {'No Records To Be Shown'}
              </Box>
            )
          }}
          headerHeight={40}
          disableRowSelectionOnClick
          hideFooter
        />
      </Box>
    )
  }

  postDoctorCancelAppointment = (selectedId) => {
    try {
      let data = {
        id: selectedId,
        status: 'Cancel'
      }
      this.setState({ postLoad: true })
      RestAPIService.create(data, Serviceurls.DOC_APPOINTMENT_REQUEST)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              doctorAppointmentAnchor: null,
              openDoctorAppointment: false,
              postLoad: false,
              datePicker: new Date()
            }, () => this.successMessage(response.data.message))
            this.getDoctorAppointmentList()
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.setState({ postLoad: false })
            this.errorMessage(error.response.data.message)
          } else {
            this.setState({ postLoad: false })
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.setState({ postLoad: false })
      this.errorMessage(error.message)
    }
  }

  // Doctor Apponintment Request Popup starts =====>
  doctorAppointmentRequest = () => {
    const { t } = this.props;
    return (
      <Menu
        open={this.state.openDoctorAppointment}
        className=""
        sx={{ position: 'absolute', top: '3vw', left: '5vw' }}
        anchorEl={this.state.doctorAppointmentAnchor}
        onClose={() => {
          this.setState({ openDoctorAppointment: false, docDateOpen: false, docSelectedRequestTab: "appointment_request", docDatePicker: new Date(), docRequestPatientListAnchor: null }, () => {
            this.docClearRequestData()
            this.getDoctorAppointmentList()
          })
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'}>
          <Tabs
            value={this.state.docSelectedRequestTab}
            onChange={(e, newValue) => {
              this.setState({ docSelectedRequestTab: newValue, docDateOpen: false, docDatePicker: new Date(), isDocAppointRequest: false }, () => {
                this.docClearRequestData()
                if (this.state.docSelectedRequestTab === "appointment_request") { this.getDoctorAppointmentList() }
              })
            }}
          >
            <Tab value="appointment_request" label="Appointment Request" className='eMed_tab_header' />
            <Tab value="create_request" label="Create Telephonic Request" className='eMed_tab_header' />
          </Tabs>
          <Box component={'div'}>
            {
              this.state.docSelectedRequestTab === "appointment_request" ?
                <Box display={'flex'} flexDirection={'row'} justifyContent={'flex-end'} alignItems={'center'}>
                  <div style={{ padding: "0.5vw" }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        open={this.state.docDatePickerOpen}
                        onOpen={() => { this.setState({ docDatePickerOpen: true }) }}
                        onClose={() => { this.setState({ docDatePickerOpen: false }) }}
                        value={this.state.docDatePicker}
                        name={"datePicker"}
                        inputFormat='DD-MM-YYYY'
                        views={["year", "month", "day"]}
                        onChange={
                          (newDate) => {
                            this.setState({
                              docDatePicker: newDate
                            }, () => {
                              this.getDoctorAppointmentList()
                            });
                          }}
                        renderInput={(params) => <TextField onKeyDown={(e) => e.preventDefault()} style={{ width: '10vw' }} size='small' {...params} onClick={() => { this.setState({ docDatePickerOpen: true }) }} />}
                      />
                    </LocalizationProvider>
                  </div>
                </Box> : null
            }
          </Box>
        </Box>
        {this.state.docSelectedRequestTab === 'appointment_request' ? this.renderAppointmentTab() : this.renderTelephonicTab()}
      </Menu>
    )
  }

  renderAppointmentTab = () => {
    try {
      const { t } = this.props
      return (this.renderAppointmentReqTbl(this.state.doctorAppointmentData, "docModule", '35.3vh', '52.5vw'))
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  renderTelephonicTab = () => {
    try {
      let states = this.state
      return (
        <Box height={"40.2vh"} width={"52.5vw"}>
          <Grid container className='eMed_IPappoint_Grid_row'>
            <Grid item xs={4} paddingTop={"1vw"}>
              <TextField
                sx={{ width: '14vw', position: "relative" }}
                size='small'
                inputProps={{ maxLength: 15 }}
                label={Object.keys(this.state.docSelectedRequestPatient).length > 0 ? "Mobile Number *" : "Mobile / UHID *"}
                value={this.state.docRequestMobileNumber}
                InputProps={{
                  endAdornment: this.state.isDocAppointRequest ?
                    <InputAdornment position="end"><CircularProgress size={15} /></InputAdornment>
                    : null,
                }}
                onChange={(e) => {

                  let number = CommonValidation.numberOnly(e.target.value);
                  this.setState({ docRequestMobileNumber: e.target.value, }, () => {
                    if (Object.keys(this.state.docSelectedRequestPatient).length > 0) {
                      this.setState({
                        docSelectedRequestPatient: {},
                        docRequestPatientName: "",
                        docRequestPatientAge: "",
                        docRequestPatientDOB: null,
                        docRequestPatientGender: "",
                      })
                    }
                    if (number && this.state.docRequestMobileNumber?.length >= 10) {
                      this.setState({}, () => { this.DoctorPatientSearch(true, this.state.docRequestMobileNumber) })
                    }
                  })
                }}
                onKeyDown={(e) => {
                  e.stopPropagation()
                  if (this.state.docRequestPatientListAnchor) {
                    if (this.state.docRequestMobileNumber.length > 5 && e.key === "Enter") {
                      this.setState({}, () => { this.DoctorPatientSearch(true, this.state.docRequestMobileNumber) })
                    }
                    if (this.state.docRequestMobileNumber.length <= 5 && e.key === "Enter") {
                      this.errorMessage("Enter atleast 6 Characters for search")
                    }
                  } else {
                    this.setState({
                      docRequestPatientListAnchor: e.currentTarget
                    }, () => {
                      if (this.state.docRequestMobileNumber.length > 5 && e.key === "Enter") {
                        this.setState({}, () => { this.DoctorPatientSearch(true, this.state.docRequestMobileNumber) })
                      }
                      if (this.state.docRequestMobileNumber.length <= 5 && e.key === "Enter") {
                        this.errorMessage("Enter atleast 6 Characters for search")
                      }
                    })
                  }
                }}
              />
              <Menu
                open={this.state.docRequestPatientMenuPop}
                anchorEl={this.state.docRequestPatientListAnchor}
                // sx={{ position: 'absolute', top: '11vw', left: '-10vw', maxHeight: '20vw', overflow: 'auto' }}
                className="eMed_Header_CreateRequest_Pop"
                onClose={() => {
                  this.setState({ docRequestPatientMenuPop: false, docRequestPatientListAnchor: null, docSearchedRequestPatientList: [] })
                }}
              // anchorOrigin={{
              //   vertical: 'top',
              //   horizontal: 'center',
              // }}
              // transformOrigin={{
              //   vertical: 'top',
              //   horizontal: 'center',
              // }}
              >
                <Typography className='eMed_Request_sugg_Head'>Patient Name | UHID</Typography>
                {
                  this.state.docSearchedRequestPatientList?.length > 0 ? this.state.docSearchedRequestPatientList?.map((item, index) => {
                    let PatientFullName = `${(item?.first_name ? item?.first_name : "")} ${(item?.last_name ? item?.last_name : "")}`
                    return (
                      <MenuItem key={index} onClick={() => {
                        this.setState({
                          docSelectedRequestPatient: item,
                          docRequestPatientMenuPop: false,
                          docRequestMobileNumber: item?.mobile_number,
                          docRequestPatientName: item?.first_name ? item?.first_name + " " + item?.last_name : "-",
                          docRequestPatientAge: item?.patient_age ? item?.patient_age : CalculateAgeFromDob(item.dob !== null ? new Date(item?.dob) : new Date(item?.approx_dob)),
                          address_1: item?.address_line_1 ? item?.address_line_1 : "",
                          address_2: item?.address_line_2 ? item?.address_line_2 : "",
                          city: item?.city_name ? item?.city_name : "",
                          state_code: item?.state_name ? State.getStatesOfCountry(this.state.AllCountry?.find((list) => (list.name === item?.country))?.isoCode)?.find((list) => (list.name === item?.state_name))?.isoCode : "",
                          country_code: item?.country ? this.state.AllCountry?.find((list) => (list.name === item?.country))?.isoCode : "",
                          pin_code: item?.pincode ? item?.pincode : "",
                        })
                      }}
                        sx={{ width: '14vw' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', width: '14vw' }}>
                          {(PatientFullName?.length > 15) ? <Tooltip title={PatientFullName} placement='top' arrow><div>
                            <Typography fontWeight={600} fontSize={"0.8vw"} paddingRight={"0.3vw"}>{(PatientFullName?.length > 12 ? PatientFullName?.slice(0, 10) + ("...") : PatientFullName)}</Typography></div>
                          </Tooltip> : <Typography fontWeight={600} fontSize={"0.8vw"} paddingRight={"0.3vw"}>{PatientFullName}</Typography>} | {item?.patient_account_number?.length > 10 ? <Tooltip title={item?.patient_account_number} placement='top' arrow><div>
                            <Typography paddingX={"0.3vw"} fontSize={"0.8vw"}>{("..." + item?.patient_account_number?.slice(-8))}</Typography></div>
                          </Tooltip> : <Typography paddingX={"0.3vw"} fontSize={"0.8vw"}>{item?.patient_account_number}</Typography>}
                        </Box>
                      </MenuItem>
                    )
                  }) : null
                }
              </Menu>
            </Grid>
            <Grid item xs={4} paddingTop={"1vw"} >
              <TextField
                sx={{ width: '14vw' }}
                autoComplete='off'
                disabled={Object.keys(this.state.docSelectedRequestPatient)?.length > 0}
                label="Patient Name *"
                value={this.state.docRequestPatientName}
                onChange={(e) => {
                  var isAlpha = CommonValidation.alphabetOnly(e.target.value)
                  if (isAlpha || e.target.value == "") {
                    this.setState({ docRequestPatientName: e.target.value })
                  }
                }}
                size='small'
                onKeyDown={(e) => { e.stopPropagation() }}
              />
            </Grid>
            <Grid item xs={4} paddingTop={"1vw"}>
              <TextField
                sx={{ width: '14vw' }}
                inputProps={{ maxLength: 3 }}
                autoComplete='off'
                disabled={Object.keys(this.state.docSelectedRequestPatient)?.length > 0}
                label="Patient Age"
                value={this.state.docRequestPatientAge}
                onChange={(e) => {
                  let number = CommonValidation.numberOnly(e.target.value);
                  if ((e.target.value < 150) && (number || e.target.value === "")) {
                    this.setState({ docRequestPatientAge: e.target.value })
                  }
                }}
                size='small'
              />
            </Grid>
          </Grid>
          <Grid container className='eMed_IPappoint_Grid_row'  >
            {/* ======> Commented for doctor and specilization not in doctor module */}
            {/* <Grid item xs={4}>
              {this.renderDropdown("Doctor", "0vw", this.state.filteredDocList.length > 0 ? this.state.filteredDocList : this.state.doctorList, "RequestSelectedDocID")}
            </Grid>
            <Grid item xs={4}>
              {this.renderDropdown("Specialization", "0vw", this.state.spcInfo, "RequestSelectedSpecID")}
            </Grid> */}
            <Grid item xs={4} >
              <Box sx={{ width: '93%', mt: '1vw' }}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DateTimePicker
                    open={this.state.docDateOpen}
                    onOpen={() => { this.setState({ docDateOpen: true }) }}
                    onClose={() => { this.setState({ docDateOpen: false }) }}
                    inputFormat='dd-MM-yyyy & hh:mm a'
                    value={this.state.docRequestAppointDatetym}
                    disabled={this.state.doceditPatientId}
                    minDate={new Date()}
                    maxDate={new Date((new Date).getFullYear(), (new Date).getMonth() + 3, 0)}
                    onChange={(newDate) => {
                      if (newDate === null) {
                        this.setState({ docRequestAppointDatetym: new Date() })
                        // , () => this.getDoctorsList(true))
                      }
                      else {
                        this.setState({ docRequestAppointDatetym: newDate })
                        // , () => this.getDoctorsList(true))
                      }
                    }}
                    renderInput={(params) => <TextField
                      size='small'
                      inputProps={{ style: { fontSize: '0.8vw' } }}
                      onKeyDown={(e) => e.preventDefault()}
                      disabled={this.state.doceditPatientId}
                      onClick={() => { this.setState({ docDateOpen: true }) }}
                      {...params}
                      sx={{ width: "14vw" }}
                      variant='outlined'
                      label="Appointment Date & Time *"
                    />}
                  />
                </LocalizationProvider>
              </Box>
            </Grid>
            <Grid item xs={8}>
              <Box>
                <Autocomplete
                  inputProps={{ maxLength: 250 }}
                  options={this.state.POVList}
                  getOptionLabel={(options) => options}
                  onChange={(e, value) => {
                    this.setState({
                      docRequestpurposeOfVisit: value
                    })
                  }}
                  onKeyDown={(e) => { e.stopPropagation() }}
                  clearIcon={false}
                  size='small'
                  sx={{ mt: "1vw", width: '31vw' }}
                  value={this.state.docRequestpurposeOfVisit}
                  renderInput={(params) => <TextField onChange={(event) => {
                    this.setState({
                      docRequestpurposeOfVisit: event.target.value
                    })
                  }}
                    {...params}
                    placeholder="Purpose Of Visit"
                  />}
                />
              </Box>
            </Grid>
          </Grid>

          <Grid container className='eMed_IPappoint_Grid_row' marginTop={"1vw"}>
            <Grid item xs={4}>
              {
                <TextField
                  sx={{ width: "14vw" }}
                  size="small"
                  autoComplete='off'
                  inputProps={{ maxLength: 100 }}
                  label={("Address 01")}
                  value={this.state.address_1}
                  disabled={Object.keys(this.state.docSelectedRequestPatient)?.length > 0}
                  onChange={(e) => {
                    this.setState({ address_1: e.target.value })
                  }}
                  onKeyDown={(e) => {
                    e.stopPropagation()
                  }}
                />
              }
            </Grid>
            <Grid item xs={4}>
              {
                <TextField
                  sx={{ width: "14vw" }}
                  size="small"
                  inputProps={{ maxLength: 100 }}
                  label={("Address 02")}
                  disabled={Object.keys(this.state.docSelectedRequestPatient)?.length > 0}
                  autoComplete='off'
                  value={this.state.address_2}
                  onChange={(e) => {
                    this.setState({ address_2: e.target.value })
                  }}
                  onKeyDown={(e) => {
                    e.stopPropagation()
                  }}
                />
              }
            </Grid>
            <Grid item xs={4} >
              <Autocomplete
                sx={{ width: "14vw" }}
                size="small"
                options={states.cityName ? states.cityName : []}
                getOptionLabel={(option) => typeof (option) === "string" ? option : option.name}
                disabled={Object.keys(this.state.docSelectedRequestPatient)?.length > 0}
                onChange={(e, value) => {
                  this.setState({
                    city: value?.name ? value?.name : '',
                    // pin_code: '',
                  })
                }}
                clearIcon={false}
                value={states.city}
                renderInput={(params) => (
                  <TextField
                    label={"City"}
                    autoComplete='off'
                    InputProps={{ ...params.InputProps }}
                    onChange={(e) => this.setState({
                      city: e.target.value,
                      // pin_code: ''
                    })}
                    {...params}
                  />)}
                onKeyDown={(e) => e.key === "Enter" ? e.preventDefault() : null}
              />


            </Grid>
          </Grid>


          <Grid container className='eMed_IPappoint_Grid_row' marginTop={"1vw"}>
            <Grid item xs={4}>
              <FormControl size='small' sx={{ width: '12vw' }}>
                <InputLabel id="title-select-label">{"Select State"}</InputLabel>
                <Select
                  sx={{ width: '14vw' }}
                  MenuProps={{ style: { maxHeight: 250, maxWidth: '12vw' } }}
                  labelId='gender-select-label'
                  size='small'
                  label={"Select State"}
                  disabled={Object.keys(this.state.docSelectedRequestPatient)?.length > 0}
                  value={states.state_code}
                  onChange={(e) => {
                    this.setState({ state_code: e.target.value },
                      () => {
                        this.setState({ cityName: City.getCitiesOfState(this.state.country_code, this.state.state_code), city: '' })
                      })
                  }}
                >
                  {
                    states.AllStates.map((list) => (
                      <MenuItem key={list.isoCode} value={list.isoCode}>{list.name}</MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl size='small' sx={{ width: '12vw', maxWidth: '12vw' }}>
                <InputLabel id="title-select-label">{"Select Country"}</InputLabel>
                <Select
                  // disabled={this.state.SelectedPatientID && !(CheckAccessFunc("front_office", "Home", "Demographics", null, "Tab")?.editAccess)}
                  sx={{ width: '14vw' }}
                  MenuProps={{ style: { maxHeight: 250, maxWidth: '12vw' } }}
                  labelId='gender-select-label'
                  label={"Select Country"}
                  disabled={Object.keys(this.state.docSelectedRequestPatient)?.length > 0}
                  size='small'
                  value={states.country_code}
                  onChange={(e) => {
                    this.setState({ country_code: e.target.value, state_code: "", city: '' }, () => {
                      this.setState({ AllStates: State.getStatesOfCountry(this.state.country_code), cityName: '' })
                    })
                  }}
                >
                  {
                    states.AllCountry.map((list) => (
                      <MenuItem key={list.isoCode} value={list.isoCode}>{list.name}</MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4} >
              <TextField
                sx={{ width: '14vw' }}
                // disabled={((data.label === "First Name") ? Object.keys(this.state.RequestedPatientData).length > 0 : false) || (this.state.SelectedPatientID && !(CheckAccessFunc("front_office", "Home", "Demographics", null, "Tab")?.editAccess))}
                autoComplete='off'
                inputProps={{ maxLength: 6 }}
                label={"Pincode"}
                variant="outlined"
                value={this.state.pin_code}
                disabled={Object.keys(this.state.docSelectedRequestPatient)?.length > 0}
                onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
                onChange={(e) => {
                  if ((CommonValidation.numberOnly(e.target.value) || e.target.value == "") && e.target.value.length <= 6) {
                    this.state.pin_code = e.target.value
                    this.setState({
                      states
                    }, () => {
                      if (this.state.pin_code && this.state.pin_code.length === 6) {
                        this.getPincodeToCity(this.state.pin_code)
                      }
                    })
                  }
                }}

                size="small"
              />
            </Grid>
          </Grid>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography marginLeft={"2vw"}>{Object.keys(this.state.SelectedRequestPatient).length > 0 ? `UHID : ${this.state.SelectedRequestPatient?.patient_account_number}` : ""}</Typography>
            <Box className="eMed_CreateRequest_BtnBox">
              <Button size='small' id="eMed_Config_btn" sx={{ marginRight: '1vw' }} onClick={() => { this.docClearRequestData() }} variant='outlined'>Clear</Button>
              <Button size='small' id="eMed_Config_btn" disabled={this.state.isClked} variant='contained' onClick={() => this.setState({ isClked: true }, () => this.CreateAppointRequest(true))}>{this.state.doceditAppointmentId ? "Update Request" : "Create Request"}</Button>
            </Box>
          </Box>
        </Box>
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getDoctorAppointmentList = (fromUpdate = false) => {
    try {
      let clinicId = localGetItem('SelectedDoctorClinicId') ? localGetItem('SelectedDoctorClinicId') : this.state.doctorClinicId
      let startDate = this.state.docDatePicker ? new Date(this.state.docDatePicker) : new Date(this.state.datePicker)
      let selectedDate = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')
      RestAPIService.getAll(Serviceurls.DOC_APPOINTMENT_REQUEST + '?from_date=' + selectedDate + '&to_date=' + selectedDate + '&clinic_id=' + clinicId)
        .then((response) => {
          if (response?.data?.status === 'success') {
            const data = response?.data?.data ? response?.data?.data?.map((item, idx) => ({ ...item, sno: idx + 1 })) : [];
            if (fromUpdate) {
              this.setState({
                doctorAppointmentData: data,
                docSelectedRequestTab: 'appointment_request'
              })
            } else {
              this.setState({
                doctorAppointmentData: data,
              })
            }
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  handlePatientSearch = () => {
    let data = this.state.duplicateFoReqList
    if (this.state.patientSearch !== "") {
      data = this.state.duplicateFoReqList.filter((item) => (
        (item?.first_name === "" ? "" : item?.first_name?.toLowerCase()?.includes(this.state.patientSearch?.toLowerCase()))
      ))
      this.setState({ FoRequestList: data })
    } else {
      this.getAppointRequests()
    }
  }

  handlePatientSearchClose = () => {
    this.setState({ patientSearch: '' })
    this.getAppointRequests()
  }

  renderDropdown = (label, mt, Data = [], stateKey) => {
    var states = this.state
    return (
      <Box sx={{ width: '45%', mt: mt }}>
        <Autocomplete
          size='small'
          clearIcon={false}
          sx={{ width: '14vw', marginTop: '1vw' }}
          componentsProps={{ popper: { style: { width: label === 'Doctor' ? "23vw" : "14vw" } } }}
          disabled={this.props?.is_Nurse && label === "Specialization" ? true : false}
          options={Data}
          getOptionLabel={(item) => ((label === "Doctor" ? item.doctor_name : label === "Specialization" ? item.name : label === "Patient Tag" ? item.patient_tag_name : label === "Appointment Type" ? item.appoinment_type : label === "Nurse" ? item.nurse : ""))}
          value={states[stateKey]}
          renderOption={label === 'Doctor' ? (props, item) => (
            <Box>
              {props["data-option-index"] === 0 ?
                <Box className="eMed_App_Doctor_table_head">
                  <Typography width={"50%"} fontWeight={'600'} fontSize={"0.8vw"}>Doctor Name</Typography>
                  <Typography width={"25%"} fontWeight={'600'} fontSize={"0.8vw"}>Total App</Typography>
                  <Typography width={"25%"} fontWeight={'600'} fontSize={"0.8vw"}>New App</Typography>
                </Box> : null}
              <Box component="li" className='eMed_App_Doctor_table_data' {...props}>
                <div style={{ width: "50%" }}>{item?.doctor_name.length > 15 ? <Tooltip placement="top" title={item?.doctor_name} arrow><div>{item?.doctor_name.slice(0, 16) + "..."}</div></Tooltip> : item?.doctor_name ? item?.doctor_name : "-"}</div>
                <Typography width={"25%"} textAlign={"center"} fontWeight={'600'} fontSize={"0.8vw"}>{item.total_appointment}</Typography>
                <Typography width={"25%"} textAlign={"center"} fontWeight={'600'} fontSize={"0.8vw"}>{item.new_appointment}</Typography>
              </Box>
            </Box>) : null}
          onChange={(event, newValue) => {
            states[stateKey] = newValue
            if (newValue !== null && "doctor_id" in newValue) {
              let docDetail = { ...newValue }
              docDetail["name"] = docDetail["specialization_name"];
              delete docDetail.specialization_name;
              docDetail["id"] = docDetail["specialization_id"];
              delete docDetail.specialization_id;
              states["RequestSelectedSpecID"] = docDetail;
            }
            if (newValue !== null && "name" in newValue) {
              let filteredLst = states["doctorList"].length > 0 && states["doctorList"].filter(item => item["specialization_id"] === newValue["id"])
              states["filteredDocList"] = filteredLst.length > 0 && filteredLst;
              states["RequestSelectedDocID"] = null;
            }
            if (newValue === null && label === "Specialization") {
              states["filteredDocList"] = states["doctorList"];
            }
            this.setState({ states })
          }}
          onKeyDown={(e) => e.stopPropagation()}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              placeholder={label}
            // onKeyDown={(e) => { e.stopPropagation() }}
            />
          )}
        />
      </Box>
    )
  }

  AppointmentRequestPop = () => {
    const { t } = this.props;
    var states = this.state
    return (
      <Menu
        open={this.state.RequestPopUp}
        // sx={{ height: '60vh' }}
        className="eMed_Header_Request_Pop"
        sx={{ height: "80vw" }}
        anchorEl={this.state.RequestAnchor}
        onClose={() => {
          this.setState({ RequestPopUp: false, DateOpen: false, SelectedRequestTab: "appointment_request", datePicker: new Date(), App_DocID: null, patientSearch: '', RequestPatientListAnchor: null }, () => {
            this.ClearRequestData()
            this.getAppointRequests()
          })
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'}>
          <Tabs

            value={this.state.SelectedRequestTab}
            onChange={(e, newValue) => {
              this.setState({ SelectedRequestTab: newValue, DateOpen: false, datePicker: new Date(), isappointRequest: false }, () => {
                this.ClearRequestData()
                if (this.state.SelectedRequestTab === "appointment_request") { this.getAppointRequests() }
                else {
                  let city_name = localGetItem('city_name')
                  let state_name = localGetItem('state_name')
                  let List = State.getAllStates()?.find(item => item?.name?.toLowerCase() === state_name?.toLowerCase())
                  let stateList = State.getStatesOfCountry(List?.countryCode)
                  let cityList = City.getCitiesOfState(List?.countryCode, List?.isoCode)
                  this.setState({ city: city_name, state_code: List?.isoCode, AllStates: stateList, cityName: cityList })
                }
              })
            }}
          // sx={{ backgroundColor: Colors.DataTblHeaderbg }}
          >
            <Tab value="appointment_request" label="Appointment Req" className='eMed_tab_header' />
            <Tab value="create_request" label="Create Tele Req" className='eMed_tab_header' />
          </Tabs>
          <Box>
            {
              this.state.SelectedRequestTab === "appointment_request" ?
                <Box display={'flex'} flexDirection={'row'} justifyContent={'flex-end'} alignItems={'center'}>
                  <TextField
                    placeholder={t("Patient Name")}
                    onChange={(e) => {
                      let validate = CommonValidation.alphabetOnly(e.target.value)
                      validate &&
                        this.setState({ patientSearch: e.target.value }, () => {
                          this.handlePatientSearch()
                        })
                    }}
                    value={this.state.patientSearch}
                    size="small"
                    sx={{ width: "10vw" }}
                    onKeyDown={(e) => { e.stopPropagation() }}
                    autoComplete='off'
                    inputProps={{ emed_tid: 'ApptReq_PatientSearch' }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {this.state.patientSearch.length ?
                            <IconButton onClick={this.handlePatientSearchClose} emed_tid='ApptReq_PatientSearch_ClearBtn'>
                              <CloseIcon fontSize='small' />
                            </IconButton>
                            : null}
                        </InputAdornment>
                      ),
                    }}
                  />
                  <div style={{ padding: "0.5vw" }}>
                    <Autocomplete
                      size='small'
                      // clearIcon={false}
                      sx={{ width: '10vw' }}
                      options={this.state.doctorList}
                      getOptionLabel={(item) => (item.doctor_name)}
                      value={this.state.App_DocID}
                      onChange={(event, newValue) => {
                        states['App_DocID'] = newValue
                        this.setState({ states }, () => { this.getAppointRequests() })
                      }}
                      onKeyDown={(e) => e.stopPropagation()}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={'Select Doctor'}
                          placeholder={'Select Doctor'}
                        // onKeyDown={(e) => { e.stopPropagation() }}
                        />
                      )}
                      renderOption={(props, option) => (
                        <li {...props} key={option?.doctor_id}>
                          {option?.doctor_name}
                        </li>
                      )}
                    />
                  </div>
                  <div style={{ padding: "0.5vw" }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        open={this.state.DatePickerOpen}
                        onOpen={() => { this.setState({ DatePickerOpen: true }) }}
                        onClose={() => { this.setState({ DatePickerOpen: false }) }}
                        value={this.state.datePicker}
                        name={"datePicker"}
                        inputFormat='DD-MM-YYYY'
                        views={["year", "month", "day"]}
                        onChange={
                          (newDate) => {
                            this.setState({
                              datePicker: newDate
                            }, () => {
                              this.getAppointRequests()
                            });
                          }}
                        renderInput={(params) => <TextField
                          onKeyDown={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                          }} style={{ width: '10vw' }} size='small' {...params} onClick={() => { this.setState({ DatePickerOpen: true }) }} />}
                      />
                    </LocalizationProvider>
                  </div>
                  <Tooltip title={"Print"} placement='top' arrow>
                    <IconButton size="small" disabled={this.state.FoRequestList.length ? false : true} onClick={() => this.getAppointRequestsPrint()}>
                      <img
                        className='eMed_action_img'
                        src={ImagePaths.LabPrintIcon.default}
                        alt="print"
                      />
                    </IconButton>
                  </Tooltip>
                </Box> : null}
          </Box>
        </Box>
        {
          this.state.SelectedRequestTab === "appointment_request" ?
            this.renderAppointmentReqTbl(this.state.FoRequestList, "request", '48.4vh', '60vw')
            :
            <Box className="eMEd_CreateRequest_Box" height={"53.2vh"} sx={{ width: '60vw' }}>
              <Grid container className='eMed_IPappoint_Grid_row'>
                <Grid item xs={4} paddingTop={"1vw"}>
                  <TextField
                    sx={{ width: '14vw', position: "relative" }}
                    size='small'
                    inputProps={{ maxLength: 15 }}
                    label={Object.keys(this.state.SelectedRequestPatient).length > 0 ? "Mobile Number *" : "Mobile / UHID *"}
                    value={this.state.RequestMobileNumber}
                    InputProps={{
                      endAdornment: this.state.isappointRequest ?
                        <InputAdornment position="end"><CircularProgress size={15} /></InputAdornment>
                        : null,
                    }}
                    onChange={(e) => {
                      let number = CommonValidation.numberOnly(e.target.value);
                      this.setState({ RequestMobileNumber: e.target.value, }, () => {
                        if (Object.keys(this.state.SelectedRequestPatient).length > 0 || this.state.editPatientId) {
                          this.setState({
                            SelectedRequestPatient: {},
                            RequestPatientName: "",
                            RequestPatientAge: "",
                            editPatientId: null,
                            RequestPatientListAnchor: null,
                            RequestPatientDOB: null,
                            RequestPatientGender: "",
                          })
                        }
                        if (number && this.state.RequestMobileNumber.length >= 10) {
                          this.setState({}, () => { this.FOPatientSearch(true, this.state.RequestMobileNumber) })
                        }
                      })
                    }}
                    onKeyDown={(e) => {
                      e.stopPropagation()
                      if (this.state.RequestPatientListAnchor) {
                        if (this.state.RequestMobileNumber.length > 5 && e.key === "Enter") {
                          this.setState({}, () => { this.FOPatientSearch(true, this.state.RequestMobileNumber) })
                        }
                        if (this.state.RequestMobileNumber.length <= 5 && e.key === "Enter") {
                          this.errorMessage("Enter atleast 6 Characters for search")
                        }
                      } else {
                        this.setState({
                          RequestPatientListAnchor: e.currentTarget
                        }, () => {
                          if (this.state.RequestMobileNumber.length > 5 && e.key === "Enter") {
                            this.setState({}, () => { this.FOPatientSearch(true, this.state.RequestMobileNumber) })
                          }
                          if (this.state.RequestMobileNumber.length <= 5 && e.key === "Enter") {
                            this.errorMessage("Enter atleast 6 Characters for search")
                          }
                        })
                      }
                    }}
                  />
                  <Menu
                    open={this.state.RequestPatientMenuPop}
                    anchorEl={this.state.RequestPatientListAnchor}
                    // sx={{ position: 'absolute', top: '4vw', left: "-9.3vw" }}
                    className="eMed_Header_CreateRequest_Pop"
                    onClose={() => {
                      this.setState({ RequestPatientMenuPop: false, RequestPatientListAnchor: null, SearchedRequestPatientList: [] })
                    }}
                  >
                    <Typography className='eMed_Request_sugg_Head'>Patient Name | UHID</Typography>
                    {
                      this.state.SearchedRequestPatientList.length > 0 ? this.state.SearchedRequestPatientList.map((item, index) => {
                        let PatientFullName = `${(item?.first_name ? item?.first_name : "")} ${(item?.last_name ? item?.last_name : "")}`
                        return (
                          <MenuItem key={index} onClick={() => {
                            this.setState({
                              SelectedRequestPatient: item,
                              RequestPatientMenuPop: false,
                              RequestMobileNumber: item?.mobile_number,
                              RequestPatientName: item?.first_name ? item?.first_name + " " + item?.last_name : "-",
                              RequestPatientAge: item?.patient_age ? (typeof item?.patient_age === "string" ? item?.patient_age?.includes("Y") ? item?.patient_age?.replace('Y', '') : item?.patient_age : item?.patient_age) : CalculateAgeFromDob(item.dob !== null ? new Date(item?.dob) : new Date(item?.approx_dob)),
                              address_1: item?.address_line_1 ? item?.address_line_1 : "",
                              address_2: item?.address_line_2 ? item?.address_line_2 : "",
                              city: item?.city_name ? item?.city_name : "",
                              state_code: item?.state_name ? State.getStatesOfCountry(this.state.AllCountry?.find((list) => (list.name === item?.country))?.isoCode)?.find((list) => (list.name === item?.state_name))?.isoCode : "",
                              country_code: item?.country ? this.state.AllCountry?.find((list) => (list.name === item?.country))?.isoCode : "",
                              pin_code: item?.pincode ? item?.pincode : "",
                              RequestPatientDOB: item?.patient_age ? this.handleFindApproxDob(typeof item?.patient_age === "string" ? item?.patient_age?.includes("Y") ? item?.patient_age?.replace('Y', '') : item?.patient_age : item?.patient_age) : null,
                              RequestPatientGender: item?.patient_gender ? ((item?.patient_gender === "M" || item?.patient_gender === "m" || item?.patient_gender === "Male") ? "m" : (item?.patient_gender === "F" || item?.patient_gender === "f" || item?.patient_gender === "Female") ? "f" : (item?.patient_gender === "T" || item?.patient_gender === "t" || item?.patient_gender === "Trans") ? "t" : "") : "",
                            })
                          }}
                            sx={{ width: '14vw' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', width: '14vw' }}>
                              {(PatientFullName?.length > 15) ? <Tooltip title={PatientFullName} placement='top' arrow><div>
                                <Typography fontWeight={600} fontSize={"0.8vw"} paddingRight={"0.3vw"}>{(PatientFullName?.length > 12 ? PatientFullName?.slice(0, 10) + ("...") : PatientFullName)}</Typography></div>
                              </Tooltip> : <Typography fontWeight={600} fontSize={"0.8vw"} paddingRight={"0.3vw"}>{PatientFullName}</Typography>} | {item?.patient_account_number?.length > 10 ? <Tooltip title={item?.patient_account_number} placement='top' arrow><div>
                                <Typography paddingX={"0.3vw"} fontSize={"0.8vw"}>{("..." + item?.patient_account_number?.slice(-8))}</Typography></div>
                              </Tooltip> : <Typography paddingX={"0.3vw"} fontSize={"0.8vw"}>{item?.patient_account_number}</Typography>}
                            </Box>
                          </MenuItem>
                        )
                      }) : null
                    }
                  </Menu>
                </Grid>
                <Grid item xs={4} paddingTop={"1vw"} >
                  <TextField
                    sx={{ width: '14vw' }}
                    inputProps={{ maxLength: 32 }}
                    disabled={Object.keys(this.state.SelectedRequestPatient).length > 0 || this.state.editPatientId}
                    label="Patient Name *"
                    value={this.state.RequestPatientName}
                    onChange={(e) => {
                      var isAlpha = CommonValidation.alphabetOnly(e.target.value)
                      if ((isAlpha || e.target.value == "") && (e.target.value?.length <= 100)) {
                        this.setState({ RequestPatientName: e.target.value })
                      }
                    }}
                    size='small'
                    onKeyDown={(e) => { e.stopPropagation() }}
                  />
                </Grid>
                <Grid item xs={4} paddingTop={"1vw"}>
                  <TextField
                    sx={{ width: '14vw' }}
                    inputProps={{ maxLength: 3 }}
                    disabled={Object.keys(this.state.SelectedRequestPatient).length > 0 || this.state.editPatientId}
                    label="Patient Age"
                    value={this.state.RequestPatientAge}
                    onChange={(e) => {
                      let number = CommonValidation.numberOnly(e.target.value);
                      if ((e.target.value < 150) && (number || e.target.value === "")) {
                        this.setState({ RequestPatientAge: e.target.value }, () => {
                          var approxDob = this.handleFindApproxDob(e.target.value);
                          this.setState({
                            RequestPatientDOB: approxDob
                          })
                        })
                      }
                    }}
                    size='small'
                    onKeyDown={(e) => { e.stopPropagation() }}
                  />
                </Grid>
              </Grid>
              <Grid container className='eMed_IPappoint_Grid_row' marginTop={"2vw"}>
                <Grid item xs={4}>
                  <FormControl size='small'>
                    <InputLabel id="gender-select-label">{"Gender"}</InputLabel>
                    <Select
                      sx={{ width: '14vw' }}
                      labelId='gender-select-label'
                      size='small'
                      label="Gender *"
                      value={this.state.RequestPatientGender}
                      onChange={(e) => {
                        states["RequestPatientGender"] = e.target.value
                        this.setState({
                          states
                        })
                      }}
                    >
                      <MenuItem key={1} value={"m"}>{t("Male")}</MenuItem>
                      <MenuItem key={2} value={"f"}>{t("Female")}</MenuItem>
                      <MenuItem key={2} value={"t"}>{t("TransGender")}</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      sx={{ width: '33vw' }}
                      size='small'
                      label="Date of Birth"
                      inputFormat={"dd-MM-yyyy"}
                      autoComplete="off"
                      value={this.state.RequestPatientDOB}
                      minDate={new Date("1872-01-01")}
                      maxDate={DateTime.now()}
                      onChange={(newDate) => {
                        var age = this.handleAgeCalculation(newDate)
                        this.setState({
                          RequestPatientDOB: newDate,
                          RequestPatientAge: age
                        })
                      }}
                      renderInput={(params) => <TextField sx={{ width: '31vw' }}  {...params} size='small' autoComplete="off"
                        variant="outlined" fullWidth />}
                    />
                  </LocalizationProvider>
                </Grid>
              </Grid>
              <Grid container className='eMed_IPappoint_Grid_row' marginTop={"1vw"}>
                <Grid item xs={4}>
                  {this.renderDropdown("Doctor", "0vw", this.state.filteredDocList.length > 0 ? this.state.filteredDocList : this.state.doctorList, "RequestSelectedDocID")}
                </Grid>
                <Grid item xs={4}>
                  {this.renderDropdown("Specialization", "0vw", this.state.spcInfo, "RequestSelectedSpecID")}
                </Grid>
                <Grid item xs={4} >
                  <Box sx={{ width: '93%', mt: '1vw' }}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DateTimePicker
                        open={this.state.DateOpen}
                        onOpen={() => { this.setState({ DateOpen: true }) }}
                        onClose={() => { this.setState({ DateOpen: false }) }}
                        inputFormat='dd-MM-yyyy & hh:mm a'
                        value={this.state.RequestAppointDatetym}
                        disabled={this.state.editPatientId}
                        minDate={new Date()}
                        maxDate={new Date((new Date).getFullYear(), (new Date).getMonth() + 3, 0)}
                        onChange={(newDate) => {
                          if (newDate === null) {
                            this.setState({ RequestAppointDatetym: new Date() })
                          }
                          else {
                            this.setState({ RequestAppointDatetym: newDate }, () => this.getDoctorsList(true))
                          }
                        }}
                        renderInput={(params) => <TextField
                          sx={{ width: '14vw' }}
                          size='small'
                          inputProps={{ style: { fontSize: '0.8vw' } }}
                          onKeyDown={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                          }}
                          disabled={this.state.editPatientId}
                          onClick={() => { this.setState({ DateOpen: true }) }}
                          {...params}
                          fullWidth
                          variant='outlined'
                          label="Appointment Date & Time *"
                        />}
                      />
                    </LocalizationProvider>

                  </Box>
                </Grid>
              </Grid>
              <Grid container className='eMed_IPappoint_Grid_row' marginTop={"2vw"}>
                <Grid item xs={4}>
                  {
                    <TextField
                      sx={{ width: "14vw" }}
                      size="small"
                      inputProps={{ maxLength: 100, autoComplete: "new-password" }}
                      autoComplete="off"
                      disabled={Object.keys(this.state.SelectedRequestPatient).length > 0 || this.state.editPatientId}
                      label={t("Address 01")}
                      value={this.state.address_1}
                      onChange={(e) => {
                        this.setState({ address_1: e.target.value })
                      }}
                      onKeyDown={(e) => {
                        e.stopPropagation()
                      }}
                      name="random-address-field"
                    />
                  }
                </Grid>
                <Grid item xs={4}>
                  {
                    <TextField
                      sx={{ width: "14vw" }}
                      size="small"
                      inputProps={{ maxLength: 100, autoComplete: "new-password" }}
                      disabled={Object.keys(this.state.SelectedRequestPatient).length > 0 || this.state.editPatientId}
                      autoComplete='off'
                      label={t("Address 02")}
                      value={this.state.address_2}
                      onChange={(e) => {
                        this.setState({ address_2: e.target.value })
                      }}
                      onKeyDown={(e) => {
                        e.stopPropagation()
                      }}
                      name="random-address-field"
                    />
                  }
                </Grid>
                <Grid item xs={4} >
                  <Autocomplete
                    sx={{ width: "14vw" }}
                    size="small"
                    options={states.cityName ? states.cityName : []}
                    getOptionLabel={(option) => typeof (option) === "string" ? option : option.name}
                    disabled={Object.keys(this.state.SelectedRequestPatient).length > 0 || this.state.editPatientId}
                    onChange={(e, value) => {
                      this.setState({
                        city: value?.name ? value?.name : '',
                        // pin_code: '',
                      })
                    }}
                    clearIcon={false}
                    value={states.city}
                    renderInput={(params) => (
                      <TextField
                        label={"City"}
                        autoComplete='off'
                        InputProps={{ ...params.InputProps }}
                        onChange={(e) => this.setState({
                          city: e.target.value,
                          // pin_code: ''
                        })}
                        {...params}
                      />)}
                    onKeyDown={(e) => e.key === "Enter" ? e.preventDefault() : null}
                  />
                </Grid>
              </Grid>
              <Grid container className='eMed_IPappoint_Grid_row' marginTop={"2vw"}>
                <Grid item xs={4}>
                  <FormControl size='small' sx={{ width: '12vw' }}>
                    <InputLabel id="title-select-label">{"Select State"}</InputLabel>
                    <Select
                      sx={{ width: '14vw' }}
                      MenuProps={{ style: { maxHeight: 250, maxWidth: '12vw' } }}
                      labelId='gender-select-label'
                      disabled={Object.keys(this.state.SelectedRequestPatient).length > 0 || this.state.editPatientId}
                      size='small'
                      label={"Select State"}
                      value={states.state_code}
                      onChange={(e) => {
                        this.setState({ state_code: e.target.value },
                          () => {
                            this.setState({ cityName: City.getCitiesOfState(this.state.country_code, this.state.state_code), city: '' })
                          })
                      }}
                    >
                      {
                        states.AllStates.map((list) => (
                          <MenuItem key={list.isoCode} value={list.isoCode}>{list.name}</MenuItem>
                        ))
                      }
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <FormControl size='small' sx={{ width: '12vw', maxWidth: '12vw' }}>
                    <InputLabel id="title-select-label">{"Select Country"}</InputLabel>
                    <Select
                      // disabled={this.state.SelectedPatientID && !(CheckAccessFunc("front_office", "Home", "Demographics", null, "Tab")?.editAccess)}
                      sx={{ width: '14vw' }}
                      MenuProps={{ style: { maxHeight: 250, maxWidth: '12vw' } }}
                      labelId='gender-select-label'
                      disabled={Object.keys(this.state.SelectedRequestPatient).length > 0 || this.state.editPatientId}
                      label={"Select Country"}
                      size='small'
                      value={states.country_code}
                      onChange={(e) => {
                        this.setState({ country_code: e.target.value, state_code: "", city: '' }, () => {
                          this.setState({ AllStates: State.getStatesOfCountry(this.state.country_code), cityName: '' })
                        })
                      }}
                    >
                      {
                        states.AllCountry.map((list) => (
                          <MenuItem key={list.isoCode} value={list.isoCode}>{list.name}</MenuItem>
                        ))
                      }
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={4} >
                  <TextField
                    sx={{ width: '14vw' }}
                    // disabled={((data.label === "First Name") ? Object.keys(this.state.RequestedPatientData).length > 0 : false) || (this.state.SelectedPatientID && !(CheckAccessFunc("front_office", "Home", "Demographics", null, "Tab")?.editAccess))}
                    autoComplete='off'
                    inputProps={{ maxLength: 6, autoComplete: "new-password" }}
                    label={"Pincode"}
                    disabled={Object.keys(this.state.SelectedRequestPatient).length > 0 || this.state.editPatientId}
                    variant="outlined"
                    value={this.state.pin_code}
                    onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
                    onChange={(e) => {
                      if ((CommonValidation.numberOnly(e.target.value) || e.target.value == "") && e.target.value?.length <= 6) {
                        this.state.pin_code = e.target.value
                        this.setState({
                          states
                        }, () => {
                          if (this.state.pin_code && this.state.pin_code?.length === 6) {
                            this.getPincodeToCity(this.state.pin_code)
                          }
                        })
                      }
                    }}
                    size="small"
                    name="random-address-field"
                  />
                </Grid>
              </Grid>
              <Autocomplete
                inputProps={{ maxLength: 250 }}
                options={this.state.POVList}
                getOptionLabel={(options) => options}
                onChange={(e, value) => {
                  this.setState({
                    RequestpurposeOfVisit: value
                  })
                }}
                onKeyDown={(e) => { e.stopPropagation() }}
                clearIcon={false}
                size='small'
                sx={{ width: '44vw', paddingLeft: '2vw', mt: "2vw" }}
                value={this.state.RequestpurposeOfVisit}
                renderInput={(params) => <TextField sx={{ width: "48vw" }} onChange={(event) => {
                  this.setState({
                    RequestpurposeOfVisit: event.target.value
                  })
                }}
                  {...params}
                  placeholder="Purpose Of Visit"
                />}
              />
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography marginLeft={"2vw"}>{Object.keys(this.state.SelectedRequestPatient).length > 0 ? `UHID : ${this.state.SelectedRequestPatient?.patient_account_number}` : ""}</Typography>
                <Box className="eMed_CreateRequest_BtnBox">
                  <Button size='small' id="eMed_Config_btn" sx={{ marginRight: '1vw' }} onClick={() => { this.ClearRequestData() }} variant='outlined'>Clear</Button>
                  <Button size='small' id="eMed_Config_btn" disabled={this.state.isClked} variant='contained' onClick={() => this.setState({ isClked: true }, () => this.CreateAppointRequest())}>{this.state.editAppointmentId ? "Update Request" : "Create Request"}</Button>
                </Box>
              </Box>
            </Box>
        }
      </Menu>
    )
  }

  QREntryList = () => {
    const { t } = this.props;
    return (
      <Menu
        open={this.state.QREntryPopUp}
        sx={{ height: '60vh' }}
        className="eMed_Header_Request_Pop"
        anchorEl={this.state.RequestAnchor}
        onClose={() => {
          this.setState({ QREntryPopUp: false, DateOpen: false, RegistrationDate: new Date(), QRPatientName: '' }, () => {
            this.getQREntryList()
          })
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <Box display={'flex'} flexDirection={'row'} justifyContent={'flex-end'} alignItems={'center'}>
          <Box>
            <Box display={'flex'} flexDirection={'row'} justifyContent={'flex-end'} alignItems={'center'}>
              <OutlinedInput
                className="emed_ordersearch"
                placeholder="Patient Name"
                onChange={(e) => {
                  let validate = CommonValidation.alphabetOnly(e.target.value)
                  validate &&
                    this.setState({ QRPatientName: e.target.value }, () => {
                      this.getQREntryList()
                    })
                }}
                inputProps={{ emed_tid: "patient_search" }}
                value={this.state.QRPatientName}
                size="small"
                sx={{ width: "15vw", marginRight: "0.5vw" }}
                endAdornment={
                  <InputAdornment position="end">
                    <i class="fas fa-search"></i>
                  </InputAdornment>
                }
              />

              <div style={{ padding: "0.5vw" }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    open={this.state.DatePickerOpen}
                    onOpen={() => { this.setState({ DatePickerOpen: true }) }}
                    onClose={() => { this.setState({ DatePickerOpen: false }) }}
                    value={this.state.RegistrationDate}
                    name={"datePicker"}
                    inputFormat='DD-MM-YYYY'
                    views={["year", "month", "day"]}
                    onChange={
                      (newDate) => {
                        this.setState({
                          RegistrationDate: newDate
                        }, () => {
                          this.getQREntryList()
                        });
                      }}
                    renderInput={(params) => <TextField
                      onKeyDown={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                      }} style={{ width: '12vw' }} size='small' {...params} inputProps={{ ...params.inputProps, 'emed_tid': 'QR_Date_Search' }} onClick={() => { this.setState({ DatePickerOpen: true }) }} />}
                  />
                </LocalizationProvider>
              </div>
            </Box>
          </Box>
        </Box>
        <Box>
          <Box className="eMed_App_reqest_table_head" sx={{ width: '51.5vw' }}>
            <Typography width={"20%"} fontWeight={'600'} fontSize={"0.8vw"}>Date & Time</Typography>
            <Typography width={"25%"} fontWeight={'600'} fontSize={"0.8vw"}>Patient Details</Typography>
            <Typography width={"35%"} fontWeight={'600'} fontSize={"0.8vw"}>Address</Typography>
            <Typography width={"20%"} fontWeight={'600'} fontSize={"0.8vw"} textAlign={'center'}>Action</Typography>
          </Box>
          <Divider />
          <Box height={"30vh"} overflow={"scroll"}>
            {
              this.state.QrEntryList.length > 0 ?
                this.state.QrEntryList.map((list) => {
                  let PatientName = `${list.patient_name} (${list?.age}/${list?.gender === 'm' ? "M" : list?.gender === 'f' ? "F" : "T"})`;
                  return (
                    <Box>
                      <Box className="eMed_Header_Request_item">
                        <Box width={'20%'}>
                          <Typography fontWeight={'600'} fontSize={"0.85vw"}>{list?.created_date ? formatDate(list.created_date) : "-"}</Typography>
                          <Typography fontSize={"0.7vw"}>{list?.created_date ? `${list?.created_date.split(" ")[1]} ${list?.created_date.split(" ")[2]}` : "-"}</Typography>
                        </Box>
                        <Box width={'25%'}>
                          <Typography fontWeight={'600'} fontSize={"0.85vw"}>
                            {PatientName ? PatientName?.length > 20 ?
                              <Tooltip placement='top' title={PatientName} arrow>
                                <div>{PatientName.slice(0, 20) + "..."}</div></Tooltip> :
                              PatientName : "-"}
                          </Typography>
                          {(list?.mobile_number) ?
                            <Typography fontSize={"0.7vw"}>{list.mobile_number}</Typography> : null}
                        </Box>
                        <Box width={'35%'}>
                          {list?.address ?
                            <Typography fontWeight={'600'} fontSize={"0.85vw"}>
                              {list?.address ? list?.address?.length > 20 ?
                                <Tooltip placement='top' title={list?.address} arrow>
                                  <div style={{ fontWeight: "600", fontSize: "0.85vw" }}>{list?.address.slice(0, 20) + "..."}</div></Tooltip> :
                                list?.address : "-"}
                            </Typography> :
                            list?.address_line_1 || list?.address_line_2 ?
                              <Box>
                                <Typography fontWeight={'600'} fontSize={"0.85vw"}>
                                  {list?.address_line_1 ? list?.address_line_1?.length > 20 ?
                                    <Tooltip placement='top' title={list?.address_line_1} arrow>
                                      <div style={{ fontWeight: "600", fontSize: "0.85vw" }}>{list?.address_line_1.slice(0, 20) + "..."}</div></Tooltip> :
                                    list?.address_line_1 : "-"}
                                </Typography>
                                <Typography fontWeight={'600'} fontSize={"0.85vw"}>
                                  {list?.address_line_2 ? list?.address_line_2?.length > 20 ?
                                    <Tooltip placement='top' title={list?.address_line_2}><div style={{ fontWeight: "600", fontSize: "0.85vw" }}>{list?.address_line_2.slice(0, 20) + "..."}</div></Tooltip>
                                    : list?.address_line_2 : '-'}
                                </Typography>
                              </Box> : null
                          }
                        </Box>
                        <Box display={'flex'} flexDirection={'row'} justifyContent={'center'} width={'20%'}>
                          <Tooltip title={t("Create Appointment")} arrow placement='top'>
                            <IconButton emed_tid="create_appointment" onClick={() => {
                              this.setState({ QREntryPopUp: false, DateOpen: false, RegistrationDate: new Date(), QRPatientName: '' }, () => {
                                setCachevalue(JSON.stringify(list), "QRRequestPatientData")
                                if (formatDate(list.created_date) === DateTime.fromJSDate(new Date()).toFormat('dd-MM-yyyy')) {
                                  this.props.history.push({ pathname: "/OPHome/Billing/NewQuickBilling" })
                                } else {
                                  this.props.history.push({ pathname: "/OPHome/Billing/CreateAppointment" })
                                }
                              })
                            }}
                              position="end">
                              <img className="eMed_Tick_img" style={{ height: "2vw", width: "2vw" }} src={ImagePaths.Tick.default} alt={"Tick"} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title={t("Cancel Request")} arrow placement='top'>
                            <IconButton emed_tid="cancel_request" onClick={() => { this.CancelQrRequest(list) }}>
                              <CancelIcon sx={{ height: '1.8vw', width: '1.8vw' }} color='error' />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </Box>
                      <Divider />
                    </Box>
                  )
                }) :
                <Box>
                  <Box className="eMed_Header_Request_item" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '20vh' }}>
                    <Typography>{t("NoRecordsFound")}</Typography>
                  </Box>
                </Box>
            }
          </Box>
        </Box>
      </Menu>
    )
  }

  getBadgeCount = () => {
    try {
      let moduleName = this.state.loggedInuserInfo?.module_name === "Doctor" ? 'front_office' : (this.state.loggedInuserInfo?.module_name || '');
      let clinicId = localGetItem('clinicId') || localGetItem('SelectedDoctorClinicId') || this.state.loggedInuserInfo?.clinic_id || null;
      RestAPIService.getAll(Serviceurls.FO_BADGE_COUNT_GET + `?module_name=${moduleName}&clinic_id=${clinicId}&billed_from=${this.state.loggedInuserInfo?.module_name === "Doctor" ? 'DOCTOR' : ''}`)
        .then((response) => {
          if (response?.data?.status === "success") {
            this.setState({
              badgeCount: response?.data?.data ? response?.data?.data : 0,
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error?.response?.data?.message)
          } else {
            this.errorMessage(error?.message)
          }
        })

    } catch (e) {
      this.errorMessage(e?.message)
    }
  }

  FoCallPatientConnect = () => {
    let userData = JSON.parse(localGetItem("loggedInUserInfo"))
    let callPatientChannel = userData?.fo_call_channel_name
    let tokenScreen = userData?.token_screen_channel_name

    if (this.PaitentCall === null) {
      this.PaitentCall = new WebSocket(`${Serviceurls.WEB_SOCKET_DOMAIN}${Serviceurls.FO_CALLPATIENT_WEBSOCKET}${callPatientChannel}/`);
    }
    if (this.FoToDocTokenSocket === null && tokenScreen) {
      this.FoToDocTokenSocket = new WebSocket(`${Serviceurls.WEB_SOCKET_DOMAIN}${Serviceurls.TOKENSCREEN_WEBSOCKET}${tokenScreen}/`);
    }

    this.PaitentCall.onopen = () => {
      console.log(`Patien Call WebSocket connected`);
    }
    this.PaitentCall.onclose = () => {
      console.log(`Patien Call WebSocket disconnected`);
    }
    this.PaitentCall.onerror = (error) => {
      console.log(`Patien Call WebSocket Error`, error);
      if (this.PaitentCall) {
        this.PaitentCall.close()
        this.PaitentCall = null
      }
    }
    this.PaitentCall.onmessage = (e) => {
      const data = JSON.parse(e.data);
      if (data && this.state.loggedInuserInfo?.module_name === "Doctor" && data?.doctor_id === userData?.doctor_id) {
        this.infoMessage(data?.message)
        if (data?.status === "Cancelled") {
          if (this.FoToDocTokenSocket && tokenScreen) {
            this.FoToDocTokenSocket.send(JSON.stringify({
              message_id: data?.message_id,
              action: "remove_message"
            }))
          }
          this.setState({
            CallPatientTrigger: true
          })
        }
      }
      console.log(`Patien Call WebSocket Message`, data);
    }
  }

  getPurposeOfVisitList() {
    let clinicId = localGetItem('SelectedDoctorClinicId') || this.state.loggedInuserInfo?.clinic_id || null;
    try {
      RestAPIService.getAll(Serviceurls.FO_POV_LIST + `?clinic_id=${clinicId}`).
        then((response) => {
          if (response.data.status === "success") {
            let data = response?.data && response?.data?.data?.length > 0 ? response.data.data : []
            let PurposeOfVisitList = []
            data.forEach(item => PurposeOfVisitList.push(item))
            localSetItem("PurposeOfVisit", JSON.stringify(PurposeOfVisitList))
          }
          else {
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  getQREntryList = () => {
    try {
      RestAPIService.getAll(Serviceurls.FO_QR_ENTRY_LIST + `?patient_name=${this.state.QRPatientName}&date=${DateTime.fromJSDate(new Date(this.state.RegistrationDate)).toFormat('yyyy-MM-dd')}`).
        then((response) => {
          if (response.data.status === "success") {
            this.setState({
              QrEntryList: response?.data?.data
            })
          }
          else {
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  getIPcomlaintsdata() {
    try {
      let clinicId = localGetItem('clinicId') || localGetItem('SelectedDoctorClinicId') || this.state.loggedInuserInfo?.clinic_id || null;
      RestAPIService.getAll(Serviceurls.IP_COMPLAINTS_DATASET + `?clinic_id=${clinicId ? clinicId : ""}`).
        then((response) => {
          if (response.data.status === "success") {
            let Array = []
            response.data.data.forEach((element) => { Array.push(element.reason) })
            localSetItem("ipComplaintsDataList", JSON.stringify(Array))
          }
          else {
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  postRequest(list, Status) {
    try {
      const convertTime12to24 = moment(list?.appointment_time, ["h:mm A"]).format("HH:mm");
      let data = {
        "id": list?.id,
        "status": Status,
        "patient_id": list?.patient_id,
        "doctor_id": list?.doctor_id,
        "patient_account_number": list?.patient_account_number,
        "appointment_date": list?.appointment_date,
        "appointment_start_time": convertTime12to24,
        "purpose_of_visit": list?.message,
        "patient_appointment_type": list?.booked_through === "Mobile" ? "Mobile Appointment" : "Web Appointment"
      }
      RestAPIService.create(data, Serviceurls.FO_APPOINT_REQUESTS)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              RequestPopUp: false,
              patientSearch: '',
              App_DocID: null,
            }, () => { this.getAppointRequests() })
            this.props.history.push({ pathname: "/OPHome", state: { RequestBool: true, RequestMessage: response?.data?.message } })
          }
        }).catch((e) => {
          if (e?.response?.data?.message) {
            this.errorMessage(e.response.data.message)
          } else {
            this.errorMessage(e.message)
          }
        })
    } catch (e) {
      if (e?.response?.data?.message) {
        this.errorMessage(e.response.data.message)
      } else {
        this.errorMessage(e.message)
      }

    }
  }

  //Doctor Module Header Search

  DoctorHeaderSearch = () => {
    const { t } = this.props;
    var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
    var UserData = myUser
    return (
      <Box sx={{ marginLeft: '3.2vw' }}>
        <Box component={'div'} display={'flex'} flexDirection={'row'} sx={{ borderRadius: "0.3vw" }}>
          <FormControl size='small' sx={{ width: "13vw", borderRadius: '0.2vw', }} >
            <Select
              className='mui_header_card_dropdown_fo'
              value={UserData?.clinic_staff ? (localGetItem("JMODoctor") ? JSON.parse(localGetItem("JMODoctor")) : (this.state.ClinicList[0]?.id ? this.state.ClinicList[0]?.id : null)) : this.state.SelectedDoctorClinic}
              onChange={(e) => {
                this.setState({ SelectedDoctorClinic: e.target.value }, () => {
                  if (UserData?.clinic_staff) {
                    const selectedClinicObj = this.state.ClinicList.find(item =>
                      (UserData?.clinic_staff ? item.id : item?.clinic_id) === e.target.value
                    );
                    if (UserData?.clinic_staff) {
                      localSetItem('JMODoctor', this.state.SelectedDoctorClinic)
                      localSetItem('ServiceType', selectedClinicObj.service_type)
                      localSetItem('regNo', selectedClinicObj.registration_number)
                    }
                    this.ChangeLoginTokken(this.state.SelectedDoctorClinic)
                  } else {
                    localSetItem('SelectedDoctorClinicId', this.state.SelectedDoctorClinic)
                    setCachevalue(this.state.SelectedDoctorClinic === 'all' ? myUser?.clinic_id : this.state.SelectedDoctorClinic, "SelectedDoctorClinic")
                    this.props.history.push({ pathname: "/DoctorHome", state: { SelectedDoctorClinic: this.state.SelectedDoctorClinic } })
                  }
                })
              }}
              sx={{ backgroundColor: 'white' }}
              MenuProps={{ style: { maxHeight: 250 } }}
            >
              {
                (window.location.pathname === "/DoctorHome" || window.location.pathname === "/IPDoctorHome") ?
                  Array.isArray(this.state.ClinicList) && this.state.ClinicList?.length > 0 && this.state.ClinicList?.map((item, index) => (
                    <MenuItem key={index} value={UserData?.clinic_staff ? item.id : item?.clinic_id}>{UserData?.clinic_staff ? item.name : item?.clinic_name}</MenuItem>
                  )) : null
              }
            </Select>
          </FormControl>
          {UserData?.clinic_staff ? null : <PatientHeaderSearch
            t={this.props.t}
            isLoading={this.state.isPatientisSearching}
            filterVisible={this.state.PatientAddressKey === "" && this.state.PatientFathHusKey === "" && this.state.PatientMotherKey === "" && this.state.FilterDob === null && this.state.FilterUHID === "" && this.state.FilterOP === ""}
            flterOpen={this.handleFilterOpen}
            faceOpen={this.handleFaceOpen}
            module_name={"Doctor"}
            onSearchSubmit={this.handleSearchSubmit}
            onClear={this.handleSearchClear}
            searchValue={this.state.PatientNameSearchKey}
            faceVisible={this.state.isfaceRecognizationEnabled}
          />}
        </Box>
        <Menu
          open={this.state.PatientSearchClicked}
          className="eMed_Header_Search_Pop"
          disableAutoFocus
          disableEnforceFocus
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          MenuListProps={{
            autoFocus: false
          }}
          onClose={() => {
            this.setState({
              PatientSearchClicked: false,
              // PatientNameSearchKey: "",
              PatientAddressKey: "",
              PatientFathHusKey: "",
              PatientMotherKey: "",
              FilterDob: null,
              FilterUHID: "",
              FilterOP: "",
            })
          }}
        >
          {
            this.state.SearchDoctorPatientList.length > 0 ?
              this.state.SearchDoctorPatientList?.map((list) => {
                let PatientFullName = `${list.first_name} ${list.last_name}`
                list["patient_name"] = PatientFullName
                list["patient_mobile_number"] = list.mobile_number
                list["patient_photo_url"] = list.photo_url
                return (
                  <Box>
                    <Box className="eMed_Header_Search_item">
                      <CommonPatientDetails data={list} fromSearch={true} isCommonUhid={this.state.common_uhid} />
                      <Tooltip title={t("Last Visit Date")} arrow>
                        <div style={{ fontSize: "0.65vw", fontWeight: "bold" }}>Last Visited Date</div>
                        <Typography sx={{ fontSize: '0.85vw' }}>OP: {formatDate(list?.op_last_visit_date)}</Typography>
                        <Typography sx={{ fontSize: '0.85vw' }}>IP: {formatDate(list?.ip_last_visit_date)}</Typography>
                      </Tooltip>
                      {(window.location.pathname === "/DoctorHome") ?
                        (list.appointment_date === "" || list.appointment_status === "Cancelled") ?
                          <Box component={'div'} className="eMed_Header_Search_icons">
                            {
                              <>
                                <Tooltip title={t("EditPatientDetails")} arrow>
                                  <IconButton onClick={() => {
                                    this.setState({
                                      PatientNameSearchKey: "",
                                      PatientAddressKey: "",
                                      PatientFathHusKey: "",
                                      FilterDob: null,
                                      FilterUHID: "",
                                      FilterOP: "",
                                      PatientSearchClicked: false,
                                      SearchedPatientList: [],
                                      PatientMotherKey: "",
                                      common_uhid: false,
                                    }, () => {
                                      this.getDoctorPatientDetailData(list?.patient_id, 'Edit Patient')
                                    })
                                  }}
                                    position="end">
                                    <Edit color='primary' />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip disabled={list?.op_has_current_appointment} title={t("CreateAppointment")} arrow>
                                  <IconButton onClick={() => {
                                    this.setState({
                                      PatientNameSearchKey: "",
                                      PatientAddressKey: "",
                                      PatientFathHusKey: "",
                                      FilterDob: null,
                                      FilterUHID: "",
                                      FilterOP: "",
                                      PatientSearchClicked: false,
                                      SearchedPatientList: [],
                                      PatientMotherKey: "",
                                      common_uhid: false,
                                    }, () => {
                                      this.getDoctorPatientDetailData(list?.patient_id, 'Create Patient')
                                    })
                                  }}
                                    position="end">
                                    <PersonAddAlt1Icon sx={{ color: list.op_has_current_appointment ? Colors.disableLabelColor : Colors.themeDark }} />
                                  </IconButton>
                                </Tooltip>
                              </>}
                          </Box>
                          :
                          <Box component={'div'} className="eMed_Header_Search_icons">
                            {<>
                              <Tooltip title={t("EditPatientDetails")} arrow>
                                <IconButton onClick={() => {
                                  this.setState({
                                    PatientNameSearchKey: "",
                                    PatientAddressKey: "",
                                    PatientFathHusKey: "",
                                    FilterDob: null,
                                    FilterUHID: "",
                                    FilterOP: "",
                                    PatientSearchClicked: false,
                                    SearchedPatientList: [],
                                    PatientMotherKey: "",
                                    common_uhid: false,
                                  }, () => {
                                    setCachevalue(JSON.stringify(list), "DoctorPatientData")
                                    this.props.history.push({ pathname: "/DoctorHome/Demographics/update", state: { fromCreate: false, doctorUpdate: true } })
                                  })
                                }}
                                  position="end">
                                  <Edit color='primary' />
                                </IconButton>
                              </Tooltip>
                              <Tooltip disabled={list?.op_has_current_appointment} title={t("CreateAppointment")} arrow>
                                <IconButton onClick={() => {
                                  this.setState({
                                    PatientNameSearchKey: "",
                                    PatientAddressKey: "",
                                    PatientFathHusKey: "",
                                    FilterDob: null,
                                    FilterUHID: "",
                                    FilterOP: "",
                                    PatientSearchClicked: false,
                                    SearchedPatientList: [],
                                    PatientMotherKey: "",
                                    common_uhid: false,
                                  }, () => {
                                    this.getDoctorPatientDetailData(list?.patient_id, 'Create Patient')
                                  })
                                }}
                                  position="end">
                                  <PersonAddAlt1Icon sx={{ color: list.op_has_current_appointment ? Colors.disableLabelColor : Colors.themeDark }} />
                                </IconButton>
                              </Tooltip>
                            </>
                            }
                          </Box>
                        : null
                      }
                    </Box>
                    <Divider />
                  </Box>
                )
              }) : null
          }
        </Menu>
        <Menu
          open={this.state.AddressFilterClicked}
          className="eMed_Header_Filter_Pop"
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          onClose={() => {
            this.setState({ AddressFilterClicked: false })
          }}
        >
          {this.DynamicFilterFeilds()}
        </Menu>
      </Box>
    )
  }

  getDoctorClinicData = () => {
    try {
      RestAPIService.getAll(Serviceurls.DOC_CLINIC_LIST_GET)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              ClinicList: response.data.data
            }, () => {
              if (!localGetItem('SelectedDoctorClinicId') && !getCachevalue('SelectedDoctorClinic')) {
                this.setState({
                  SelectedDoctorClinic: response?.data?.data[0]?.clinic_id
                }, () => {
                  let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
                  localSetItem('SelectedDoctorClinicId', this.state.SelectedDoctorClinic)
                  if (!UserData?.clinic_staff) {
                    setCachevalue(this.state.SelectedDoctorClinic === 'all' ? UserData?.clinic_id : this.state.SelectedDoctorClinic, "SelectedDoctorClinic")
                  }
                  this.getDoctorAppointmentList()
                  if (localGetItem("PurposeOfVisit") === null) {
                    this.getPurposeOfVisitList()
                  }
                })
              } else {
                this.getDoctorAppointmentList()
                if (localGetItem("PurposeOfVisit") === null) {
                  this.getPurposeOfVisitList()
                }
              }
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getTransferAppointmentData = () => {
    try {
      let startdate = new Date()
      let date = DateTime.fromJSDate(startdate).toFormat('yyyy-MM-dd')
      RestAPIService.getAll(Serviceurls.DOC_TRANSFER_REQUEST + '?appointment_date=' + date)
        .then((response) => {
          if (response.data.status === 'success') {
            let dataList = response.data.data
            dataList?.forEach(element => {
              let gender = element?.gender === 'm' ? 'M' : element.gender === 'f' ? 'F' : 'T'
              element.patientDetails = `${element?.title} ${element?.first_name} ${element?.last_name} (${element.patient_age}/${gender})`
              element.patientUnidMob = `${element?.patient_account_number} | ${element?.patient_mobile}`
              element.doctorName = `${element.from_doctor__title} ${element?.from_doctor__first_name} ${element?.from_doctor__qualifications}`
              element.doctor_data = null
              element.specialization_data = null
            })
            this.setState({
              transferReqData: dataList?.filter(item => item?.doctor_id === this.state.loggedInuserInfo?.doctor_id || item.doctor_id === null)
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getUnlockNotesData = () => {
    try {
      let clinicId = localGetItem('SelectedDoctorClinicId')
      if (clinicId) {
        RestAPIService.getAll(Serviceurls.DOC_UNLOCK_DOCTOR_NOTES + `?clinic_id=${clinicId}`)
          .then((response) => {
            if (response.data.status === 'success') {
              this.setState({
                unlockDocData: response.data.data,
                unlockDocDataCount: response.data?.total_count ? response.data?.total_count : 0
              })
            }
          }).catch((error) => {
            if (error?.response?.data?.message) {
              this.errorMessage(error.message)
            } else {
              this.errorMessage(error.message)
            }
          })
      }
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  unlockNotesTable = () => {
    const { t } = this.props
    try {
      return (
        <div>
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", marginBottom: "0.65vw" }}>
            <div>Unlocked Doctor Notes</div>
          </div>
          <div>
            <Box>
              <Box className="eMed_App_reqest_table_head" width={'35vw'}>
                <Typography width={"50%"} fontWeight={'600'} fontSize={"0.8vw"}>Date</Typography>
                <Typography width={"50%"} fontWeight={'600'} fontSize={"0.8vw"}>No of Patient</Typography>
              </Box>
              <Box height={"57vh"} overflow={"scroll"} mt={"0.5vw"}>
                {this.state.unlockDocData && this.state.unlockDocData.length > 0 ?
                  this.state.unlockDocData.map((list) => {
                    return (
                      <Box>
                        <Box component={'div'} className="eMed_Header_Request_item" style={{ cursor: "pointer" }} width={'35vw'} onClick={() => { this.setState({ unlockDate: list?.appointment_date?.split("T")[0], unlockNotespopup: false }) }}>
                          <Box width={'50%'}>
                            <Typography fontWeight={'600'} fontSize={"0.85vw"}>{list?.appointment_date ? list?.appointment_date : "-"}</Typography>
                          </Box>
                          <Box width={'50%'}>
                            <Typography fontWeight={'600'} fontSize={"0.85vw"}>
                              {list?.total ? list?.total : "-"}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    )
                  })
                  :
                  <Box>
                    <Box className="eMed_Header_Request_item" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '20vh' }}>
                      <Typography>{t("NoRecordsFound")}</Typography>
                    </Box>
                  </Box>
                }
              </Box>
            </Box>
          </div>
        </div>
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  renderTransferListPopup = () => {
    try {
      this.state.transferReqData?.forEach((element, index) => element.sno = index + 1)
      const column = [
        {
          field: 'patientDetails', headerName: 'Patient Details', flex: 0.143,
          renderCell: (params) => {
            let patientName = params?.row?.patientDetails
            let patientAccMob = params?.row?.patientUnidMob
            return (
              <Box component={'div'}>
                {patientName ? patientName?.length > 20 ?
                  <Tooltip placement='top' title={patientName}><Box fontWeight={600} fontSize={'0.9vw'}>{patientName?.slice(0, 20) + '...'}</Box></Tooltip> :
                  <Box fontWeight={600} fontSize='0.9dvw'>{patientName}</Box> : '-'}
                {patientAccMob ? patientAccMob?.length > 20 ?
                  <Tooltip placement='top' title={patientAccMob}><Box fontSize={'0.8dvw'} color={Colors.grayShade}>{patientAccMob?.slice(0, 20) + '...'}</Box></Tooltip> :
                  <Box fontSize={'0.8dvw'} color={Colors.grayShade}>{patientAccMob}</Box> : '-'}
              </Box>
            )
          }
        },
        {
          field: 'from_doctor__first_name', headerName: 'Previous Consultant', flex: 0.143,
          renderCell: (params) => {
            let doctorName = params?.row?.doctorName
            let specialisation = params?.row?.specialization_name
            return (
              <Box>
                {doctorName ? doctorName?.length > 12 ?
                  <Tooltip placement='top' title={doctorName}><Box fontSize={'0.9dvw'} fontWeight={600}>{doctorName?.slice(0, 12) + '...'}</Box></Tooltip> :
                  <Box fontSize={'0.9dvw'} fontWeight={600}>{doctorName}</Box> : '-'}
                {specialisation ? specialisation?.length > 12 ?
                  <Tooltip placement='top' title={specialisation}><Box fontSize={'0.8dvw'} color={Colors.grayShade}>{specialisation?.slice(0, 12) + '...'}</Box></Tooltip> :
                  <Box fontSize={'0.8dvw'} color={Colors.grayShade}>{specialisation}</Box> : '-'}
              </Box>
            )
          }
        },
        {
          field: 'purpose_of_visit', headerName: 'Purpose of Visit', flex: 0.143,
          renderCell: (params) => {
            let pov = params?.row?.purpose_of_visit
            return (
              pov ? pov?.length > 15 ?
                <Tooltip placement='top' title={pov}><Box>{pov?.slice(0, 15) + '...'}</Box></Tooltip> :
                pov : '-'
            )
          }
        },
        {
          field: 'transfer_notes', headerName: 'Transfer Notes', flex: 0.11,
          renderCell: (params) => {
            let notes = params?.row?.transfer_notes
            return (
              <Box>
                {notes ? notes?.length > 15 ?
                  <Tooltip placement='top' title={notes}><Box>{notes?.slice(0, 15) + '...'}</Box></Tooltip> :
                  notes : '-'}
              </Box>
            )
          }
        },
        {
          field: 'specilaization', headerName: 'Specializiation', flex: 0.183,
          renderCell: (params) => {
            let specialization = params?.row?.specialization_name
            return (
              <Box component={'div'}>
                {specialization ? specialization?.length > 20 ?
                  <Tooltip placement='top' title={specialization}><Box>{specialization?.slice(0, 20) + '...'}</Box></Tooltip> :
                  specialization : '-'}
              </Box>
            )
          }
        },
        {
          field: 'Doctor Name', headerName: 'Doctor Name', flex: 0.183,
          renderCell: (params) => {
            let docName = params?.row?.doctor_name
            return (
              <Box component={'div'}>
                {docName ? docName?.length > 20 ?
                  <Tooltip placement='top' title={docName}><Box>{docName?.slice(0, 20) + '...'}</Box></Tooltip> :
                  docName : '-'}
              </Box>
            )
          }
        },
        {
          field: 'action', headerName: 'Action', flex: 0.1,
          renderCell: (params) => {
            return (
              <Box component={'div'}>
                <Tooltip placement='top' title='Create Appointment'><Button
                  className='Common_Btn_Min_Width'
                  startIcon={<CheckCircleOutlineIcon color='primary' />}
                  onClick={() => this.cancelTransRequest(params?.row?.id, 'Approved')}
                /></Tooltip>
                <Tooltip placement='top' title={'Cancel'}>
                  <Button
                    className='Common_Btn_Min_Width'
                    startIcon={<CancelIcon color='error' />}
                    onClick={() => this.cancelTransRequest(params?.row?.id, 'Cancelled')}
                  ></Button>
                </Tooltip>
              </Box>
            )
          }
        },
      ]
      return (
        <Box component={'div'}>
          <Dialog
            open={this.state.TransAppoint}
            maxWidth="lg"
            fullWidth
          >
            <Box className='emedhub_popup_lobby' p={'1rem'}>
              <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                <Box component={'div'} display={'flex'} alignItems={'center'} mb={'0.5rem'}>
                  <Typography fontSize={'0.9dvw'} fontWeight={600} mr={'1rem'}>Transferred List</Typography>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      open={this.state.transDatePickerOpen}
                      onOpen={() => { this.setState({ transDatePickerOpen: true }) }}
                      onClose={() => { this.setState({ transDatePickerOpen: false }) }}
                      value={this.state.datePickerTrans}
                      name={"datePicker"}
                      inputFormat='DD-MM-YYYY'
                      views={["year", "month", "day"]}
                      onChange={(newDate) => {
                        this.setState({ datePickerTrans: newDate }, () => this.getTransferAppointmentData());
                      }}
                      renderInput={(params) => (
                        <TextField
                          onKeyDown={(e) => e.preventDefault()}
                          style={{ width: '10vw' }}
                          size='small'
                          {...params}
                          onClick={() => { this.setState({ transDatePickerOpen: true }) }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Box>
                <Button
                  className='Common_Btn_Min_Width'
                  onClick={() => this.setState({ TransAppoint: false })}
                >
                  <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1dvw'} width={'1dvw'} />
                </Button>
              </Box>
              <Box component={'div'} height={'30dvw'}>
                <DataGrid
                  columns={column}
                  rows={this.state.transferReqData}
                  getRowId={(row) => row['sno']}
                  localeText={{
                    toolbarColumns: "",
                    toolbarDensity: "",
                    toolbarExport: "",
                    toolbarFilters: "",
                    toolbarExportPrint: ""
                  }}
                  components={{
                    NoRowsOverlay: () => (
                      <Box className='' sx={{ position: 'relative', top: '10vw', left: '33vw' }}>
                        {'No Records To Be Shown'}
                      </Box>
                    )
                  }}
                  pageSizeOptions={[10, 20, 30]}
                  pagination
                  paginationMode="client"
                  paginationModel={{
                    page: this.state.transPage,
                    pageSize: this.state.transPageSize
                  }}
                  onPaginationModelChange={(model) => {
                    this.setState({
                      transPage: model.page,
                      transPageSize: model.pageSize
                    })
                  }}
                  headerHeight={40}
                  disableRowSelectionOnClick
                  loading={this.state.loading}
                />
              </Box>
            </Box>
          </Dialog>
        </Box>
      )
    } catch (error) {
      this.errorMsgFunc(error.message)
    }
  }

  postDoctorPrint = () => {
    try {
      let status = [];
      let states = this.state
      if (states.all) {
        status = []
      } else {
        if (states.booked) {
          status.push('Booked')
        }
        if (states.arrived) {
          status.push('Arrived')
        }
        if (states.withNurse) {
          status.push('With Nurse')
        }
        if (states.withDoctor) {
          status.push('With Doctor')
        }
        if (states.completed) {
          status.push('Completed')
        }
        if (states.cancelled) {
          status.push('Cancelled')
        }
      }
      let clinicId = localGetItem('SelectedDoctorClinicId')
      let startDate = new Date(this.state.doctorAppointmentDate)
      let date = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')
      RestAPIService.getAll(Serviceurls.DOC_APPOINTMENT_LIST + `?appointment_date=${date}&clinic_id=${clinicId}&appointment_status=${status}&export=pdf`)
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({
            doctorAnchor: null, openDoctorPrint: false, all: true,
            booked: true, arrived: true, withNurse: true, withDoctor: true,
            completed: true, cancelled: true
          })
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  printDoctorHistoryData = () => {
    try {
      let patientDetails = getCachevalue('DoctorPatientData')
      let appointmentId = JSON.parse(patientDetails)
      RestAPIService.getAll(Serviceurls.DOC_HISTORY_REPORT_PRINT + `?appointment_id=${appointmentId?.appointment_id}&patient_id=${appointmentId?.patient_id}&export=pdf`)
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }
  printImmunizationData = () => {
    try {
      let patientDetails = getCachevalue('DoctorPatientData')
      let appointmentId = JSON.parse(patientDetails)
      RestAPIService.getAll(Serviceurls.DOC_IMMUNIZATION_PRINT + `?patient_id=${appointmentId?.patient_id}&export_type=pdf`)
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getDoctorNotesPrint = () => {
    try {
      let notesList = [];
      let states = this.state
      let flag = false
      flag = states.doctorPrintList?.other_doctor?.every(item => !item.is_checked)
      let fullReport = states.doctorPrintList?.other_doctor?.find(item => item?.label === 'Full Report')
      if (fullReport?.is_checked) {
        notesList?.push('FullReport')
      } else {
        states.doctorPrintList?.other_doctor?.filter(item => item?.is_checked && item.label !== 'Full Report')?.forEach(element => {
          if (element?.is_checked) {
            notesList?.push(element?.value)
          }
        })
      }
      if (!flag) {
        let patientDetails = getCachevalue('DoctorPatientData')
        let appointmentId = JSON.parse(patientDetails)
        RestAPIService.getAllPrint(Serviceurls.DOC_DOCTOR_NOTES_PRINT + `?appointment_id=${appointmentId?.appointment_id}&patient_id=${appointmentId?.patient_id}&doctor_notes=${notesList}`)
          .then((response) => {
            const file = new Blob(
              [response.data],
              { type: 'application/pdf' });
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
            this.setState({ openDoctorNotesPrintAnchor: null, openDoctorNotesPrint: false, doctorPrintList: JSON.parse(this.state.dupDocPrintList) })
          }).catch((error) => {
            if (error?.response?.data?.message) {
              this.errorMessage(error.response.data.message)
            } else {
              this.errorMessage(error.message)
            }
          })
      } else {
        this.errorMessage('Please Select Atleast one for Print')
      }
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getRefundRefundCOunt = (status) => {
    if (status == true) {
      this.getRefundRequestData()
    }
  }

  // refund request get 
  getRefundRequestData = () => {
    try {
      RestAPIService.getAll(Serviceurls.NEW_BILING_CANCEL_REQUEST)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              CashCounterRefundRequestList: response.data.data,
            })
          }
        }).catch((error) => {
          this.errorMessage(error?.response?.data?.message || error?.message);
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  // draft get api 
  getDraftBillData = () => {
    const { opDraftDate, loggedInuserInfo } = this.state;

    try {
      const date = DateTime.fromJSDate(new Date(opDraftDate)).toFormat('yyyy-MM-dd');
      this.setState({ opDraftLoad: true });

      const moduleMap = {
        Laboratory: 'LAB',
        Radiology: 'RADIOLOGY',
        Investigation: GetInvestigationName(),
        Doctor: 'Doctor'
      };

      const moduleType = moduleMap[loggedInuserInfo?.module_name] || '';

      RestAPIService.getAll(`${Serviceurls.NEW_BILLING_SAVED_BILL_GET}?date=${date}&module_type=${moduleType}`)
        .then((response) => {
          if (response?.data?.status === 'success') {
            const data = response.data.data;
            this.setState({
              opDraftList: data,
              dupOpDraftList: JSON.stringify(data),
              opDraftLoad: false
            });
          }
        })
        .catch((error) => {
          this.setState({ opDraftLoad: false });
          this.errorMessage(error?.response?.data?.message || error?.message);
        });

    } catch (error) {
      this.setState({ opDraftLoad: false });
      this.errorMessage(error.message);
    }
  };

  // get radiology data
  getRadAppointmentListData = (fromoplist = false) => {
    try {
      const fromDate = fromoplist ? this.state.opListDate : this.state.radAppointmentDate
      const startDate = new Date(fromDate)
      const date = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')
      const clinicId = JSON.parse(localGetItem('loggedInUserInfo'))
      RestAPIService.getAll(Serviceurls.RAD_APPOINTMENT_GET + `?search_date=${date}` + '&clinic_id=' + clinicId?.clinic_id)
        .then((response) => {
          if (response.data.status === 'success') {
            const opListFilter = response?.data?.data?.filter(item => !item?.is_ip)
            this.setState({
              radAppointmentList: response.data.data,
              dupAppointmentList: JSON.stringify(response.data.data),
              opListData: opListFilter,
              dupOpList: JSON.stringify(opListFilter)
            })
          }
        }).catch((error) => {
          this.errorMessage(error?.response?.data?.message || error?.message);
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  // get approvals data
  getApproverListData = (approverDate, searchApproverList) => {
    try {
      const userId = localGetItem('loggedUserId')
      const startDate = new Date(approverDate)
      const date = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')
      this.setState({ approverLoad: true })
      const myUser = JSON.parse(localGetItem("loggedInUserInfo"))
      RestAPIService.getAll(Serviceurls.NEW_BILLING_PENDING_LIST + '?approver_id=' + userId + '&request_status=Requested' + '&from_date=' + date + '&to_date=' + date)
        .then((response) => {
          if (response?.data?.status === 'success') {
            const RequestsList = response?.data?.data?.filter((list) => (list?.module_type !== "IP" || myUser?.module_name === "front_office")) || []
            this.setState({
              approverList: RequestsList,
              dupApproverList: JSON.stringify(RequestsList),
              approverLoad: false
            })
            const searchValue = searchApproverList?.toLowerCase();
            if (searchValue) {
              const dupApproverList = RequestsList?.filter((item) =>
                ['patient_name', 'patient_mobile_number', 'patient_account_number']?.some(key =>
                  item[key]?.toLowerCase().includes(searchValue)
                ))
              this.setState({ approverList: dupApproverList })
            }
          }
        }).catch((error) => {
          this.setState({ approverLoad: false })
          this.errorMessage(error?.response?.data?.message || error?.message);
        })
    } catch (error) {
      this.setState({ approverLoad: false })
      this.errorMessage(error.message)
    }
  }

  // render op list 
  renderOpListPopup = (FromCashCounter = false) => {
    const module_paths = {
      front_office: '/HospitalBilling/HospitalBilling',
      Laboratory: '/LabBilling/HospitalBilling',
      Radiology: '/RadiologyBilling/HospitalBilling',
      Investigation: `/${GetInvestigationName()}Billing/HospitalBilling`,
      Doctor: '/DoctorBilling'
    };

    const cashModulePaths = {
      front_office: '/HospitalBilling/CashCounter',
      Laboratory: '/LabBilling/CashCounter',
      Radiology: '/RadiologyBilling/CashCounter',
      Investigation: `/${GetInvestigationName()}Billing/CashCounter`,
      Pharmacy: '/PharmacyBilling/CashCounter'
    };
    try {
      return (
        <Box component={'div'} key={window.location.pathname}>
          <Menu
            id="basic-menu"
            anchorEl={this.state.isOpListAnchor}
            open={this.state.isOpList || this.state.rtWalkinOpen}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
            sx={{ position: 'absoulte', top: '2.5vw' }}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'bottom',
            }}
            transformOrigin={{
              vertical: 'bottom',
              horizontal: 'bottom',
            }}
          >
            <Box component={'div'} p={'0.5vw'}>
              <Box component={'div'} display={'flex'} justifyContent={'space-between'}>
                <Typography fontWeight={600} fontSize={'0.9vw'}>{this.state.rtWalkinOpen ? "RT Walkin Appointments" : "Appointments"}</Typography>
                <Box component={'div'} onClick={() => this.setState({ isOpList: false, rtWalkinOpen: false, opListDate: new Date() },
                  () => { this.getRadAppointmentListData(true) })} sx={{ cursor: 'pointer' }}>
                  <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1vw'} width={'1vw'} />
                </Box>
              </Box>
              <Box component={'div'} mt={'0.5vw'} display={'flex'}>
                <TextField
                  size='small'
                  value={this.state.searchOpList}
                  onChange={(e) => {
                    const searchValue = e.target.value.toLowerCase();
                    const { rtWalkinOpen, dupwalkInAppointData, dupOpList } = this.state;

                    this.setState({ searchOpList: e.target.value }, () => {
                      const sourceData = JSON.parse(rtWalkinOpen ? dupwalkInAppointData : dupOpList);
                      const key = rtWalkinOpen ? "patient_names" : "patient_name";

                      const filteredData = searchValue
                        ? sourceData.filter(item =>
                          item?.[key]?.toLowerCase().includes(searchValue)
                        )
                        : sourceData;

                      this.setState({
                        [rtWalkinOpen ? "walkInAppointData" : "opListData"]: filteredData
                      });
                    });
                  }}
                  onKeyDown={(e) => {
                    e.stopPropagation()
                  }}
                  sx={{ width: '20vw', mr: '1vw' }}
                  placeholder='Search Appointment....'
                />
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    open={this.state.opListDatePickerOpen}
                    onOpen={() => { this.setState({ opListDatePickerOpen: true }) }}
                    onClose={() => { this.setState({ opListDatePickerOpen: false }) }}
                    value={this.state.opListDate}
                    name={"datePicker"}
                    inputFormat='DD-MM-YYYY'
                    views={["year", "month", "day"]}
                    onChange={(newDate) => {
                      this.setState({ opListDate: newDate },
                        () => { this.getRadAppointmentListData(true) })
                    }}
                    renderInput={(params) => <TextField onKeyDown={(e) => e.preventDefault()}
                      style={{ width: '10vw' }} size='small' {...params}
                      onClick={() => { this.setState({ opListDatePickerOpen: true }) }} />}
                  />
                </LocalizationProvider>
              </Box>
              <Box component={'div'} maxHeight={'60dvh'} overflow={'auto'}>
                {this.state.opListData?.length > 0 ? this.state.opListData?.map((item, index) => {
                  return (
                    <Box component={'div'} key={index} display={'flex'} alignItems={'center'} mt={'1vw'}>
                      <Box component={'div'} display={'flex'} alignItems={'center'} width={'22vw'}>
                        <Box component={'div'} display={'flex'} alignItems={'center'} mr={'0.5vw'}>
                          <Box component={'img'}
                            src={item?.patient_photo_url === null || item?.patient_photo_url === "" || item?.patient_photo_url === undefined ? item?.patient_gender === "Male" || item?.patient_gender === "m" || item?.gender === "m" ? ImagePaths.Male.default : ImagePaths.Female.default : item?.patient_photo_url} height={'2.8vw'} width={'2.8vw'}
                            border={`1.8px solid ${(item?.patient_type === "new_patient" || item?.patient__patient_type === 1) ? "#F1584A" : (item?.patient_type === "old_patient") || (item?.patient_type === "establish_patient") || (item?.patient__patient_type === 3) ? "#800080" : '#29B6F6'}`}
                            borderRadius={'50px'}
                          />
                        </Box>
                        <Box component={'div'}>
                          {item?.patient_name ?
                            item?.patient_name?.length > 14 ?
                              <Tooltip placement='top' title={item?.patient_name} arrow><Typography component={'div'} fontWeight={600} fontSize={'0.9vw'} >{item?.patient_name?.slice(0, 14) + '...'}
                                <Typography component={'span'} fontSize={'0.9vw'} fontWeight={600}>{`${item?.patient_age ? item?.patient_age : '-'}/${item?.patient_gender ? (item?.patient_gender)?.toUpperCase() : '-'}`}</Typography>
                              </Typography></Tooltip> :
                              <Typography component={'div'} fontWeight={600} fontSize={'0.9vw'} >{item?.patient_name}
                                <Typography component={'span'} fontSize={'0.9vw'} fontWeight={600} ml={'0.5vw'}>{`${item?.patient_age ? item?.patient_age : '-'}/${item?.patient_gender ? (item?.patient_gender)?.toUpperCase() : '-'}`}</Typography>
                              </Typography>
                            : '-'}
                          <Typography component={'div'} color={Colors.grayShade} fontSize={'0.8vw'}>{item?.patient_account_number ? item.patient_account_number : '-'} |
                            <Typography component={'span'} fontSize={'0.8vw'} color={Colors.grayShade}>{item?.patient_mobile_number ? item?.patient_mobile_number : '-'}</Typography>
                          </Typography>
                        </Box>
                      </Box>
                      <Box component={'div'}>
                        <Button variant='contained' size='small' emed_tid='rad_ip_req_btn'
                          onClick={() => {
                            this.setState({ isOpListAnchor: null, searchOpList: '', isOpList: false, opListDate: new Date() }, () => {
                              if (FromCashCounter) {
                                const { module_name } = this.state.loggedInuserInfo || {};
                                const cashtargetPath = cashModulePaths[module_name];
                                this.props.history?.push({ pathname: cashtargetPath, states: { patient_details: item, fromPharmacy: module_name === 'Pharmacy', from_op_list: true, module: "op" } });
                              } else {
                                const { module_name } = this.state.loggedInuserInfo || {};
                                const targetPath = module_paths[module_name];
                                this.props.history?.push({ pathname: targetPath, state: { opListData: item, fromOpList: true } });
                                setTimeout(() => this.props.history?.push({ pathname: targetPath, state: {} }), 5000);
                              }
                            });
                          }}
                        >Proceed</Button>
                      </Box>
                    </Box>
                  )
                }) : <Typography display={'flex'} justifyContent={'center'} mt={'2vw'}>No Records To Be Shown</Typography>}
              </Box>
            </Box>
          </Menu>
        </Box>
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  onDeleteNewDraftItem = (item) => {
    try {
      const data = { id: item?.id }
      RestAPIService.delete(Serviceurls.NEW_COMPLETE_BILLS_GET, data)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.successMessage(response?.data?.message)
            this.getDraftBillData()
            this.getBadgeCount()
          }
        }).catch(error => {
          this.errorMessage(error?.response?.data?.message || error.message)
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  renderOPDraftPopup = () => {
    try {
      this.state.opDraftList?.forEach((element, index) => element.sno = index + 1)
      const columns = [
        {
          field: 'patient_details', headerName: 'Patient Details', flex: 0.3,
          renderCell: (params) => {
            return (
              <Box>{renderPatientCard(params?.row?.patient_data)}</Box>
            )
          }
        },
        {
          field: 'op_number', headerName: 'OP Number', flex: 0.2,
          renderCell: (params) => {
            let opNumber = params?.row?.op_number
            return (
              <Box>
                {opNumber ? opNumber?.length > 15 ?
                  <Tooltip placement='top' title={opNumber}><Typography fontSize={'0.9rem'} fontWeight={600}>{'...' + opNumber?.slice(-15)}</Typography></Tooltip> :
                  <Typography fontSize={'0.9rem'} fontWeight={600}>{opNumber}</Typography> : '-'}
              </Box>
            )
          }
        },
        {
          field: 'draft_details', headerName: 'Draft Details', flex: 0.2,
          renderCell: (params) => {
            let tempInvoice = params?.row?.temp_invoice_number
            return (
              <Box>
                {tempInvoice ? tempInvoice?.length > 15 ?
                  <Tooltip placement='top' title={tempInvoice}><Typography fontSize={'0.9rem'} fontWeight={600}>{'...' + tempInvoice?.slice(-15)}</Typography></Tooltip> :
                  <Typography fontSize={'0.9rem'} fontWeight={600}>{tempInvoice}</Typography> : '-'}
                <Typography fontSize={'0.8rem'} color={Colors.grayShade}>{params?.row?.invoice_date}</Typography>
              </Box>
            )
          }
        },
        {
          field: 'doctor_details', headerName: 'Doctor/Nurse Details', flex: 0.2,
          renderCell: (params) => {
            let doctorName = params?.row?.patient_data?.doctor_name
            let doctorSpec = params?.row?.patient_data?.specialization_name
            return (
              <Box>
                {doctorName ? doctorName?.length > 15 ?
                  <Tooltip placement='top' title={doctorName}><Typography fontSize={'0.9rem'} fontWeight={600}>{doctorName?.slice(0, 15) + '...'}</Typography></Tooltip> :
                  <Typography fontSize={'0.9rem'} fontWeight={600}>{doctorName}</Typography> : '-'}
                {doctorSpec ? doctorSpec?.length > 15 ?
                  <Tooltip placement='top' title={doctorSpec}><Typography fontSize={'0.8rem'} color={Colors.grayShade}>{doctorSpec?.slice(0, 15) + '...'}</Typography></Tooltip> :
                  <Typography fontSize={'0.8rem'} color={Colors.grayShade}>{doctorSpec}</Typography> : '-'}
              </Box>
            )
          }
        },
        {
          field: 'action', headerName: 'Action', flex: 0.1, align: 'center',
          renderCell: (params) => {
            const { module_name } = this.state.loggedInuserInfo || {};
            const targetPath = modulePaths[module_name];
            return (
              <Box>
                {targetPath && (
                  <>
                    <IconButton
                      onClick={() => {
                        this.setState(
                          { isOpDraft: false, isOpDraftAnchor: null, opDraftDate: new Date(), opDraftDatePickerOpen: false, searchOpDraftList: '' },
                          () => {
                            this.props.history?.push({ pathname: targetPath, state: { draftData: params?.row, fromDraft: true } });
                            setTimeout(() => this.props.history?.push({ pathname: targetPath, state: {} }), 5000);
                          }
                        );
                      }}
                    >
                      <Box component={'img'} src={ImagePaths.CreateBill.default} height={'1.5dvw'} width={'1.8dvw'} />
                    </IconButton>
                    <IconButton
                      onClick={() => { this.onDeleteNewDraftItem(params?.row) }}
                    >
                      <Box component={'img'} src={ImagePaths.Delete.default} height={'1.5dvw'} width={'1.8dvw'} />
                    </IconButton>
                  </>
                )}
              </Box>
            )
          }
        },
      ]
      return (
        <Dialog open={this.state.isOpDraft} maxWidth='md' fullWidth>
          <Box component={'div'} className='com_billing_popup' p={'0.5vw'}>
            <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
              <Typography fontWeight={600}>OP Draft List</Typography>
              <Button className='Common_Btn_Min_Width'
                onClick={() => this.setState({ isOpDraft: false, isOpDraftAnchor: null, opDraftDatePickerOpen: false, opDraftDate: new Date(), searchOpDraftList: '' }, () => { this.getDraftBillData() })}
              >
                <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1vw'} width={'1vw'} />
              </Button>
            </Box>
            <Box component={'div'} m={'0.5vw 0.5vw'} display={'flex'}>
              <TextField
                autoComplete='off'
                size='small'
                sx={{ width: '20vw', mr: '1vw' }}
                value={this.state.searchOpDraftList}
                onChange={(e) => this.setState({ searchOpDraftList: e.target.value }, () => {
                  let dupOpDraftList = JSON.parse(this.state.dupOpDraftList)
                  if (this.state.searchOpDraftList !== '') {
                    const searchValue = this.state.searchOpDraftList?.toLowerCase();
                    dupOpDraftList = dupOpDraftList.filter((item) => {
                      return (
                        (item?.patient_name === '' ? '' : item?.patient_data?.patient_name?.toLowerCase()?.includes(searchValue)) ||
                        (item?.patient_mobile_number === '' ? '' : item?.patient_data?.patient_mobile_number?.toLowerCase()?.includes(searchValue)) ||
                        (item?.patient_account_number === '' ? '' : item?.patient_data?.patient_account_number?.toLowerCase()?.includes(searchValue)) ||
                        (item?.op_number === '' ? '' : item?.patient_data?.op_number?.toLowerCase()?.includes(searchValue)) ||
                        (item?.temp_invoice_number === '' ? '' : item?.patient_data?.temp_invoice_number?.toLowerCase()?.includes(searchValue))
                      )
                    })
                    this.setState({ opDraftList: dupOpDraftList })
                  } else {
                    this.setState({ opDraftList: dupOpDraftList })
                  }
                })}
                label={'Search Patient Name'}
                onKeyDown={(e) => { e.stopPropagation() }}
              />
            </Box>
            <Box component={'div'} height={'30dvw'} mt={'0.5rem'}>
              <DataGrid
                rows={this.state.opDraftList}
                columns={columns}
                getRowId={(row) => row.sno}
                pageSizeOptions={[10, 20, 30]}
                pagination
                paginationMode="client"
                paginationModel={{
                  page: this.state.opDraftPage,
                  pageSize: this.state.opDraftPageSize
                }}
                onPaginationModelChange={(model) => {
                  this.setState({
                    opDraftPage: model.page,
                    opDraftPageSize: model.pageSize
                  })
                }}
                loading={this.state.opDraftLoad}
                localeText={{
                  toolbarColumns: "",
                  toolbarDensity: "",
                  toolbarExport: "",
                  toolbarFilters: "",
                  toolbarExportPrint: ""
                }}
                components={{
                  NoRowsOverlay: () => (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                      {("No Records To Be Shown")}
                    </Box>
                  )
                }}
                headerHeight={40}
              />
            </Box>
          </Box>
        </Dialog>
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  renderRefundRequestPopup = () => {
    if (!this.state.isIPTrans) return null;
    const handleClose = () => {
      this.setState({
        isIPTrans: false,
        ipTransAnchor: null,
        labTransDatePickerOpen: false,
        labIpTransDate: new Date()
      })
    }

    const handleRefund = (patient) => {
      const { module_name } = this.state.loggedInuserInfo || {};
      const redirectPath = patient?.bill_module === "RT" ? "/HospitalBilling/CashCounter" : cashmodulePaths[module_name];
      this.setState(({ isIPTrans: false, ipTransAnchor: null }),
        () => {
          this.props.history.push({
            pathname: redirectPath,
            state: {
              patient_details: { ...patient, patient_account_number: patient?.uhid },
              from_refund_request: true,
              refund_details: patient,
              fromRTRefund: patient?.bill_module === "RT"
            }
          });
        });
    };

    try {
      return (
        <Menu
          elevation={1}
          anchorEl={this.state.ipTransAnchor}
          open={this.state.isIPTrans}
          sx={{ mt: '3vw' }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
        >
          <Box component={'div'} width={'67vw'} maxHeight={'28vw'} overflow={'auto'} p={'0vw 0.5vw'}>
            <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
              <Typography fontWeight={600}>Refund Request</Typography>
              <Button className='Common_Btn_Min_Width' onClick={() => handleClose()}>
                <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1vw'} width={'1vw'} />
              </Button>
            </Box>
            <Box component={'div'}>
              {this.state.ipTraLoad ?
                <Box component={'div'} pb={'0.5vw'} borderBottom={'1.5px solid lightgray'} mb={'0.5vw'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                  <CircularProgress size='small' color='primary' />
                </Box> :
                <Box sx={{ width: "65dvw" }}>
                  <TableContainer sx={{ margin: "auto", mt: '1dvh' }}>
                    <Table size='small'>
                      <TableHead>
                        <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                          <TableCell>Patient Details</TableCell>
                          <TableCell>OP/IP Number</TableCell>
                          <TableCell>Bill Details</TableCell>
                          <TableCell>Amount</TableCell>
                          <TableCell>Type</TableCell>
                          <TableCell>Cancel Remarks</TableCell>
                          <TableCell>Action</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.CashCounterRefundRequestList?.map((patient) => (
                          <TableRow key={patient.id}>
                            <TableCell><CommonPatientDetails data={patient} /></TableCell>
                            <TableCell>{patient?.walk_in_number ? patient?.walk_in_number : patient.op_number ? patient.op_number : patient.ip_numbers ? patient.ip_numbers : patient?.self_patient}</TableCell>
                            <TableCell><Typography variant="body2">{patient.invoice_number}</Typography>
                              {patient.invoice_date && <Typography variant="caption">
                                {formatDateAndTimeMeth2(patient.invoice_date)}</Typography>}
                            </TableCell>
                            <TableCell>{AmountFormat(patient.net_amount)}</TableCell>
                            <TableCell>{patient.request_type || "-"}</TableCell>
                            <TableCell>{patient.cancel_reason ? patient.cancel_reason?.length > 18 ?
                              <Tooltip placement='top' title={patient.cancel_reason} arrow>
                                <div>{patient.cancel_reason.slice(0, 18) + "..."}</div></Tooltip> :
                              patient.cancel_reason : "-"}</TableCell>
                            <TableCell>
                              <Tooltip title={"Process Refund"} arrow placement="top">
                                <IconButton color="primary" onClick={() => { handleRefund(patient) }}>
                                  <ReceiptIcon />
                                </IconButton>
                              </Tooltip>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>}
            </Box>
          </Box>
        </Menu>
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  isSearchClear = (flag) => {
    const { history } = this.props;
    if (flag) {
      this.setState({
        searchkey: ""
      }, () => {
        history.push({ pathname: "/MainHome", state: { search_key: "" } })
      })
    }
  }

  printIPAppList(fromDocModule = false) {
    try {
      const fromDate = getCachevalue('FormDate')
      const toDate = getCachevalue('ToDate')
      const status = getCachevalue('Status')
      const ward_name = getCachevalue('wardName')
      const block_name = getCachevalue('blockName')
      const floor_number = getCachevalue('floorNumber')
      let DoctorId = this.state.SelectedDoctor === 0 ? "" : this.state.SelectedDoctor
      const clinic_id = JSON.parse(localGetItem('SelectedDoctorClinicId'));
      this.setState({ disableBtn: true })
      let url = `${Serviceurls.IP_APP_PRINT}?from_date=${fromDate}&to_date=${toDate}&doctor_id=${DoctorId}&admission_status=${status}`;
      if (fromDocModule) {
        url = `${url}&clinic_id=${clinic_id}&ward_name=${ward_name || ""}&block_name=${block_name || ""}&floor_number=${floor_number || ""}`
      }
      RestAPIService.getAll(url).
        then((response) => {
          if (response) {
            //Create a Blob from the PDF Stream
            const file = new Blob(
              [response.data],
              { type: 'application/pdf' });
            //Build a URL from the file
            const fileURL = URL.createObjectURL(file);
            //Open the URL on new Window
            window.open(fileURL);
            this.setState({ disableBtn: false })
          }
        }).catch((error) => {
          this.errorMessage(error?.response?.data?.message || error.message)
          this.setState({ disableBtn: false })
        })
    } catch (e) {
      this.setState({ disableBtn: false })
    }
  }

  render() {
    const { t } = this.props;
    const { history } = this.props;
    var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
    var UserData = myUser
    let ModuleData = localGetItem("ModulesList") ? JSON.parse(localGetItem("ModulesList")) : []
    let DisableSwitchModule = (ModuleData?.length === 1 && ModuleData[0]?.data?.length === 1) ? true : false
    const menuList = this.returnSideMenus();
    const path = window.location.pathname;
    const module_name = UserData?.module_name;
    const investigation_name = GetInvestigationName();
    const notifyPath = new Set(["/MainHome", "/Results",
      "/MainHome/TestReport", '/MainHome/ForTechnicians',
      '/MainHome/OutsourceList', "/MainHome/Order/CreateOrder"]);
    const notRadiologyBilling = !getCachevalue("isInRadiologyBilling");
    let noReturn = JSON.parse(localGetItem("pharmacy_rtn_period"))



    if (localGetItem("isLoggedIn")) {
      return (
        <div>
          <Box className='eMed_muiDrawer' >
            <CssBaseline />
            <AppBar sx={{ minHeight: '4.1vw' }} position="fixed" open={this.state.drawer_Open}>
              <Toolbar>
                {((module_name === "front_office" || module_name === "nurse") && ((path === "/OPHome") || (path === "/IPHome"))) ? this.FOheaderSearch() : null}
                {((module_name === 'Doctor' || UserData?.clinic_staff) && ((path === "/DoctorHome"))) || (UserData?.clinic_staff && path === "/IPDoctorHome") ? this.DoctorHeaderSearch() : null}
                {(module_name === "Laboratory") && path === "/MainHome" ? this.LabHeaderSearch() : null}
                {((module_name === 'Radiology' || module_name === 'Investigation') && ((path === `/${GetInvestigationName()}Home`))) ? this.RadiologyHeaderSearch() : null}
                {(module_name === "Pharmacy" && ((path === "/PharmacyBilling"))) ? this.PharmaheaderSearch() : null}

                <div className='eMed_headContent'></div>
                <div className='savedBillFieldHeader'>
                  {((notifyPath?.has(path) && !(path === "/Dashboard") &&
                    !(path === "/LabBilling/NewQuickBilling") && (this.state.loginType === 'Laboratory')) ||
                    ((path === "/OPHome") && module_name !== "nurse") ||
                    ((new Set(["/IPHome", `/${investigation_name}Home`, "/PharmacyBilling"])?.has(path))
                      && localGetItem('set_due_date_for_credit_billing') === "true")) ?
                    renderBadge(t('Notification'), t('Notification'), this.state.notifyCount,
                      ImagePaths.Notification.default,
                      () => {
                        this.getNotificationData();
                        this.setState({ notifyPopup: true })
                      })
                    : null}
                  {
                    (path === "/OPHome") && module_name !== "nurse" ?
                      <div style={{ display: 'flex', flexDirection: 'row' }}>
                        {this.state.loggedInuserInfo?.is_qms_enabled ?
                          <Box display={'flex'}>
                            {renderBadge(t('Queue'), t('Doctor Queue'),
                              this.state.drQueueData?.length,
                              ImagePaths.DocCallOnIcon.default,
                              () => { this.setState({ DocQueuePopup: true }) })}
                          </Box>
                          : null}

                        {renderBadge(t('Request'), t('AppReq'),
                          this.state.FoRequestList?.length,
                          ImagePaths.RequestsIcon.default,
                          (e) => {
                            let POVList = localGetItem("PurposeOfVisit") ? localGetItem("PurposeOfVisit") : '[]'
                            let array = []
                            JSON.parse(POVList)?.forEach(element => array.push(element.reason));
                            this.setState({
                              RequestPopUp: true,
                              RequestAnchor: e.currentTarget,
                              POVList: array
                            }, () => {
                              this.getAppointRequests(true)
                            })
                          })}
                      </div> : null
                  }
                  {
                    // Uma = 204 , masonic = 173
                    (path === "/OPHome" && this.state.loggedInuserInfo?.show_qr_entry) ?
                      <div style={{ display: 'flex', flexDirection: 'row' }}>
                        {
                          renderBadge(t('QR Entry'),
                            t('QR Entry'),
                            this.state.QrEntryList.length,
                            ImagePaths.QRIcon.default,
                            (e) => {
                              this.setState({ QREntryPopUp: true, RequestAnchor: e.currentTarget }, () => {
                                this.getQREntryList()
                              })
                            }
                          )
                        }
                      </div> : null
                  }
                  {(path === "/DoctorHome") && module_name == "Doctor" ?
                    <div style={{ display: 'flex', flexDirection: 'row', columnGap: "0.6vw" }}>
                      {
                        renderBadge(t('Unlocked Notes'), t('Unlocked Notes'),
                          this.state.unlockDocDataCount, ImagePaths.LockBtn.default,
                          () => { this.setState({ unlockNotespopup: true }) }
                        )
                      }
                      {
                        renderBadge(t('Transfer Request'), t('Transfer Request'),
                          this.state.transferReqData?.length, ImagePaths.TransAppoint.default,
                          () => { this.setState({ TransAppoint: true }) }
                        )
                      }
                    </div>
                    : null}
                  {/* Doctor Print and Appointment Request Starts ========> */}
                  {
                    (path === "/DoctorHome") && module_name !== "nurse" && !UserData?.clinic_staff ?
                      <div style={{ display: 'flex', flexDirection: 'row', columnGap: "0.6vw" }}>
                        {renderBadge(t('Request'), t('AppReq'),
                          this.state.doctorAppointmentData?.length, ImagePaths.RequestsIcon.default,
                          (e) => {
                            let POVList = localGetItem("PurposeOfVisit") ? localGetItem("PurposeOfVisit") : '[]'
                            let array = []
                            JSON.parse(POVList)?.forEach(element => array.push(element.reason));
                            this.setState({
                              openDoctorAppointment: true,
                              doctorAppointmentAnchor: e.currentTarget,
                              POVList: array
                            })
                          }
                        )}
                        {renderBadge(t('Print'), t('Print'), 0, ImagePaths.Print.default,
                          (e) => { this.setState({ openDoctorPrint: true, doctorAnchor: e.currentTarget }) }, false
                        )}
                      </div> : null
                  }
                  {((path === "/DoctorHome/DoctorNotes")) && module_name !== "nurse" ?
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      {renderBadge(t('Print'), t('Doctor Notes Print'), 0, ImagePaths.Print.default,
                        (e) => { this.setState({ openDoctorNotesPrint: true, openDoctorNotesPrintAnchor: e.currentTarget }) }, false
                      )}
                    </div> : null}
                  {((path === "/DoctorHome/DocImmunization")) ?
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      {renderBadge(t('Print'), t('Doctor Notes Print'), 0, ImagePaths.Print.default,
                        (e) => { this.printImmunizationData() }, false
                      )}
                    </div> : null}
                  {((path === "/DoctorHome/History/MedicalHistory")) && module_name !== "nurse" ?
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      {renderBadge(t('Print'), t('History Print'), 0, ImagePaths.Print.default,
                        (e) => { this.printDoctorHistoryData() }, false
                      )}
                    </div> : null}
                  {/* New Lab Order,draft  */}
                  {
                    ((new Set(["/MainHome", "/LabBilling", "/LabBilling/HospitalBilling"])?.has(path) && (this.state.loginType === 'Laboratory')) ||
                      (new Set([`/${investigation_name}Home`, `/Billing/${investigation_name}Billing`])?.has(path) && module_name !== "nurse" && notRadiologyBilling) ||
                      (path === `/${investigation_name}Billing` && notRadiologyBilling || path === `/${investigation_name}Billing/HospitalBilling`) ||
                      (new Set(['/HospitalBilling', '/HospitalBilling/HospitalBilling'])?.has(path))
                    ) ?
                      <>
                        <div hidden={getCachevalue('FromOtherScreen') === 'true' ? true : false}>
                          {renderBadge('OP List', 'OP List', this.state.badgeCount?.op_list_count, ImagePaths.RequestsIcon.default,
                            (e) => { this.setState({ isOpList: true, isOpListAnchor: e.currentTarget }) }
                          )}
                          {this.renderOpListPopup()}
                        </div>
                        <div hidden={getCachevalue('FromOtherScreen') === 'true' ? true : false}>
                          {renderBadge('Draft', 'Draft', this.state.badgeCount?.op_draft_list_count, ImagePaths.PharmacyIPReturn.default,
                            (e) => {
                              this.setState({ isOpDraft: true, isOpDraftAnchor: e.currentTarget },
                                () => this.getDraftBillData())
                            }
                          )}
                          {this.renderOPDraftPopup()}
                        </div>
                      </> : null}
                  {/* common cash counter icons */}
                  {cashCounterRoute?.has(path) ?
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      {renderBadge('OP List', 'Appointments', this.state.opListData?.length, ImagePaths.RequestsIcon.default,
                        (e) => { this.setState({ isOpList: true, isOpListAnchor: e.currentTarget }) }
                      )}
                      {new Set(["front_office", 'Pharmacy'])?.has(UserData?.module_name) ?
                        renderBadge('IP List', 'IP List', this.state.badgeCount?.ip_list_count, ImagePaths.Ip_list.default,
                          (e) => { this.setState({ cash_IpList: true }) }
                        )
                        : null}
                      {(UserData?.module_name === "front_office" && UserData?.enable_radiotherapy) ?
                        renderBadge('Walkin', 'RT Walkin', JSON.parse(this.state.dupwalkInAppointData || "[]")?.length, ImagePaths.RequestsIcon.default,
                          (e) => { this.setState({ rtWalkinOpen: true, isOpListAnchor: e.currentTarget }) }
                        ) : null}
                      {this.renderOpListPopup(true)}
                      <div>
                        {renderBadge('Refund Request', 'Refund Request', this.state.CashCounterRefundRequestList?.length, ImagePaths.PharmacyIPReturn.default,
                          (e) => { this.setState({ isIPTrans: true, ipTransAnchor: e.currentTarget }) }
                        )}
                        {this.renderRefundRequestPopup()}
                      </div>
                    </div> : null}
                  {/* common approvals  */}
                  {/* Pharmacy headers */}
                  {path === "/PharmacyBilling" && UserData?.module_name !== "nurse" ?
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      {renderBadge('Indent Request', 'Indent Request',
                        this.state.indent_Count?.total || 0,
                        ImagePaths.indentApprove.default,
                        () => { this.props.history.push('/PharmacyStockTransfer') }
                      )}
                      {UserData?.pharmacy_type === 'Inhouse Pharmacy' ?
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                          {/* {renderBadge(t('IP Returns'), 'In Patients Returns',
                            this.state.badgeCount?.pharmacy_IP_return_count || 0,
                            ImagePaths.PharmacyIPReturn.default,
                            () => {
                              if (noReturn?.rtn_type === 'No Return') { this.errorMessage("Return is Not Allowed") }
                              else { this.setState({ ph_returns: true }) }
                            }
                          )}
                          {renderBadge(t('IP Request'), 'In Patients Request',
                            this.state.badgeCount?.pha_ip_request_count || 0,
                            ImagePaths.PharmacyIPRequest.default,
                            () => { this.setState({ ph_request: true }) }
                          )}*/}
                          {renderBadge(t('Appointments'), 'Appointments',
                            this.state.badgeCount?.pharmacy_appointment_count || 0,
                            ImagePaths.PharmacyApp.default,
                            () => { this.setState({ ph_Appointments: true }) }
                          )}
                        </div>
                        : null}
                      {renderBadge(t('Saved Bills'), 'Saved Bills',
                        this.state.badgeCount?.pharmacy_bill_count || 0,
                        ImagePaths.PharmacySaveBill.default,
                        () => { this.setState({ ph_SavedBill: true }) }
                      )}
                      <div>
                        {renderBadge(t('Prescription'), 'Prescription',
                          this.state.badgeCount?.pha_prescription_count || 0,
                          ImagePaths.Pharmacypres.default,
                          () => { this.setState({ ph_Prescrition: true }) }
                        )}
                      </div>
                      <div>
                        {renderBadge(t('IP Request'), 'IP Request',
                          this.state.badgeCount?.pharmacy_ip_request_count || 0,
                          ImagePaths.PharmacyIPRequest.default,
                          () => { this.setState({ ph_request: true }) }
                        )}
                        </div>
                        <div>
                        {renderBadge(t('IP List'), 'IP Admission List',
                          this.state.badgeCount?.pha_inpatient_count || 0,
                          ImagePaths.Ip_list.default,
                          () => { this.setState({ ph_IpPatientList: true }) }
                        )}
                      </div>
                    </div> : null}
                  {
                    path === "/SubLocationBilling" ?
                      <div style={{ marginRight: "1vw", display: 'flex', flexDirection: 'row' }}>
                        {renderBadge(t('Indent Request'), 'Indent Request', this.state.indent_Count?.total || 0, ImagePaths.indentApprove.default,
                          () => { this.props.history.push('/SubLocationStockTransfer') }
                        )}
                        {renderBadge(t('Saved Bills'), t('Saved Bills'), this.state.badgeCount?.pharmacy_bill_count || 0, ImagePaths.PharmacySaveBill.default,
                          () => { this.setState({ ph_SavedBill: true }) }
                        )}
                      </div> : null
                  }
                  {!(window.location.href.includes("/Dashboard")) && this.state.loggedInuserInfo?.is_checker ?
                    <div hidden={getCachevalue('FromOtherScreen') === 'true' ? true : false}>
                      {renderBadge('Approvals', 'Approvals', this.state.badgeCount?.approver_list_count, ImagePaths.ApproverIcon.default,
                        (e) => { this.setState({ openApproverList: true }) }
                      )}
                      <ApproverListPopup
                        module_name={module_name}
                        modulePaths={modulePaths}
                        history={this.props.history}
                        openApproverList={this.state.openApproverList}
                        approverLoad={this.state.approverLoad}
                        onClose={() => {
                          this.setState({
                            openApproverList: false
                          })
                        }}
                        getApproverListData={(date, searchKey) => { this.getApproverListData(date, searchKey) }}
                        errorMessage={(msg) => this.errorMessage(msg)}
                      />
                    </div> : null}

                  {path === "/IPHome" && renderBadge('IP Request', 'IP Request',
                    this.state.badgeCount?.op_to_ip_list_count || 0, ImagePaths.opRequestIcon.default,
                    (e) => { this.setState({ oPRequestPopUp: true }) }
                  )}
                  {((path === "/IPHome") || path === "/IPDoctorHome") && UserData?.module_name !== "nurse" &&
                    renderBadge('Print', path === "/OPHome" ? t('AppPrint') : t('IPAppPrint'),
                      this.state.badgeCount?.op_to_ip_list_count || 0, ImagePaths.Print.default,
                      () => { this.printIPAppList(path === "/IPDoctorHome") }
                    )}
                </div>
                {/* Print Menu */}
                <Menu
                  anchorEl={this.state.doctorAnchor}
                  sx={{ position: 'absoulte', top: '2.5vw', left: '0.7vw' }}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'bottom',
                  }}
                  transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'bottom',
                  }}
                  open={this.state.openDoctorPrint}
                  onClose={() => {
                    this.setState({ openDoctorPrint: false })
                  }}
                >
                  <Box component={'div'} p={'1vw'}>
                    <FormGroup>
                      <FormControlLabel control={<Checkbox checked={this.state.all} onChange={(e) => { this.handleCheckBox(e, "all") }} />} label="All" />
                      <FormControlLabel control={<Checkbox checked={this.state.booked} onChange={(e) => { this.handleCheckBox(e, "booked") }} />} label="Booked" />
                      <FormControlLabel control={<Checkbox checked={this.state.arrived} onChange={(e) => { this.handleCheckBox(e, "arrived") }} />} label="Arrived" />
                      <FormControlLabel control={<Checkbox checked={this.state.withNurse} onChange={(e) => { this.handleCheckBox(e, "withNurse") }} />} label="With Nurse" />
                      <FormControlLabel control={<Checkbox checked={this.state.withDoctor} onChange={(e) => { this.handleCheckBox(e, "withDoctor") }} />} label="With Doctor" />
                      <FormControlLabel control={<Checkbox checked={this.state.completed} onChange={(e) => { this.handleCheckBox(e, "completed") }} />} label="Completed" />
                      <FormControlLabel control={<Checkbox checked={this.state.cancelled} onChange={(e) => { this.handleCheckBox(e, "cancelled") }} />} label="Cancelled" />
                    </FormGroup>
                    <Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                      <Button
                        sx={{ height: '2vw', width: '5vw', mr: '1vw', textTransform: 'capitalize' }}
                        variant='contained'
                        onClick={() => {
                          if (window.location.pathname === "/DoctorHome") {
                            this.postDoctorPrint()
                          }
                        }
                        }
                      >
                        Print
                      </Button>
                      <Button
                        variant='outlined'
                        sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize' }}
                        onClick={() => this.setState({ doctorAnchor: null, openDoctorPrint: false })}
                      >
                        cancel
                      </Button>
                    </Box>
                  </Box>
                </Menu>
                {this.doctorAppointmentRequest()}
                <Menu
                  anchorEl={this.state.openDoctorNotesPrintAnchor}
                  sx={{ position: 'absolute', top: '2.5vw', left: '0.7vw' }}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'bottom',
                  }}
                  transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'bottom',
                  }}
                  open={this.state.openDoctorNotesPrint}
                  onClose={() => {
                    this.setState({ openDoctorNotesPrint: false })
                  }}
                >
                  <Box component={'div'} p={'1vw'} maxHeight={'30vw'} overflow={'auto'} maxWidth={'20vw'}>
                    {this.state.doctorPrintList?.other_doctor?.map((item, index) => {
                      return (
                        <FormGroup>
                          <FormControlLabel key={index} control={<Checkbox checked={item?.is_checked} onChange={(e) => { this.handleNewCheckBoxHandler(e, index) }} />}
                            label={<span style={{
                              wordBreak: "break-all",
                              overflowWrap: "break-word",
                              whiteSpace: "normal",
                              display: "block",
                              maxWidth: "100%",
                            }}>
                              {item?.label}
                            </span>} />
                        </FormGroup>
                      )
                    })
                    }
                  </Box>

                  <Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                    <Button
                      sx={{ height: '2vw', width: '5vw', mr: '1vw', textTransform: 'capitalize' }}
                      variant='contained'
                      onClick={() => this.getDoctorNotesPrint()}
                    >
                      Print
                    </Button>
                    <Button
                      sx={{ height: '2vw', width: '5vw', mr: '1vw', textTransform: 'capitalize' }}
                      variant='contained'
                      onClick={() => this.onClickDoctorNotesDefault()}
                    >
                      Default
                    </Button>
                    <Button
                      variant='outlined'
                      sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize' }}
                      onClick={() => this.setState({ openDoctorNotesPrintAnchor: null, openDoctorNotesPrint: false, doctorPrintList: JSON.parse(this.state.dupDocPrintList) })}
                    >
                      cancel
                    </Button>
                  </Box>
                </Menu>
                {/* Doctor Print and Appointment Menu Ends */}
                {this.renderTransferListPopup()}
                <Dialog
                  className="emed_DialogboxOrder"
                  open={this.state.unlockNotespopup}
                  onClose={() => { this.setState({ unlockNotespopup: false }) }}
                  maxWidth={"md"}
                >
                  <div className='emed_Dialog_Appoin' style={{ width: '38vw' }}>
                    {this.unlockNotesTable()}
                  </div>
                </Dialog>
                <div className='fieldHeaderfordoctor'>
                  {
                    <div className='eMed_profile'>
                      <div className='eMed_user'>
                        <label className='eMed_loginuser'>{window.location.pathname === "/Dashboard" ? localGetItem("LogedUserName") : this.state.loginName}</label>
                      </div>
                      {window.location.pathname !== "/Dashboard" &&
                        <div className='eMed_servicetype'>
                          <label className='eMed_LoginType'>{loginTypeMap[this.state.loginType] || this.state.loginType}</label>
                        </div>}
                    </div>}
                  <div className='eMed_Avatar'>
                    <Box >
                      <Tooltip title="Profile" arrow>
                        <IconButton disabled={(getCachevalue("isForCancelBill") === "true" || getCachevalue("IsForCheckedOut") === "true" || getCachevalue("isInRadiologyBilling") === "true")} onClick={(e) => { this.setState({ anchorElUser: true, anchorElUser: e.currentTarget }) }}>
                          <Avatar sx={{ bgcolor: Colors.IconCircleBgColor, boxShadow: 3, color: Colors.ThemeColor }} id="eMed_Icons_Avatar" />
                        </IconButton>
                      </Tooltip>
                      <Menu
                        id="eMed_profileMenu"
                        // anchorEl={this.state.anchorElUser}
                        anchorOrigin={{
                          vertical: 'top',
                          horizontal: 'right',
                        }}
                        keepMounted
                        transformOrigin={{
                          vertical: 'top',
                          horizontal: 'right',
                        }}
                        open={this.state.anchorElUser}
                        onClose={this.handleCloseUserMenu}
                        sx={{ marginRight: '5vw' }}
                        TransitionProps={{
                          timeout: 0
                        }}
                      >

                        <div className='eMed_AvatarMenu'>
                          {(this.state.loginType === 'Doctor' || DisableSwitchModule) ? null :
                            !(window.location.href.includes("/Dashboard")) ?
                              <MenuItem onClick={() => {
                                this.handleCloseUserMenu()
                                this.setState({
                                  loginName: "",
                                  loginType: '',
                                  clinicId: null,
                                  badgeCount: {},
                                  anchorElUser: false,
                                  PatientNameSearchKey: '',
                                  pharmaNameSearchKey: '',
                                  searchkey: '',
                                }, () => {
                                  this.WebSocketDisconnect()
                                  localClearItem("AccessToken")
                                  localClearItem("loggedInUserInfo")
                                  localClearItem("clinicId")
                                  localClearItem("DoctorsList")
                                  clearCachevalue("isCanteenOverall")
                                  clearCachevalue("IsPORequestEdit")
                                  clearCachevalue('Laboratory_id')
                                  clearCachevalue('subInbound')
                                  clearCachevalue('subOutbound')
                                  clearCachevalue('branchInbound')
                                  clearCachevalue('branchOutbound')
                                  clearCachevalue('subTotal')
                                  clearCachevalue('branchTotal')
                                  clearCachevalue('LabStatusDateFilter')
                                  clearCachevalue('LabCancelledDateFilter')
                                  clearCachevalue('LabStatusDateCustumFilter')
                                  clearCachevalue('LabTstReportDateFilter')
                                  clearCachevalue('LabForTechDateFilter')
                                  clearCachevalue('SelectedOPDate')
                                  clearCachevalue('SelectedDate')
                                  clearCachevalue('OP_CreateAppointment_PatientId')
                                  clearCachevalue('BillType')
                                  clearCachevalue('FromOtherScreen')
                                  clearCachevalue('Status')
                                  clearCachevalue('FormDate')
                                  clearCachevalue('ToDate')
                                  localClearItem('is_investigation_module')
                                  localClearItem('investigation_name')
                                  history.push('/Dashboard');
                                  this.setState({
                                    selectedMenuId: null,
                                    selectedPageName: "",
                                    FoNotifyList: {},
                                    notifyCount: 0,
                                  })
                                })
                              }}>
                                <GridViewIcon sx={{ color: Colors.ThemeColor, marginRight: '0.5vw' }} />
                                {t('SwitchModule')}
                              </MenuItem>
                              : null
                          }
                          {(this.state.loginType === 'Doctor' && myUser?.is_qms_enabled) ?
                            <MenuItem onClick={() => {
                              this.setState({
                                anchorElUser: false,
                              }, () => {
                                history.push('/ViewDoctorProfile')
                              })
                            }}>
                              <AccountBoxIcon sx={{ color: Colors.ThemeColor, marginRight: '0.5vw' }} />
                              {`${t('View Profile')}`}
                            </MenuItem> : null}
                          <MenuItem onClick={() => { this.WebSocketDisconnect(); this.handleCloseUserMenu(); this.logout(); history.push('/'); }}>
                            <ExitToAppIcon sx={{ color: Colors.ThemeColor, marginRight: '0.5vw' }} />
                            {`${t('Logout')} / ${localGetItem("LogedUserName")}`}
                          </MenuItem>
                        </div>

                      </Menu>
                    </Box>
                  </div>
                </div>
                {this.state.labHistoryPopup && (<LabHistoryPopup
                  openPopup={this.state.labHistoryPopup}
                  labHistoryData={this.state.labHistoryData || []}
                  labPatientData={this.state.labPatientData}
                  onClose={() => {
                    this.setState({
                      labHistoryPopup: false,
                      labPatientData: null,
                    })
                  }}
                  errorMessage={(msg) => { this.errorMessage(msg) }}
                />)}
                {this.state.ph_SavedBill && <PharmacySavedBills
                  properties={this.props}
                  open={this.state.ph_SavedBill}
                  onClose={this.savedBillClose}
                  isFromSubLocation={this.state.loginType === "sub_location"}
                  getPharmaSavedBillCount={this.getListCount}
                  onClickSavedBillClose={this.onClickSavedBillClose} />}

                {this.state.ph_returns &&
                  <IPReturns properties={this.props}
                    open={this.state.ph_returns}
                    onClose={() => { this.setState({ ph_returns: false }) }}
                    onClickreturnClose={(flag) => { this.setState({ ph_returns: flag }) }} />}

                {this.state.ph_request &&
                  <IPRequest properties={this.props}
                    open={this.state.ph_request}
                    onClose={() => { this.setState({ ph_request: false }) }}
                    onClickrequestClose={(flag) => { this.setState({ ph_request: flag }) }}
                    recallKey={this.state.loggedInuserInfo?.allow_ip_request_cancel_in_pharmacy} />}

                {this.state.ph_IpPatientList &&
                  <Appointments
                    properties={this.props}
                    open={this.state.ph_IpPatientList}
                    onClose={() => { this.setState({ ph_IpPatientList: false }) }}
                    onClickAppointClose={(flag) => { this.setState({ ph_IpPatientList: flag }) }}
                    isFromIpAdmission={true}
                    />
                }

                {this.state.ph_Prescrition &&
                  <Prescription
                    properties={this.props}
                    open={this.state.ph_Prescrition}
                    onClose={() => { this.setState({ ph_Prescrition: false, DocQueuePopup: false }) }}
                    getPharmaPrescriptionCount={this.getListCount}
                    onClickPrescriptionClose={(flag) => { this.setState({ ph_Prescrition: flag }) }} />}

                {this.state.ph_Appointments && <Appointments
                  open={this.state.ph_Appointments}
                  onClose={() => { this.setState({ ph_Appointments: false }) }}
                  properties={this.props}
                  onClickAppointClose={(flag) => { this.setState({ ph_Appointments: flag }) }}
                  isFromPharmaApp={true}
                  FromcashCounter={(path === "/HospitalBilling/CashCounter" ||
                    path === "/LabBilling/CashCounter" ||
                    path === `/${GetInvestigationName()}Billing/CashCounter`)}
                  /> 
                  }

                <Dialog
                  className="emed_DialogboxOrder"
                  open={this.state.oPRequestPopUp}
                  onClose={() => { this.setState({ oPRequestPopUp: false }) }}
                  maxWidth={"md"}
                >
                  <div className='emed_Dialog_Appoin' style={{ width: '45vw', height: "35vw" }}>
                    <OpToIpPopup properties={this.props}
                      countList={this.getListCount}
                      onClkClose={(flag) => { this.setState({ oPRequestPopUp: flag }) }} />
                  </div>
                </Dialog>
                  <Dialog
                  className="emed_DialogboxOrder"
                  open={this.state.cash_IpList}
                  onClose={() => { this.setState({ cash_IpList: false }) }}
                  maxWidth={"md"}
                >
                  <div className='emed_Dialog_Appoin' style={{ width: '38vw' }}>
                    <CashCounterIPList properties={this.props} onClickIPListClose={(flag) => { this.setState({ cash_IpList: flag }) }} IPListLabCount={this.getListCount} />
                  </div>
                </Dialog>

              </Toolbar>
            </AppBar>
            {!(window.location.href.includes("/Dashboard")) ?
              <List id="eMed_side_list">

                {menuList.map((item, index) => {
                  let DisplayLabel = item.label.split(" ")
                  return (
                    <React.Fragment key={index}>
                      <ListItem
                        disabled={(getCachevalue("isForCancelBill") === "true") || (getCachevalue("isForVisitreport") === "true") || (getCachevalue("IsForCheckedOut") === "true") || (getCachevalue("IsPORequestEdit") === "true") || (getCachevalue("isCanteenOverall") === "true") || (getCachevalue("isInRadiologyBilling") === "true")}  // disable all sidemenu during from cancel bill
                        className='eMed_menuItems'
                        sx={{
                          maxWidth: '3.3vw',
                          marginBottom: '1.5vh',
                          alignItems: 'center',
                          display: 'flex',
                          justifyContent: 'center',
                          padding: 0
                        }}
                        // button 
                        key={item.menuName}
                        checked={this.state.checked}
                        onClick={() => {
                          if (!(getCachevalue("isForCancelBill") === "true") && !(getCachevalue("IsForCheckedOut") === "true") && !(getCachevalue("IsPORequestEdit") === "true") && !(getCachevalue("isCanteenOverall") === "true") && !(getCachevalue("isInRadiologyBilling") === "true")) {
                            this.setState({
                              selectedMenuId: item.id,
                              selectedSubMenuId: null,
                              selectedPageName: item.menuName,
                              searchkey: "",
                              configSearch: '',
                              inventorySearch: "",
                              reportSearch: "",
                              purchaseSearch: '',
                              clinic_name: null,
                              PatientNameSearchKey: "",
                              PatientAddressKey: "",
                              PatientFathHusKey: "",
                              badgeCount: {},
                              PatientMotherKey: "",
                              pharmaNameSearchKey: "",
                              FilterIP: "",
                              FilterOP: "",
                            }, () => {
                              this.onClick(this.props.history.push(`/${item.menuName.replace(/\s/g, '')}`),)
                              this.clearCacheData(item?.menuName)
                            })
                          }
                        }}>
                        <Tooltip placement='right' title={t(item.label)} disableInteractive arrow>
                          <Badge color="error" badgeContent={(item.menuName === 'Pharmacy Stock Transfer' || item.menuName === 'SubLocation Stock Transfer' || item.menuName === 'OT Stock Transfer') ? (this.state.indent_Count?.total ? this.state.indent_Count?.total : 0) : 0} showZero={false}>
                            <ListItemIcon emed_tid={`${'ph_' + item.label}`} className='eMed_menuIcon' sx={{ display: 'flex', flexDirection: 'column', padding: 0, alignItems: 'center' }}>
                              <Avatar
                                src={
                                  ((window?.location?.pathname?.split("/")[1] === item?.menuName?.replace(/\s/g, '')) || (item?.menuName === "MainHome" && window?.location?.pathname === "/Results")) ? item?.OnIcon?.default : item?.OffIcon?.default
                                }
                                sx={((window?.location?.pathname.split("/")[1] === item.menuName.replace(/\s/g, '')) || (item?.menuName === "MainHome" && window?.location?.pathname === "/Results")) ? { width: '3vw', height: '3vw' } : { width: '2.5vw', height: '2.5vw' }}
                                variant="square"
                              />
                              {
                                DisplayLabel?.map((list) => (
                                  <Typography component={'p'} style={{ color: window?.location?.href?.toLowerCase()?.includes(item?.menuName?.replace(/\s/g, '')?.toLowerCase()) ? Colors?.themeDark : Colors?.disableLabelColor, whiteSpace: "pre-line", alignContent: "center", justifyContent: "center" }} variant="caption" sx={{ maxWidth: '3.3vw', fontSize: '0.6vw' }}>{list}</Typography>
                                ))
                              }
                            </ListItemIcon>
                          </Badge>
                        </Tooltip>
                      </ListItem>
                    </React.Fragment>
                  )
                })}
              </List> : null}
            <Box component="main" sx={{ flexGrow: 1, minWidth: '10vw', pl: '3vw', pr: '1vw' }} >
              <RouterComponent reportSearch={this.state.reportSearch} inventorySearch={this.state.inventorySearch}
                purchaseSearch={this.state.purchaseSearch} configSearch={this.state.configSearch}
                clearSearch={this.clearSearch} changeScreen={this.changeScreen}
                subScreenChange={this.subScreenChange} isSearchClear={this.isSearchClear}
                clinicId={this.state.clinicId} getSavedBillStatus={this.getListCount}
                getTransmitBillCount={this.getListCount} getRadTransmitCount={this.getRadTransmitBillCount}
                getIPListCount={this.getListCount} getPharmaSavedBillCount={this.getListCount}
                getPharmaPrescriptionCount={this.getListCount} changeDate={this.state.unlockDate}
                isGetCalled={this.isGetCalled} CallPatientTrigger={this.state.CallPatientTrigger}
                ClearCalledTrigger={this.ClearCalledTrigger} getcountNotification={this.getcountNotification}
                closeAlertPopup={this.closeAlertPopup} getbillingCount={this.getListCount}
                getRefundRefundCOunt={this.getRefundRefundCOunt} getListCount={this.getListCount}
                triggerNotifyCount={this.triggerNotifyCount} />
            </Box>
          </Box>
          <Box sx={{ height: '1vh', width: '100%', zIndex: 1200, position: 'fixed', borderTop: '1px solid lightgrey', backgroundColor: Colors.BgColor, }}></Box>
          <Box sx={{ height: '5vh', width: '100%', zIndex: 1200, position: 'fixed', backgroundColor: Colors.ThemeColor, alignItems: 'center', justifyContent: 'center', display: 'flex', flexDirection: 'row' }}>
            <Avatar
              src={ImagePaths.Logo}
              sx={{ width: '1vw', height: '1vw', marginRight: '0.25vw' }}
            />
            <Typography color={Colors.white} fontSize={'1vw'}>www.emedhub.in</Typography>
            <Typography sx={{ paddingLeft: 2, paddingRight: 5 }} color={Colors.white} fontSize={'1vw'}>{APP_Version_Label}</Typography>
            <Typography color={Colors.white} fontSize={'1vw'}>{APP_Support_Label}</Typography>
            {(UserData?.module_name === "front_office" || UserData?.module_name === "Pharmacy" || UserData?.module_name === "Laboratory") ? window.location.pathname === '/Dashboard' ? null :
              <IconButton color="primary" aria-label="add item" sx={{ marginLeft: 5, marginRight: '0.25vw' }}
                onClick={() => {
                  this.setState({
                    isHelpdeskClicked: true
                  })
                }}
              >
                <HelpOutline color="action" sx={{ width: '1.2vw', height: '1.2vw', marginLeft: '0.25vw' }} />
                <Typography color={Colors.white} fontSize={'1vw'}>Customer Support</Typography>
              </IconButton> : null}
            <Dialog
              className="emed_DialogboxOrder"
              open={this.state.DocQueuePopup}
              onClose={this.closeDrQueue}
              maxWidth={"md"}
            >
              <div className='emed_Dialog_Pres'>
                <DrQueuePopup data={this.state.drQueueData} date={this.state.datePicker} onClose={this.closeDrQueue} callPatient={this.callPatientSend.bind(this)} />
              </div>
            </Dialog>
            {
              this.state.isErrorMsg ?
                <ToastMsg
                  severity={'error'}
                  msg={this.state.isErrorMsgText}
                  msgPop={this.msgClose.bind(this)}
                />
                : this.state.isSuccessMsg ?
                  <ToastMsg
                    severity={'success'}
                    msg={this.state.isSuccessMsgText}
                    msgPop={this.msgClose.bind(this)}
                  /> : null
            }
            {this.AppointmentRequestPop()}
            <NotificationPopup
              FoNotifyList={this.state.FoNotifyList || []}
              isNotifyLoader={this.state.isNotifyLoader}
              notifyPopup={this.state.notifyPopup}
              onClose={() => { this.setState({ notifyPopup: false }) }}
            />
            {this.QREntryList()}
          </Box>
        </div>
      )
    } else {
      return (<RouterComponent />)
    }
  }
}
export default withRouter(withTranslation()(MiniDrawer));